export default {
  "pokemons": [
    {
      "id": 1,
      "avatar": require('./images/avatars/001.png'),
      "name": "Bulbasaur",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Seed Pokémon",
      "moves": [
        {
          "name": "Petal Dance",
          "type": "grass",
          "attack": "156",
          "wait": "5",
          "description": "The user spins in place, scattering petals that deal damage to enemies around it.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Toxic",
          "type": "poison",
          "attack": "59",
          "wait": "4",
          "description": "The user sprays a powerful poison around itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Vine Whip",
          "type": "grass",
          "attack": "237",
          "wait": "5",
          "description": "The user strikes enemies in front of itself with whiplike vines. Deals damage to enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Hit Healing +2%",
          "Healing from K.O. +2%",
          "Own Knockback Distance -10%"
        ],
        [
          "Healing per Wave +50%",
          "Resistant to Poisoned +100%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Grass Type Moves +20%",
          "HP +550",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "125",
      "baseAtk": "75",
      "sprite": require('./images/sprites/1.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          165,
          3300,
          3300
        ],
        "type": [
          0,
          400,
          8000,
          8000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 2,
      "avatar": require('./images/avatars/002.png'),
      "name": "Ivysaur",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Seed Pokémon",
      "evolution": "Evolve Bulbasaur (Lv. 16)",
      "moves": [
        {
          "name": "Leech Seed",
          "type": "grass",
          "attack": "103",
          "wait": "9",
          "description": "The user plants a seed on the ground in front of itself. Enemies in range are gradually damaged. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Petal Dance",
          "type": "grass",
          "attack": "156",
          "wait": "5",
          "description": "The user spins in place, scattering petals that deal damage to enemies around it.",
          "learnable": true
        },
        {
          "name": "Poison Powder",
          "type": "poison",
          "attack": "67",
          "wait": "4",
          "description": "The user scatters poison powder in front of itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Toxic",
          "type": "poison",
          "attack": "59",
          "wait": "4",
          "description": "The user sprays a powerful poison around itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Vine Whip",
          "type": "grass",
          "attack": "237",
          "wait": "5",
          "description": "The user strikes enemies in front of itself with whiplike vines. Deals damage to enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Hit Healing +2%",
          "Healing from K.O. +2%",
          "Own Knockback Distance -10%"
        ],
        [
          "Healing per Wave +40%",
          "Resistant to Poisoned +100%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Grass Type Moves +15%",
          "HP +250",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "400",
      "baseAtk": "100",
      "sprite": require('./images/sprites/2.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 3,
      "avatar": require('./images/avatars/003.png'),
      "name": "Venusaur",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Seed Pokémon",
      "evolution": "Evolve Ivysaur (Lv. 32)",
      "moves": [
        {
          "name": "Leech Seed",
          "type": "grass",
          "attack": "103",
          "wait": "9",
          "description": "The user plants a seed on the ground in front of itself. Enemies in range are gradually damaged. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Mega Drain",
          "type": "grass",
          "attack": "165",
          "wait": "9",
          "description": "The user attacks enemies in front of itself, dealing damage to them. Some of the damage dealt is absorbed by the user, restoring its HP.",
          "learnable": true
        },
        {
          "name": "Petal Dance",
          "type": "grass",
          "attack": "156",
          "wait": "5",
          "description": "The user spins in place, scattering petals that deal damage to enemies around it.",
          "learnable": true
        },
        {
          "name": "Solar Beam",
          "type": "grass",
          "attack": "227",
          "wait": "7",
          "description": "The user gathers light and unleashes it in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Toxic",
          "type": "poison",
          "attack": "59",
          "wait": "4",
          "description": "The user sprays a powerful poison around itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Vine Whip",
          "type": "grass",
          "attack": "237",
          "wait": "5",
          "description": "The user strikes enemies in front of itself with whiplike vines. Deals damage to enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Hit Healing +2%",
          "Healing from K.O. +2%",
          "Own Knockback Distance -10%"
        ],
        [
          "Ice Type Damage Taken -50%",
          "Resistant to Poisoned +100%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Grass Type Moves +10%",
          "Fire-Type Damage Taken -50%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "550",
      "baseAtk": "150",
      "sprite": require('./images/sprites/3.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 4,
      "avatar": require('./images/avatars/004.png'),
      "name": "Charmander",
      "type": [
        "fire"
      ],
      "classification": "Lizard Pokémon",
      "moves": [
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Fire Punch",
          "type": "fire",
          "attack": "229",
          "wait": "5",
          "description": "The user imbues its fist with the power of flames, and strikes enemies directly in front of it with a burning punch. Deals damage and sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Fire Spin",
          "type": "fire",
          "attack": "97",
          "wait": "5",
          "description": "The user creates flames all around itself and fires them off in a spiral. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Metal Claw",
          "type": "steel",
          "attack": "211",
          "wait": "5",
          "description": "The user rakes enemies in front of itself with its steel claws, dealing damage. Sometimes raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Moves Wait -5%",
          "Critical Hit Rate +5%",
          "Movement Speed +30%"
        ],
        [
          "ATK of Fire Type Moves +15%",
          "Critical Hit Rate +20%",
          "Resistant to Burned +100%"
        ],
        [
          "ATK of Fire Type Moves +20%",
          "ATK + 550",
          "Movement Speed +40%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "75",
      "baseAtk": "125",
      "sprite": require('./images/sprites/4.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          165,
          3300,
          3300
        ],
        "type": [
          0,
          400,
          8000,
          8000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 5,
      "avatar": require('./images/avatars/005.png'),
      "name": "Charmeleon",
      "type": [
        "fire"
      ],
      "classification": "Flame Pokémon",
      "evolution": "Evolve Charmander (Lv. 16)",
      "moves": [
        {
          "name": "Dragon Claw",
          "type": "dragon",
          "attack": "296",
          "wait": "5",
          "description": "The user gathers its strength, then charges forward while spinning, damaging enemies with its sharp claws.",
          "learnable": true
        },
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Fire Punch",
          "type": "fire",
          "attack": "229",
          "wait": "5",
          "description": "The user imbues its fist with the power of flames, and strikes enemies directly in front of it with a burning punch. Deals damage and sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Fire Spin",
          "type": "fire",
          "attack": "97",
          "wait": "5",
          "description": "The user creates flames all around itself and fires them off in a spiral. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Metal Claw",
          "type": "steel",
          "attack": "211",
          "wait": "5",
          "description": "The user rakes enemies in front of itself with its steel claws, dealing damage. Sometimes raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Moves Wait -5%",
          "Critical Hit Rate +5%",
          "Movement Speed +30%"
        ],
        [
          "ATK of Fire Type Moves +10%",
          "Critical Hit Rate +15%",
          "Resistant to Burned +100%"
        ],
        [
          "ATK of Fire Type Moves +15%",
          "ATK +250",
          "Movement Speed +40%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "400",
      "sprite": require('./images/sprites/5.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 6,
      "avatar": require('./images/avatars/006.png'),
      "name": "Charizard",
      "type": [
        "fire",
        "flying"
      ],
      "classification": "Flame Pokémon",
      "evolution": "Evolve Charmeleon (Lv. 36)",
      "moves": [
        {
          "name": "Dragon Claw",
          "type": "dragon",
          "attack": "296",
          "wait": "5",
          "description": "The user gathers its strength, then charges forward while spinning, damaging enemies with its sharp claws.",
          "learnable": true
        },
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Fire Blast",
          "type": "fire",
          "attack": "179",
          "wait": "5",
          "description": "The user sprays an all-consuming fire on the ground, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Fire Punch",
          "type": "fire",
          "attack": "229",
          "wait": "5",
          "description": "The user imbues its fist with the power of flames, and strikes enemies directly in front of it with a burning punch. Deals damage and sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Fire Spin",
          "type": "fire",
          "attack": "97",
          "wait": "5",
          "description": "The user creates flames all around itself and fires them off in a spiral. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flame Charge",
          "type": "fire",
          "attack": "0",
          "wait": "5",
          "description": "The user stores up the power of flames, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flare Blitz",
          "type": "fire",
          "attack": "128",
          "wait": "5",
          "description": "The user creates a path of flames in front of itself and charges forward along it. Deals damage to enemies. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Metal Claw",
          "type": "steel",
          "attack": "211",
          "wait": "5",
          "description": "The user rakes enemies in front of itself with its steel claws, dealing damage. Sometimes raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Moves Wait -5%",
          "Critical Hit Rate +5%",
          "Movement Speed +30%"
        ],
        [
          "Fire Type Moves Wait -5%",
          "Critical Hit Rate +10%",
          "Resistant to Burned +100%"
        ],
        [
          "ATK of Fire Type Moves +10%",
          "Critical Hit Rate +15%",
          "Movement Speed +40%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "200",
      "baseAtk": "600",
      "sprite": require('./images/sprites/6.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 7,
      "avatar": require('./images/avatars/007.png'),
      "name": "Squirtle",
      "type": [
        "water"
      ],
      "classification": "Tiny Turtle Pokémon",
      "moves": [
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        },
        {
          "name": "Withdraw",
          "type": "water",
          "attack": "0",
          "wait": "5",
          "description": "The user withdraws into its hard shell, reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Water Type Moves Wait -5%",
          "Natural HP Healing +10%"
        ],
        [
          "ATK of Water Type Moves +15%",
          "Water Type Moves Wait -20%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Water Type Moves 20%",
          "ATK +550",
          "HP +550"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "100",
      "sprite": require('./images/sprites/7.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          250,
          5000,
          5000
        ],
        "type": [
          0,
          200,
          4000,
          4000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 8,
      "avatar": require('./images/avatars/008.png'),
      "name": "Wartortle",
      "type": [
        "water"
      ],
      "classification": "Turtle Pokémon",
      "evolution": "Evolve Squirtle (Lv. 16)",
      "moves": [
        {
          "name": "Aqua Jet",
          "type": "water",
          "attack": "182",
          "wait": "5",
          "description": "The user charges at enemies in front of itself with tremendous speed, dealing damage to them.",
          "learnable": true
        },
        {
          "name": "Aqua Ring",
          "type": "water",
          "attack": "0",
          "wait": "9",
          "description": "The user envelops itself in a veil made of water, restoring some of its HP.",
          "learnable": true
        },
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Water Type Moves Wait -5%",
          "Natural HP Healing +10%"
        ],
        [
          "ATK of Water Type Moves +10%",
          "Water Type Moves Wait -15%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Water Type Moves 15%",
          "ATK +350",
          "HP +350"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "250",
      "baseAtk": "250",
      "sprite": require('./images/sprites/8.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 9,
      "avatar": require('./images/avatars/009.png'),
      "name": "Blastoise",
      "type": [
        "water"
      ],
      "classification": "Shellfish Pokémon",
      "evolution": "Evolve Wartortle (Lv. 36)",
      "moves": [
        {
          "name": "Aqua Jet",
          "type": "water",
          "attack": "182",
          "wait": "5",
          "description": "The user charges at enemies in front of itself with tremendous speed, dealing damage to them.",
          "learnable": true
        },
        {
          "name": "Aqua Ring",
          "type": "water",
          "attack": "0",
          "wait": "9",
          "description": "The user envelops itself in a veil made of water, restoring some of its HP.",
          "learnable": true
        },
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Hydro Pump",
          "type": "water",
          "attack": "213",
          "wait": "5",
          "description": "The user shoots four pillars of water up from the ground and sends them out in front of itself. Deals damage to enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        },
        {
          "name": "Withdraw",
          "type": "water",
          "attack": "0",
          "wait": "5",
          "description": "The user withdraws into its hard shell, reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Water Type Moves Wait -5%",
          "Natural HP Healing +10%"
        ],
        [
          "ATK of WaterType Moves +10%",
          "Water Type Moves Wait -10%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Water Type Moves 10%",
          "Water Type Moves Wait -15%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "400",
      "baseAtk": "400",
      "sprite": require('./images/sprites/9.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 10,
      "avatar": require('./images/avatars/010.png'),
      "name": "Caterpie",
      "type": [
        "bug"
      ],
      "classification": "Worm Pokémon",
      "moves": [
        {
          "name": "Lunge",
          "type": "bug",
          "attack": "180",
          "wait": "5",
          "description": "The user lunges toward enemies in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "String Shot",
          "type": "bug",
          "attack": "118",
          "wait": "2",
          "description": "The user spews a sticky thread in three directions, creating nets that will damage enemies and often lower their movement speed.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Movement Speed +30%",
          "Resistant to ↓ Effects +10%",
          "Hit Healing +2%"
        ],
        [
          "Movement Speed +40%",
          "Resistant to ↓ Effects +20%",
          "Hit Healing +3%"
        ],
        [
          "ATK +500",
          "Wait for Standard Attacks -50%",
          "HP +500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "110",
      "baseAtk": "90",
      "sprite": require('./images/sprites/10.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 11,
      "avatar": require('./images/avatars/011.png'),
      "name": "Metapod",
      "type": [
        "bug"
      ],
      "classification": "Cocoon Pokémon",
      "evolution": "Evolve Caterpie (Lv. 7)",
      "moves": [
        {
          "name": "Iron Defense",
          "type": "steel",
          "attack": "0",
          "wait": "5",
          "description": "The user hardens its skin until it's like iron, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Lunge",
          "type": "bug",
          "attack": "180",
          "wait": "5",
          "description": "The user lunges toward enemies in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "String Shot",
          "type": "bug",
          "attack": "118",
          "wait": "2",
          "description": "The user spews a sticky thread in three directions, creating nets that will damage enemies and often lower their movement speed.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -10%",
          "Resistant to ↓ Effects +20%",
          "Healing per Wave +30%"
        ],
        [
          "Taking Critical Hits Rate -20%",
          "Resistant to ↓ Effects +30%",
          "Healing per Wave +50%"
        ],
        [
          "Resistant to Status Conditions +30%",
          "Own Knockback Distance -40%",
          "HP +450"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "275",
      "baseAtk": "25",
      "sprite": require('./images/sprites/11.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 12,
      "avatar": require('./images/avatars/012.png'),
      "name": "Butterfree",
      "type": [
        "bug",
        "flying"
      ],
      "classification": "Butterfly Pokémon",
      "evolution": "Evolve Metapod (Lv. 10)",
      "moves": [
        {
          "name": "Electroweb",
          "type": "electric",
          "attack": "0",
          "wait": "2",
          "description": "The user spreads an electric net out directly in front of itself, lowering the movement speed of enemies hit by it for a while.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Lunge",
          "type": "bug",
          "attack": "180",
          "wait": "5",
          "description": "The user lunges toward enemies in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Rage Powder",
          "type": "bug",
          "attack": "0",
          "wait": "2",
          "description": "The user scatters a cloud of irritating powder on itself, causing surrounding enemies to target it.",
          "learnable": true
        },
        {
          "name": "Silver Wind",
          "type": "bug",
          "attack": "53",
          "wait": "5",
          "description": "Scales carried by the wind swirl around the user, damaging enemies hit by them. Some or all of the user's stats sometimes rise at random.",
          "learnable": true
        },
        {
          "name": "String Shot",
          "type": "bug",
          "attack": "118",
          "wait": "2",
          "description": "The user spews a sticky thread in three directions, creating nets that will damage enemies and often lower their movement speed.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Movement Speed +30%",
          "Resistant to ↓ Effects +10%",
          "Healing from K.O. +5%"
        ],
        [
          "Movement Speed +40%",
          "Resistant to ↓ Effects +10%",
          "Own Knockback Distance -10%"
        ],
        [
          "ATK +400",
          "Own Knockback Distance -20%",
          "HP +500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "150",
      "baseAtk": "250",
      "sprite": require('./images/sprites/12.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 13,
      "avatar": require('./images/avatars/013.png'),
      "name": "Weedle",
      "type": [
        "bug",
        "poison"
      ],
      "classification": "Hairy Pokémon",
      "moves": [
        {
          "name": "Lunge",
          "type": "bug",
          "attack": "180",
          "wait": "5",
          "description": "The user lunges toward enemies in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "String Shot",
          "type": "bug",
          "attack": "118",
          "wait": "2",
          "description": "The user spews a sticky thread in three directions, creating nets that will damage enemies and often lower their movement speed.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Movement Speed +30%",
          "Critical Hit Damage +5%",
          "Bug Type Move Wait -5%"
        ],
        [
          "Movement Speed +40%",
          "Resistant to Poisoned +100%",
          "Healing from K.O. +5%"
        ],
        [
          "HP +500",
          "Natural HP Healing +30%",
          "ATK +500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "100",
      "sprite": require('./images/sprites/13.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 14,
      "avatar": require('./images/avatars/014.png'),
      "name": "Kakuna",
      "type": [
        "bug",
        "poison"
      ],
      "classification": "Cocoon Pokémon",
      "evolution": "Evolve Weedle (Lv. 7)",
      "moves": [
        {
          "name": "Iron Defense",
          "type": "steel",
          "attack": "0",
          "wait": "5",
          "description": "The user hardens its skin until it's like iron, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "String Shot",
          "type": "bug",
          "attack": "118",
          "wait": "2",
          "description": "The user spews a sticky thread in three directions, creating nets that will damage enemies and often lower their movement speed.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Own Knockback Distance -20%",
          "Critical Hit Damage +5%",
          "HP upon Recovery +10%"
        ],
        [
          "Own Knockback Distance -20%",
          "Resistant to Poisoned +100%",
          "HP upon Recovery +10%"
        ],
        [
          "Own Knockback Distance -50%",
          "HP upon Recovery +20%",
          "HP +450"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "250",
      "baseAtk": "50",
      "sprite": require('./images/sprites/14.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 15,
      "avatar": require('./images/avatars/015.png'),
      "name": "Beedrill",
      "type": [
        "bug",
        "poison"
      ],
      "classification": "Poison Bee Pokémon",
      "evolution": "Evolve Kakuna (Lv. 10)",
      "moves": [
        {
          "name": "Aerial Ace",
          "type": "flying",
          "attack": "124",
          "wait": "5",
          "description": "The user quickly slashes in front of itself twice, dealing damage.",
          "learnable": true
        },
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Electroweb",
          "type": "electric",
          "attack": "0",
          "wait": "2",
          "description": "The user spreads an electric net out directly in front of itself, lowering the movement speed of enemies hit by it for a while.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Iron Defense",
          "type": "steel",
          "attack": "0",
          "wait": "5",
          "description": "The user hardens its skin until it's like iron, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Lunge",
          "type": "bug",
          "attack": "180",
          "wait": "5",
          "description": "The user lunges toward enemies in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Pin Missile",
          "type": "bug",
          "attack": "110",
          "wait": "7",
          "description": "The user shoots three sharp spikes in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "String Shot",
          "type": "bug",
          "attack": "118",
          "wait": "2",
          "description": "The user spews a sticky thread in three directions, creating nets that will damage enemies and often lower their movement speed.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Movement Speed +30%",
          "Critical Hit Damage +10%",
          "Bug Type Move Wait -5%"
        ],
        [
          "Movement Speed +40%",
          "Resistant to Poisoned +100%",
          "Critical Hit Rate +10%"
        ],
        [
          "ATK of Bug Type Moves +20%",
          "Critical Hit Damage +40%",
          "ATK +450"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "150",
      "baseAtk": "250",
      "sprite": require('./images/sprites/15.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 16,
      "avatar": require('./images/avatars/016.png'),
      "name": "Pidgey",
      "type": [
        "normal",
        "flying"
      ],
      "classification": "Tiny Bird Pokémon",
      "moves": [
        {
          "name": "Gust",
          "type": "flying",
          "attack": "61",
          "wait": "7",
          "description": "The user sends an intense gust of wind out in front of itself that whirls around and damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Tailwind",
          "type": "flying",
          "attack": "0",
          "wait": "2",
          "description": "The user creates an intense swirling wind that raises its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Twister",
          "type": "dragon",
          "attack": "115",
          "wait": "7",
          "description": "The user whips up several tornadoes and sends them out in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Whirlwind",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user whips up a strong wind around itself, blowing away enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Resistant to ↓ Effects +10%",
          "Movement Speed + 30%",
          "ATK of Flying Type Moves +5%"
        ],
        [
          "Resistant to ↓ Effects +20%",
          "Movement Speed + 50%",
          "Flying Type Move Wait -15%"
        ],
        [
          "Resistant to DEF↓ +100%",
          "ATK +550",
          "Attack of Flying Type Moves +20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "100",
      "baseAtk": "100",
      "sprite": require('./images/sprites/16.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 17,
      "avatar": require('./images/avatars/017.png'),
      "name": "Pidgeotto",
      "type": [
        "normal",
        "flying"
      ],
      "classification": "Bird Pokémon",
      "evolution": "Evolve Pidgey (Lv. 18)",
      "moves": [
        {
          "name": "Gust",
          "type": "flying",
          "attack": "61",
          "wait": "7",
          "description": "The user sends an intense gust of wind out in front of itself that whirls around and damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Hurricane",
          "type": "flying",
          "attack": "105",
          "wait": "5",
          "description": "The user whips up an intense wind around itself, damaging surrounding enemies and sometimes confusing them.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Tailwind",
          "type": "flying",
          "attack": "0",
          "wait": "2",
          "description": "The user creates an intense swirling wind that raises its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Twister",
          "type": "dragon",
          "attack": "115",
          "wait": "7",
          "description": "The user whips up several tornadoes and sends them out in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Whirlwind",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user whips up a strong wind around itself, blowing away enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Resistant to ↓ Effects +10%",
          "Movement Speed + 30%",
          "ATK of Flying Type Moves +5%"
        ],
        [
          "Resistant to ↓ Effects +20%",
          "Movement Speed + 40%",
          "Flying Type Move Wait -10%"
        ],
        [
          "Resistant to DEF↓ +100%",
          "ATK +350",
          "Attack of Flying Type Moves +15%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "250",
      "baseAtk": "250",
      "sprite": require('./images/sprites/17.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 18,
      "avatar": require('./images/avatars/018.png'),
      "name": "Pidgeot",
      "type": [
        "normal",
        "flying"
      ],
      "classification": "Bird Pokémon",
      "evolution": "Evolve Pidgeotto (Lv. 36)",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Gust",
          "type": "flying",
          "attack": "61",
          "wait": "7",
          "description": "The user sends an intense gust of wind out in front of itself that whirls around and damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Heat Wave",
          "type": "fire",
          "attack": "123",
          "wait": "7",
          "description": "The user exhales hot breath in front of itself, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Hurricane",
          "type": "flying",
          "attack": "105",
          "wait": "5",
          "description": "The user whips up an intense wind around itself, damaging surrounding enemies and sometimes confusing them.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Roost",
          "type": "flying",
          "attack": "0",
          "wait": "9",
          "description": "The user briefly rests its body, restoring a bit of its HP.",
          "learnable": true
        },
        {
          "name": "Sky Attack",
          "type": "flying",
          "attack": "125",
          "wait": "5",
          "description": "After flying up and bracing itself, the user charges at enemies directly in front of itself, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Tailwind",
          "type": "flying",
          "attack": "0",
          "wait": "2",
          "description": "The user creates an intense swirling wind that raises its movement speed for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Resistant to ↓ Effects +10%",
          "Movement Speed + 30%",
          "ATK of Flying Type Moves +5%"
        ],
        [
          "Resistant to ↓ Effects +20%",
          "Movement Speed + 30%",
          "Flying Type Move Wait -10%"
        ],
        [
          "Resistant to DEF↓ +100%",
          "Movement Speed + 40%",
          "Attack of Flying Type Moves +10%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "400",
      "baseAtk": "400",
      "sprite": require('./images/sprites/18.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 19,
      "avatar": require('./images/avatars/019.png'),
      "name": "Rattata",
      "type": [
        "normal"
      ],
      "classification": "Mouse Pokémon",
      "moves": [
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Movement Speed +30%",
          "Time to Recover -10%"
        ],
        [
          "ATK of Normal Type Moves +5%",
          "Movement Speed +40%",
          "Wait for Standard Attacks -30%"
        ],
        [
          "ATK +550",
          "Movement Speed +50%",
          "HP +600"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "75",
      "baseAtk": "125",
      "sprite": require('./images/sprites/19.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 20,
      "avatar": require('./images/avatars/020.png'),
      "name": "Raticate",
      "type": [
        "normal"
      ],
      "classification": "Mouse Pokémon",
      "evolution": "Evolve Rattata (Lv. 20)",
      "moves": [
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Flame Wheel",
          "type": "fire",
          "attack": "57",
          "wait": "5",
          "description": "The user cloaks itself in fire and charges forward, damaging enemies it hits and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Zen Headbutt",
          "type": "psychic",
          "attack": "370",
          "wait": "5",
          "description": "The user focuses its willpower to its head, then smashes it into enemies directly in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Zen Headbutt",
          "type": "psychic",
          "attack": "370",
          "wait": "5",
          "description": "The user focuses its willpower to its head, then smashes it into enemies directly in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Movement Speed +30%",
          "Time to Recover -10%"
        ],
        [
          "ATK of Normal Type Moves +5%",
          "Movement Speed +30%",
          "Wait for Standard Attacks -25%"
        ],
        [
          "ATK +200",
          "Movement Speed +30%",
          "HP +500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "150",
      "baseAtk": "450",
      "sprite": require('./images/sprites/20.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 21,
      "avatar": require('./images/avatars/021.png'),
      "name": "Spearow",
      "type": [
        "normal",
        "flying"
      ],
      "classification": "Tiny Bird Pokémon",
      "moves": [
        {
          "name": "Aerial Ace",
          "type": "flying",
          "attack": "124",
          "wait": "5",
          "description": "The user quickly slashes in front of itself twice, dealing damage.",
          "learnable": true
        },
        {
          "name": "Fly",
          "type": "flying",
          "attack": "243",
          "wait": "5",
          "description": "The user flies toward enemies far in front of itself, then swoops down to deal damage to them.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Flying Type Moves +5%",
          "Critical Hits Rate +5%",
          "Critical Hit Damage +10%"
        ],
        [
          "ATK of Flying Type Moves +15%",
          "Critical Hit Rate +15%",
          "Critical Hit Damage +15%"
        ],
        [
          "ATK +400",
          "Critical Hit Rate 20%",
          "Critical Hit Damage +25%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "75",
      "baseAtk": "125",
      "sprite": require('./images/sprites/21.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 22,
      "avatar": require('./images/avatars/022.png'),
      "name": "Fearow",
      "type": [
        "normal",
        "flying"
      ],
      "classification": "Beak Pokémon",
      "evolution": "Evolve Spearow (Lv. 20)",
      "moves": [
        {
          "name": "Aerial Ace",
          "type": "flying",
          "attack": "124",
          "wait": "5",
          "description": "The user quickly slashes in front of itself twice, dealing damage.",
          "learnable": true
        },
        {
          "name": "Drill Peck",
          "type": "flying",
          "attack": "321",
          "wait": "5",
          "description": "The user attacks enemies directly in front of itself with its sharp beak, damaging them.",
          "learnable": true
        },
        {
          "name": "Fly",
          "type": "flying",
          "attack": "243",
          "wait": "5",
          "description": "The user flies toward enemies far in front of itself, then swoops down to deal damage to them.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Tri Attack",
          "type": "normal",
          "attack": "81",
          "wait": "5",
          "description": "The user's body is imbued with three powers as it attacks enemies in front of itself, damaging them. Sometimes burns, paralyzes, or freezes enemies.",
          "learnable": true
        },
        {
          "name": "Whirlwind",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user whips up a strong wind around itself, blowing away enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Flying Type Moves +5%",
          "Critical Hits Rate +5%",
          "Critical Hit Damage +10%"
        ],
        [
          "ATK of Flying Type Moves +10%",
          "Critical Hit Rate +10%",
          "Critical Hit Damage +15%"
        ],
        [
          "ATK of Flying Type Moves +30%",
          "Critical Hit Rate +15%",
          "Critical Hit Damage +25%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "500",
      "sprite": require('./images/sprites/22.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 23,
      "avatar": require('./images/avatars/023.png'),
      "name": "Ekans",
      "type": [
        "poison"
      ],
      "classification": "Snake Pokémon",
      "moves": [
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Mud Bomb",
          "type": "ground",
          "attack": "215",
          "wait": "5",
          "description": "The user throws a lump of mud in front of itself that splits open when it hits the ground, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Time to Recover -10%",
          "Resistant to ↓ Effects +10%",
          "Healing per Wave +30%"
        ],
        [
          "HP upon Recovery +20%",
          "Resistant to Poisoned +100%",
          "Wait for Standard Attacks -25%"
        ],
        [
          "ATK +550",
          "Resistant to ↓ Effects +20%",
          "Wait for Standard Attacks -50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/23.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 24,
      "avatar": require('./images/avatars/024.png'),
      "name": "Arbok",
      "type": [
        "poison"
      ],
      "classification": "Cobra Pokémon",
      "evolution": "Evolve Ekans (Lv. 22)",
      "moves": [
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Mud Bomb",
          "type": "ground",
          "attack": "215",
          "wait": "5",
          "description": "The user throws a lump of mud in front of itself that splits open when it hits the ground, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Sucker Punch",
          "type": "dark",
          "attack": "130",
          "wait": "5",
          "description": "The user briefly disappears and moves a short distance. It then charges toward enemies, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Time to Recover -10%",
          "Resistant to ↓ Effects +10%",
          "Healing per Wave +25%"
        ],
        [
          "HP upon Recovery +10%",
          "Resistant to Poisoned +100%",
          "Wait for Standard Attacks -20%"
        ],
        [
          "ATK +200",
          "Resistant to ↓ Effects +20%",
          "Wait for Standard Attacks -30%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "150",
      "baseAtk": "450",
      "sprite": require('./images/sprites/24.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 25,
      "avatar": require('./images/avatars/025.png'),
      "name": "Pikachu",
      "type": [
        "electric"
      ],
      "classification": "Mouse Pokémon",
      "moves": [
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Spark",
          "type": "electric",
          "attack": "81",
          "wait": "5",
          "description": "The user charges its body with electricity and charges toward enemies in front of itself. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunder Shock",
          "type": "electric",
          "attack": "173",
          "wait": "5",
          "description": "After storing up electricity, the user fires it toward enemies in front of itself, dealing damage to them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunderbolt",
          "type": "electric",
          "attack": "80",
          "wait": "5",
          "description": "The user discharges tremendous electricity all around itself. Deals damage to enemies around the user. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Volt Tackle",
          "type": "electric",
          "attack": "110",
          "wait": "6",
          "description": "After electrifying itself and charging toward enemies, the user jumps and discharges electricity, damaging enemies hit by it and sometimes paralyzing them.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": false,
          "method": "Mini Expedition Pack (Mobile Only)"
        }
      ],
      "bonus": [
        [
          "Electric Type Moves Wait -5%",
          "ATK of Electric Type Moves +5%",
          "Movement Speed +30%"
        ],
        [
          "Resistant to Paralyzed +100%",
          "ATK of Electric Type Moves +15%",
          "Movement Speed +20%"
        ],
        [
          "Electric Type Damage Taken -50%",
          "ATK of Electric Type Moves +50%",
          "ATK +550"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "70",
      "baseAtk": "130",
      "sprite": require('./images/sprites/25.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          165,
          3300,
          3300
        ],
        "type": [
          0,
          400,
          8000,
          8000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 26,
      "avatar": require('./images/avatars/026.png'),
      "name": "Raichu",
      "type": [
        "electric"
      ],
      "classification": "Mouse Pokémon",
      "evolution": "Evolve Pikachu (Lv. 22)",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Charge",
          "type": "electric",
          "attack": "0",
          "wait": "9",
          "description": "The user stores up electricity, raising the damage it deals and making it resistant to negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Electric Terrain",
          "type": "electric",
          "attack": "0",
          "wait": "5",
          "description": "The user gathers electrical power beneath itself, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Giga Impact",
          "type": "normal",
          "attack": "176",
          "wait": "5",
          "description": "The user focuses every bit of its power and charges toward enemies in front of itself, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Spark",
          "type": "electric",
          "attack": "81",
          "wait": "5",
          "description": "The user charges its body with electricity and charges toward enemies in front of itself. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunder",
          "type": "electric",
          "attack": "204",
          "wait": "5",
          "description": "The user strikes the area in front of itself with a lightning bolt. Deals damage to nearby enemies. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunderbolt",
          "type": "electric",
          "attack": "80",
          "wait": "5",
          "description": "The user discharges tremendous electricity all around itself. Deals damage to enemies around the user. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Volt Tackle",
          "type": "electric",
          "attack": "110",
          "wait": "6",
          "description": "After electrifying itself and charging toward enemies, the user jumps and discharges electricity, damaging enemies hit by it and sometimes paralyzing them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Electric Type Moves Wait -5%",
          "ATK of Electric Type Moves +5%",
          "Movement Speed +30%"
        ],
        [
          "Resistant to Paralyzed +100%",
          "ATK of Electric Type Moves +15%",
          "Movement Speed +40%"
        ],
        [
          "Electric Type Damage Taken -50%",
          "Electric Type Moves Wait -20%",
          "ATK +200"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "150",
      "baseAtk": "450",
      "sprite": require('./images/sprites/26.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 27,
      "avatar": require('./images/avatars/027.png'),
      "name": "Sandshrew",
      "type": [
        "ground"
      ],
      "classification": "Mouse Pokémon",
      "moves": [
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Metal Claw",
          "type": "steel",
          "attack": "211",
          "wait": "5",
          "description": "The user rakes enemies in front of itself with its steel claws, dealing damage. Sometimes raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Sandstorm",
          "type": "rock",
          "attack": "117",
          "wait": "5",
          "description": "The user creates a sandstorm around itself, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -10%",
          "Critical Hit Damage +5%",
          "Movement Speed +30%"
        ],
        [
          "Taking Critical Hits Rate -20%",
          "Critical Hits Rate +15%",
          "Movement Speed +50%"
        ],
        [
          "Taking Critical Hits Rate -30%",
          "ATK +550",
          "Movement Speed +50%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/27.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 28,
      "avatar": require('./images/avatars/028.png'),
      "name": "Sandslash",
      "type": [
        "ground"
      ],
      "classification": "Mouse Pokémon",
      "evolution": "Evolve Sandshrew (Lv. 22)",
      "moves": [
        {
          "name": "Aerial Ace",
          "type": "flying",
          "attack": "124",
          "wait": "5",
          "description": "The user quickly slashes in front of itself twice, dealing damage.",
          "learnable": true
        },
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Metal Claw",
          "type": "steel",
          "attack": "211",
          "wait": "5",
          "description": "The user rakes enemies in front of itself with its steel claws, dealing damage. Sometimes raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Night Slash",
          "type": "dark",
          "attack": "83",
          "wait": "5",
          "description": "The user dashes forward, slashing surrounding enemies and damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Sandstorm",
          "type": "rock",
          "attack": "117",
          "wait": "5",
          "description": "The user creates a sandstorm around itself, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Swords Dance",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "With a frenetic dance to uplift the fighting spirit, the user raises the amount of damage it deals for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -10%",
          "Critical Hit Damage +5%",
          "Movement Speed +30%"
        ],
        [
          "Taking Critical Hits Rate -20%",
          "Critical Hits Rate +10%",
          "Movement Speed +40%"
        ],
        [
          "Taking Critical Hits Rate -30%",
          "ATK+300",
          "Movement Speed +50%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "150",
      "baseAtk": "350",
      "sprite": require('./images/sprites/28.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 29,
      "avatar": require('./images/avatars/029.png'),
      "name": "Nidoran♀",
      "type": [
        "poison"
      ],
      "classification": "Poison Pin Pokémon",
      "moves": [
        {
          "name": "Flatter",
          "type": "dark",
          "attack": "0",
          "wait": "6",
          "description": "The user flatters enemies in front of itself, which confuses them but raises the amount of damage they deal and reduces the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Sing",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user sings to enemies around itself with its calming voice, often putting them to sleep.",
          "learnable": false,
          "method": "Expedition Pack Only"
        }
      ],
      "bonus": [
        [
          "Poison Type Moves Wait -5%",
          "Normal Type Moves Wait -5%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Poison Type Moves Wait -20%",
          "Normal Type Moves Wait -20%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Poison Type Moves Wait -20%",
          "Normal Type Moves Wait -20%",
          "HP +500"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "140",
      "baseAtk": "60",
      "sprite": require('./images/sprites/29.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 30,
      "avatar": require('./images/avatars/030.png'),
      "name": "Nidorina",
      "type": [
        "poison"
      ],
      "classification": "Poison Pin Pokémon",
      "evolution": "Evolve Nidoran (Lv. 16)",
      "moves": [
        {
          "name": "Flatter",
          "type": "dark",
          "attack": "0",
          "wait": "6",
          "description": "The user flatters enemies in front of itself, which confuses them but raises the amount of damage they deal and reduces the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Poison Type Moves Wait -5%",
          "Normal Type Moves Wait -5%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Poison Type Moves Wait -15%",
          "Normal Type Moves Wait -15%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Poison Type Moves Wait -15%",
          "Normal Type Moves Wait -15%",
          "HP +300"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "325",
      "baseAtk": "175",
      "sprite": require('./images/sprites/30.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 31,
      "avatar": require('./images/avatars/031.png'),
      "name": "Nidoqueen",
      "type": [
        "poison",
        "ground"
      ],
      "classification": "Drill Pokémon",
      "evolution": "Evolve Nidorina (Lv. 36)",
      "moves": [
        {
          "name": "Flatter",
          "type": "dark",
          "attack": "0",
          "wait": "6",
          "description": "The user flatters enemies in front of itself, which confuses them but raises the amount of damage they deal and reduces the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Stealth Rock",
          "type": "rock",
          "attack": "120",
          "wait": "5",
          "description": "The user creates pillars of stone from the ground, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Supersonic",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user generates odd sound waves from its body, often confusing surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Venom Drench",
          "type": "poison",
          "attack": "118",
          "wait": "5",
          "description": "The user spews poison in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Poison Type Moves Wait -5%",
          "Normal Type Moves Wait -5%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Poison Type Moves Wait -10%",
          "Normal Type Moves Wait -10%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Poison Type Moves Wait -10%",
          "Normal Type Moves Wait -10%",
          "Resistant to ↓ Effects +20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "600",
      "baseAtk": "200",
      "sprite": require('./images/sprites/31.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 32,
      "avatar": require('./images/avatars/032.png'),
      "name": "Nidoran♂",
      "type": [
        "poison"
      ],
      "classification": "Poison Pin Pokémon",
      "moves": [
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Toxic",
          "type": "poison",
          "attack": "59",
          "wait": "4",
          "description": "The user sprays a powerful poison around itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Work Up",
          "type": "normal",
          "attack": "0",
          "wait": "8",
          "description": "The user is roused, raising the amount of damage it deals and reducing the amount of damage it takes for a while.",
          "learnable": false,
          "method": "Expedition Pack Only"
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -10%",
          "ATK of Normal Type Moves +5%",
          "Own Knockback Distance -10%"
        ],
        [
          "Resistant to Poisoned +100%",
          "Critical Hit Damage +15%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK +500",
          "Critical Hit Rate +20%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "60",
      "baseAtk": "140",
      "sprite": require('./images/sprites/32.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 33,
      "avatar": require('./images/avatars/033.png'),
      "name": "Nidorino",
      "type": [
        "poison"
      ],
      "classification": "Poison Pin Pokémon",
      "evolution": "Evolve Nidoran (Lv. 16)",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Toxic",
          "type": "poison",
          "attack": "59",
          "wait": "4",
          "description": "The user sprays a powerful poison around itself, often poisoning enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -10%",
          "ATK of Normal Type Moves +5%",
          "Own Knockback Distance -10%"
        ],
        [
          "Resistant to Poisoned +100%",
          "Critical Hit Damage +10%",
          "Own Knockback Distance -20%"
        ],
        [
          "Normal Type Moves Wait -15%",
          "Critical Hit Rate +15%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "175",
      "baseAtk": "325",
      "sprite": require('./images/sprites/33.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 34,
      "avatar": require('./images/avatars/034.png'),
      "name": "Nidoking",
      "type": [
        "poison",
        "ground"
      ],
      "classification": "Drill Pokémon",
      "evolution": "Evolve Nidorino (Lv. 36)",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Megahorn",
          "type": "bug",
          "attack": "513",
          "wait": "5",
          "description": "Using its tough and impressive horn, the user rams into enemies in front of itself with no letup, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Toxic",
          "type": "poison",
          "attack": "59",
          "wait": "4",
          "description": "The user sprays a powerful poison around itself, often poisoning enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -10%",
          "ATK of Normal Type Moves +5%",
          "Own Knockback Distance -10%"
        ],
        [
          "Resistant to Poisoned +100%",
          "Critical Hit Damage +5%",
          "Own Knockback Distance -20%"
        ],
        [
          "Critical Hit Damage +10%",
          "Critical Hit Rate +10%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "200",
      "baseAtk": "600",
      "sprite": require('./images/sprites/34.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 35,
      "avatar": require('./images/avatars/035.png'),
      "name": "Clefairy",
      "type": [
        "fairy"
      ],
      "classification": "Fairy Pokémon",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Pokémon Size Change -10%",
          "Normal Type Moves Wait -10%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Pokémon Size Change -15%",
          "Normal Type Moves Wait -20%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Pokémon Size Change -15%",
          "HP +500",
          "Resistant to Burned +100%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "120",
      "baseAtk": "80",
      "sprite": require('./images/sprites/35.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 36,
      "avatar": require('./images/avatars/036.png'),
      "name": "Clefable",
      "type": [
        "fairy"
      ],
      "classification": "Fairy Pokémon",
      "evolution": "Evolve Clefairy (Lv. 36)",
      "moves": [
        {
          "name": "Dazzling Gleam",
          "type": "fairy",
          "attack": "146",
          "wait": "5",
          "description": "The user moves about as it emits a powerful flash that damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Follow Me",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user grabs the attention of surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Pokémon Size Change -10%",
          "Normal Type Moves Wait -5%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Pokémon Size Change -15%",
          "Normal Type Moves Wait -10%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Pokémon Size Change -25%",
          "Resistant to Burned +100%",
          "Resistant to ↓ Effects +40%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "450",
      "baseAtk": "250",
      "sprite": require('./images/sprites/36.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 37,
      "avatar": require('./images/avatars/037.png'),
      "name": "Vulpix",
      "type": [
        "fire"
      ],
      "classification": "Fox Pokémon",
      "moves": [
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flame Charge",
          "type": "fire",
          "attack": "0",
          "wait": "5",
          "description": "The user stores up the power of flames, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Roar",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user roars intensely, blowing away surrounding enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Moves Wait -5%",
          "ATK of Fire Type Moves +5%",
          "Fire Type Damage Taken -25%"
        ],
        [
          "Fire Type Moves Wait -10%",
          "ATK of Fire Type Moves +15%",
          "Resistant to Burned +100%"
        ],
        [
          "Fire Type Moves Wait -20%",
          "ATK of Fire Type Moves +20%",
          "HP +500"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "110",
      "baseAtk": "90",
      "sprite": require('./images/sprites/37.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 38,
      "avatar": require('./images/avatars/038.png'),
      "name": "Ninetales",
      "type": [
        "fire"
      ],
      "classification": "Fox Pokémon",
      "evolution": "Evolve Vulpix (Lv. 36)",
      "moves": [
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Confuse Ray",
          "type": "ghost",
          "attack": "0",
          "wait": "3",
          "description": "The user exposes surrounding enemies to a sinister ray, often confusing them.",
          "learnable": true
        },
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Fire Blast",
          "type": "fire",
          "attack": "179",
          "wait": "5",
          "description": "The user sprays an all-consuming fire on the ground, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Flame Charge",
          "type": "fire",
          "attack": "0",
          "wait": "5",
          "description": "The user stores up the power of flames, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Heat Wave",
          "type": "fire",
          "attack": "123",
          "wait": "7",
          "description": "The user exhales hot breath in front of itself, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Roar",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user roars intensely, blowing away surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Solar Beam",
          "type": "grass",
          "attack": "227",
          "wait": "7",
          "description": "The user gathers light and unleashes it in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Will-O-Wisp",
          "type": "fire",
          "attack": "19",
          "wait": "3",
          "description": "The user drapes itself with sinister flames and attacks enemies directly in front of it. Often burns enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Moves Wait -5%",
          "ATK of Fire Type Moves +5%",
          "Fire Type Damage Taken -25%"
        ],
        [
          "Fire Type Moves Wait -10%",
          "ATK of Fire Type Moves +10%",
          "Resistant to  Burned +100%"
        ],
        [
          "Fire Type Moves Wait -15%",
          "ATK of Fire Type Moves +15%",
          "Time to Recover -10%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "550",
      "baseAtk": "250",
      "sprite": require('./images/sprites/38.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 39,
      "avatar": require('./images/avatars/039.png'),
      "name": "Jigglypuff",
      "type": [
        "normal",
        "fairy"
      ],
      "classification": "Balloon Pokémon",
      "moves": [
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Sing",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user sings to enemies around itself with its calming voice, often putting them to sleep.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Time to Recover -10%",
          "ATK of Normal Type Moves +5%",
          "Normal Type Moves Wait -5%"
        ],
        [
          "Pokémon Size Change +25%",
          "ATK of Normal Type Moves +20%",
          "Normal Type Moves Wait -15%"
        ],
        [
          "Pokémon Size Change +25%",
          "HP +500",
          "Normal Type Moves Wait -20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "140",
      "baseAtk": "60",
      "sprite": require('./images/sprites/39.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 40,
      "avatar": require('./images/avatars/040.png'),
      "name": "Wigglytuff",
      "type": [
        "normal",
        "fairy"
      ],
      "classification": "Balloon Pokémon",
      "evolution": "Evolve Jigglypuff (Lv. 36)",
      "moves": [
        {
          "name": "Bounce",
          "type": "flying",
          "attack": "186",
          "wait": "5",
          "description": "The user bounces forward high into the air twice, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Dynamic Punch",
          "type": "fighting",
          "attack": "87",
          "wait": "5",
          "description": "The user punches enemies directly in front of itself with its full, concentrated power. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Play Rough",
          "type": "fairy",
          "attack": "98",
          "wait": "5",
          "description": "The user plays rough with enemies in front of itself, damaging them. Sometimes lowers the damage enemies deal.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Sing",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user sings to enemies around itself with its calming voice, often putting them to sleep.",
          "learnable": true
        },
        {
          "name": "Sweet Kiss",
          "type": "fairy",
          "attack": "165",
          "wait": "3",
          "description": "The user kisses enemies directly in front of itself with a sweet, angelic kiss that often confuses them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Time to Recover -10%",
          "ATK of Normal Type Moves +5%",
          "Normal Type Moves Wait -5%"
        ],
        [
          "Pokémon Size Change +25%",
          "ATK of Normal Type Moves +15%",
          "Normal Type Moves Wait -10%"
        ],
        [
          "Pokémon Size Change +25%",
          "Dragon Type Damage Taken -50%",
          "Normal Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "450",
      "baseAtk": "150",
      "sprite": require('./images/sprites/40.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 41,
      "avatar": require('./images/avatars/041.png'),
      "name": "Zubat",
      "type": [
        "poison",
        "flying"
      ],
      "classification": "Bat Pokémon",
      "moves": [
        {
          "name": "Gust",
          "type": "flying",
          "attack": "61",
          "wait": "7",
          "description": "The user sends an intense gust of wind out in front of itself that whirls around and damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Leech Life",
          "type": "bug",
          "attack": "185",
          "wait": "9",
          "description": "The user drains the blood of enemies directly in front of itself, damaging them. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Supersonic",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user generates odd sound waves from its body, often confusing surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "U-turn",
          "type": "bug",
          "attack": "243",
          "wait": "5",
          "description": "After attacking surrounding enemies, the user moves back to dodge enemies' counterattacks.",
          "learnable": true
        },
        {
          "name": "Whirlwind",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user whips up a strong wind around itself, blowing away enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Hit Healing +1%",
          "Movement Speed +30%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Hit Healing +2%",
          "Movement Speed +40%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Hit Healing +3%",
          "Movement Speed +50%",
          "ATK +550"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/41.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 42,
      "avatar": require('./images/avatars/042.png'),
      "name": "Golbat",
      "type": [
        "poison",
        "flying"
      ],
      "classification": "Bat Pokémon",
      "evolution": "Evolve Zubat (Lv. 22)",
      "moves": [
        {
          "name": "Gust",
          "type": "flying",
          "attack": "61",
          "wait": "7",
          "description": "The user sends an intense gust of wind out in front of itself that whirls around and damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Leech Life",
          "type": "bug",
          "attack": "185",
          "wait": "9",
          "description": "The user drains the blood of enemies directly in front of itself, damaging them. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Nasty Plot",
          "type": "dark",
          "attack": "0",
          "wait": "5",
          "description": "The user stimulates its brain by thinking bad thoughts, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Roost",
          "type": "flying",
          "attack": "0",
          "wait": "9",
          "description": "The user briefly rests its body, restoring a bit of its HP.",
          "learnable": true
        },
        {
          "name": "Tailwind",
          "type": "flying",
          "attack": "0",
          "wait": "2",
          "description": "The user creates an intense swirling wind that raises its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Venom Drench",
          "type": "poison",
          "attack": "118",
          "wait": "5",
          "description": "The user spews poison in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        },
        {
          "name": "Whirlwind",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user whips up a strong wind around itself, blowing away enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Hit Healing +1%",
          "Movement Speed +30%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Hit Healing +2%",
          "Movement Speed +40%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Hit Healing +3%",
          "Movement Speed +40%",
          "ATK +250"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "200",
      "baseAtk": "400",
      "sprite": require('./images/sprites/42.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 43,
      "avatar": require('./images/avatars/043.png'),
      "name": "Oddish",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Weed Pokémon",
      "moves": [
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Petal Dance",
          "type": "grass",
          "attack": "156",
          "wait": "5",
          "description": "The user spins in place, scattering petals that deal damage to enemies around it.",
          "learnable": true
        },
        {
          "name": "Poison Powder",
          "type": "poison",
          "attack": "67",
          "wait": "4",
          "description": "The user scatters poison powder in front of itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Grass Type Moves +5%",
          "Movement Speed +30%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "ATK of Grass Type Moves +20%",
          "Movement Speed +40%",
          "Resistant to Poisoned +100%"
        ],
        [
          "ATK of Grass Type Moves +20%",
          "Grass Type Moves Wait -10%",
          "ATK +500"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "75",
      "baseAtk": "125",
      "sprite": require('./images/sprites/43.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 44,
      "avatar": require('./images/avatars/044.png'),
      "name": "Gloom",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Weed Pokémon",
      "evolution": "Evolve Oddish (Lv. 21)",
      "moves": [
        {
          "name": "Bullet Seed",
          "type": "grass",
          "attack": "168",
          "wait": "7",
          "description": "The user sends several seeds flying out in front of itself simultaneously, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Petal Dance",
          "type": "grass",
          "attack": "156",
          "wait": "5",
          "description": "The user spins in place, scattering petals that deal damage to enemies around it.",
          "learnable": true
        },
        {
          "name": "Poison Powder",
          "type": "poison",
          "attack": "67",
          "wait": "4",
          "description": "The user scatters poison powder in front of itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Grass Type Moves +5%",
          "Movement Speed +30%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "ATK of Grass Type Moves +15%",
          "Movement Speed +40%",
          "Resistant to Poisoned +100%"
        ],
        [
          "ATK of Grass Type Moves +15%",
          "Grass Type Moves Wait -15%",
          "ATK +250"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "250",
      "baseAtk": "350",
      "sprite": require('./images/sprites/44.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 45,
      "avatar": require('./images/avatars/045.png'),
      "name": "Vileplume",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Flower Pokémon",
      "evolution": "Evolve Gloom (Lv. 36)",
      "moves": [
        {
          "name": "Bullet Seed",
          "type": "grass",
          "attack": "168",
          "wait": "7",
          "description": "The user sends several seeds flying out in front of itself simultaneously, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Petal Dance",
          "type": "grass",
          "attack": "156",
          "wait": "5",
          "description": "The user spins in place, scattering petals that deal damage to enemies around it.",
          "learnable": true
        },
        {
          "name": "Solar Beam",
          "type": "grass",
          "attack": "227",
          "wait": "7",
          "description": "The user gathers light and unleashes it in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Grass Type Moves +5%",
          "Movement Speed +30%",
          "Resistant to  ↓ Effects  +10%"
        ],
        [
          "ATK of Grass Type Moves +10%",
          "Movement Speed +40%",
          "Resistant to Poisoned +100%"
        ],
        [
          "ATK of Grass Type Moves +10%",
          "Grass Type Moves Wait -10%",
          "Hit Healing +3%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "300",
      "baseAtk": "500",
      "sprite": require('./images/sprites/45.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 46,
      "avatar": require('./images/avatars/046.png'),
      "name": "Paras",
      "type": [
        "bug",
        "grass"
      ],
      "classification": "Mushroom Pokémon",
      "moves": [
        {
          "name": "Leech Seed",
          "type": "grass",
          "attack": "103",
          "wait": "9",
          "description": "The user plants a seed on the ground in front of itself. Enemies in range are gradually damaged. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Poison Powder",
          "type": "poison",
          "attack": "67",
          "wait": "4",
          "description": "The user scatters poison powder in front of itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Rage Powder",
          "type": "bug",
          "attack": "0",
          "wait": "2",
          "description": "The user scatters a cloud of irritating powder on itself, causing surrounding enemies to target it.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Healing per Wave +30%",
          "Grass Type Moves Wait -5%",
          "Time to Recover -10%"
        ],
        [
          "Healing per Wave +40%",
          "Grass Type Moves Wait -15%",
          "HP upon Recovery +20%"
        ],
        [
          "Natural HP Healing +15%",
          "Grass Type Moves Wait -20%",
          "ATK +550"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/46.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 47,
      "avatar": require('./images/avatars/047.png'),
      "name": "Parasect",
      "type": [
        "bug",
        "grass"
      ],
      "classification": "Mushroom Pokémon",
      "evolution": "Evolve Paras (Lv. 24)",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Bullet Seed",
          "type": "grass",
          "attack": "168",
          "wait": "7",
          "description": "The user sends several seeds flying out in front of itself simultaneously, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Leech Seed",
          "type": "grass",
          "attack": "103",
          "wait": "9",
          "description": "The user plants a seed on the ground in front of itself. Enemies in range are gradually damaged. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Metal Claw",
          "type": "steel",
          "attack": "211",
          "wait": "5",
          "description": "The user rakes enemies in front of itself with its steel claws, dealing damage. Sometimes raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Poison Powder",
          "type": "poison",
          "attack": "67",
          "wait": "4",
          "description": "The user scatters poison powder in front of itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Rage Powder",
          "type": "bug",
          "attack": "0",
          "wait": "2",
          "description": "The user scatters a cloud of irritating powder on itself, causing surrounding enemies to target it.",
          "learnable": true
        },
        {
          "name": "Spore",
          "type": "grass",
          "attack": "0",
          "wait": "9",
          "description": "The user scatters sleep-inducing spores directly in front of itself, often making enemies fall asleep.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Healing per Wave +20%",
          "Grass Type Moves Wait -5%",
          "Time to Recover -10%"
        ],
        [
          "Healing per Wave +30%",
          "Grass Type Moves Wait -10%",
          "HP upon Recovery +10%"
        ],
        [
          "Natural HP Healing +10%",
          "Grass Type Moves Wait -15%",
          "Critical Hit Rate +20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "200",
      "baseAtk": "500",
      "sprite": require('./images/sprites/47.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 48,
      "avatar": require('./images/avatars/048.png'),
      "name": "Venonat",
      "type": [
        "bug",
        "poison"
      ],
      "classification": "Insect Pokémon",
      "moves": [
        {
          "name": "Poison Powder",
          "type": "poison",
          "attack": "67",
          "wait": "4",
          "description": "The user scatters poison powder in front of itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "String Shot",
          "type": "bug",
          "attack": "118",
          "wait": "2",
          "description": "The user spews a sticky thread in three directions, creating nets that will damage enemies and often lower their movement speed.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Resistant to ↓ Effects +10%",
          "Resistant to Status Conditions +10%",
          "Taking Critical Hits Rate -10%"
        ],
        [
          "Resistant to ↓ Effects +20%",
          "Resistant to Poisoned +100%",
          "Taking Critical Hits Rate -20%"
        ],
        [
          "Resistant to ↓ Effects +30%",
          "Resistant to Status Conditions +30%",
          "ATK +600"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "120",
      "baseAtk": "80",
      "sprite": require('./images/sprites/48.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          250,
          5000,
          5000
        ],
        "type": [
          0,
          250,
          5000,
          5000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 49,
      "avatar": require('./images/avatars/049.png'),
      "name": "Venomoth",
      "type": [
        "bug",
        "poison"
      ],
      "classification": "Poison Moth Pokémon",
      "evolution": "Evolve Venonat (Lv. 31)",
      "moves": [
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Gust",
          "type": "flying",
          "attack": "61",
          "wait": "7",
          "description": "The user sends an intense gust of wind out in front of itself that whirls around and damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Poison Powder",
          "type": "poison",
          "attack": "67",
          "wait": "4",
          "description": "The user scatters poison powder in front of itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Silver Wind",
          "type": "bug",
          "attack": "53",
          "wait": "5",
          "description": "Scales carried by the wind swirl around the user, damaging enemies hit by them. Some or all of the user's stats sometimes rise at random.",
          "learnable": true
        },
        {
          "name": "String Shot",
          "type": "bug",
          "attack": "118",
          "wait": "2",
          "description": "The user spews a sticky thread in three directions, creating nets that will damage enemies and often lower their movement speed.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Supersonic",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user generates odd sound waves from its body, often confusing surrounding enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Resistant to ↓ Effects +10%",
          "Resistant to Status Conditions +10%",
          "Taking Critical Hits Rate -10%"
        ],
        [
          "Resistant to ↓ Effects +20%",
          "Resistant to Poisoned +100%",
          "Taking Critical Hits Rate -15%"
        ],
        [
          "Resistant to ↓ Effects +30%",
          "Resistant to Status Conditions +20%",
          "ATK +350"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "350",
      "baseAtk": "350",
      "sprite": require('./images/sprites/49.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 50,
      "avatar": require('./images/avatars/050.png'),
      "name": "Diglett",
      "type": [
        "ground"
      ],
      "classification": "Mole Pokémon",
      "moves": [
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Mud Bomb",
          "type": "ground",
          "attack": "215",
          "wait": "5",
          "description": "The user throws a lump of mud in front of itself that splits open when it hits the ground, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Stealth Rock",
          "type": "rock",
          "attack": "120",
          "wait": "5",
          "description": "The user creates pillars of stone from the ground, damaging enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Ground Type Moves Wait -5%",
          "ATK of Ground Type Moves +5%",
          "Movement Speed +30%"
        ],
        [
          "Ground Type Moves Wait -15%",
          "ATK of Normal Type Moves +15%",
          "Movement Speed +40%"
        ],
        [
          "ATK +500",
          "ATK of Ground Type Moves +20%",
          "Movement Speed +50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "60",
      "baseAtk": "140",
      "sprite": require('./images/sprites/50.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 51,
      "avatar": require('./images/avatars/051.png'),
      "name": "Dugtrio",
      "type": [
        "ground"
      ],
      "classification": "Mole Pokémon",
      "evolution": "Evolve Diglett (Lv. 26)",
      "moves": [
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Mud Bomb",
          "type": "ground",
          "attack": "215",
          "wait": "5",
          "description": "The user throws a lump of mud in front of itself that splits open when it hits the ground, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Mud-Slap",
          "type": "ground",
          "attack": "56",
          "wait": "7",
          "description": "The user hurls mud in three directions, dealing damage to enemies hit by it. Sometimes reduces their movement speed.",
          "learnable": true
        },
        {
          "name": "Rock Throw",
          "type": "rock",
          "attack": "234",
          "wait": "5",
          "description": "The user picks up two rocks and hurls them in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Shore Up",
          "type": "ground",
          "attack": "0",
          "wait": "9",
          "description": "The user gathers sand from beneath itself, restoring a bit of its HP.",
          "learnable": true
        },
        {
          "name": "Stealth Rock",
          "type": "rock",
          "attack": "120",
          "wait": "5",
          "description": "The user creates pillars of stone from the ground, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Sucker Punch",
          "type": "dark",
          "attack": "130",
          "wait": "5",
          "description": "The user briefly disappears and moves a short distance. It then charges toward enemies, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Ground Type Moves Wait -5%",
          "ATK of Ground Type Moves +5%",
          "Movement Speed +30%"
        ],
        [
          "Ground Type Moves Wait -10%",
          "ATK of Normal Type Moves +10%",
          "Movement Speed +30%"
        ],
        [
          "Critical Hit Rate +20%",
          "ATK of Ground Type Moves +15%",
          "Movement Speed +40%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "100",
      "baseAtk": "600",
      "sprite": require('./images/sprites/51.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 52,
      "avatar": require('./images/avatars/052.png'),
      "name": "Meowth",
      "type": [
        "normal"
      ],
      "classification": "Scratch Cat Pokémon",
      "moves": [
        {
          "name": "Fury Swipes",
          "type": "normal",
          "attack": "146",
          "wait": "5",
          "description": "The user repeatedly swipes at enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "U-turn",
          "type": "bug",
          "attack": "243",
          "wait": "5",
          "description": "After attacking surrounding enemies, the user moves back to dodge enemies' counterattacks.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Normal Type Moves Wait -5%",
          "Movement Speed +30%",
          "Critical Hit Rate +5%"
        ],
        [
          "Normal Type Moves Wait -15%",
          "Movement Speed +40%",
          "Critical Hit Damage +5%"
        ],
        [
          "Normal Type Moves Wait -20%",
          "Movement Speed +50%",
          "ATK +550"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "85",
      "baseAtk": "115",
      "sprite": require('./images/sprites/52.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 53,
      "avatar": require('./images/avatars/053.png'),
      "name": "Persian",
      "type": [
        "normal"
      ],
      "classification": "Classy Cat Pokémon",
      "evolution": "Evolve Meowth (Lv. 28)",
      "moves": [
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Fury Swipes",
          "type": "normal",
          "attack": "146",
          "wait": "5",
          "description": "The user repeatedly swipes at enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Nasty Plot",
          "type": "dark",
          "attack": "0",
          "wait": "5",
          "description": "The user stimulates its brain by thinking bad thoughts, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Night Slash",
          "type": "dark",
          "attack": "83",
          "wait": "5",
          "description": "The user dashes forward, slashing surrounding enemies and damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Play Rough",
          "type": "fairy",
          "attack": "98",
          "wait": "5",
          "description": "The user plays rough with enemies in front of itself, damaging them. Sometimes lowers the damage enemies deal.",
          "learnable": true
        },
        {
          "name": "Roar",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user roars intensely, blowing away surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "U-turn",
          "type": "bug",
          "attack": "243",
          "wait": "5",
          "description": "After attacking surrounding enemies, the user moves back to dodge enemies' counterattacks.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Normal Type Moves Wait -5%",
          "Movement Speed +30%",
          "Critical Hit Rate +5%"
        ],
        [
          "Normal Type Moves Wait -10%",
          "Movement Speed +40%",
          "Resistant to Paralyzed +100%"
        ],
        [
          "Normal Type Moves Wait -15%",
          "Movement Speed +40%",
          "ATK +250"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "300",
      "baseAtk": "400",
      "sprite": require('./images/sprites/53.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 54,
      "avatar": require('./images/avatars/054.png'),
      "name": "Psyduck",
      "type": [
        "water"
      ],
      "classification": "Duck Pokémon",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Confuse Ray",
          "type": "ghost",
          "attack": "0",
          "wait": "3",
          "description": "The user exposes surrounding enemies to a sinister ray, often confusing them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Water Type Moves Wait -5%",
          "Psychic Type Moves Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "Water Type Moves Wait -10%",
          "Psychic Type Moves Wait -10%",
          "Movement Speed +30%"
        ],
        [
          "ATK +500",
          "ATK of Psychic Type Moves +20%",
          "Movement Speed +40%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/54.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 55,
      "avatar": require('./images/avatars/055.png'),
      "name": "Golduck",
      "type": [
        "water"
      ],
      "classification": "Duck Pokémon",
      "evolution": "Evolve Psyduck (Lv. 33)",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Confuse Ray",
          "type": "ghost",
          "attack": "0",
          "wait": "3",
          "description": "The user exposes surrounding enemies to a sinister ray, often confusing them.",
          "learnable": true
        },
        {
          "name": "Hydro Pump",
          "type": "water",
          "attack": "213",
          "wait": "5",
          "description": "The user shoots four pillars of water up from the ground and sends them out in front of itself. Deals damage to enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Mud Bomb",
          "type": "ground",
          "attack": "215",
          "wait": "5",
          "description": "The user throws a lump of mud in front of itself that splits open when it hits the ground, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Water Type Moves Wait -5%",
          "Psychic Type Moves Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "Water Type Moves Wait -10%",
          "Psychic Type Moves Wait -10%",
          "Movement Speed +30%"
        ],
        [
          "ATK of Water Type Moves +25%",
          "ATK of Psychic Type Moves +15%",
          "Movement Speed +30%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "200",
      "baseAtk": "500",
      "sprite": require('./images/sprites/55.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 56,
      "avatar": require('./images/avatars/056.png'),
      "name": "Mankey",
      "type": [
        "fighting"
      ],
      "classification": "Pig Monkey Pokémon",
      "moves": [
        {
          "name": "Fury Swipes",
          "type": "normal",
          "attack": "146",
          "wait": "5",
          "description": "The user repeatedly swipes at enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Submission",
          "type": "fighting",
          "attack": "130",
          "wait": "5",
          "description": "The user spins toward enemies in front of itself, smashing into them. Deals damage to enemies hit by the user as it whirls around.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fighting Type Moves Wait -5%",
          "ATK of Normal Type Moves +5%",
          "Resistant to ↓ Effects +20%"
        ],
        [
          "Fighting Type Moves Wait -10%",
          "ATK of Normal Type Moves +15%",
          "Resistant to Asleep +100%"
        ],
        [
          "ATK +500",
          "Normal Type Moves Wait -20%",
          "Resistant to ↓ Effects +30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "60",
      "baseAtk": "140",
      "sprite": require('./images/sprites/56.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 57,
      "avatar": require('./images/avatars/057.png'),
      "name": "Primeape",
      "type": [
        "fighting"
      ],
      "classification": "Pig Monkey Pokémon",
      "evolution": "Evolve Mankey (Lv. 28)",
      "moves": [
        {
          "name": "Close Combat",
          "type": "fighting",
          "attack": "245",
          "wait": "5",
          "description": "The user gets right up on enemies in front of itself and smacks them with a single blow, damaging them. Sometimes raises the amount of damage the user takes.",
          "learnable": true
        },
        {
          "name": "Cross Chop",
          "type": "fighting",
          "attack": "273",
          "wait": "5",
          "description": "The user jumps toward enemies in front of itself and smacks them with a two-handed chop, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Fury Swipes",
          "type": "normal",
          "attack": "146",
          "wait": "5",
          "description": "The user repeatedly swipes at enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Meditate",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user meditates to awaken the power deep within its body, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Night Slash",
          "type": "dark",
          "attack": "83",
          "wait": "5",
          "description": "The user dashes forward, slashing surrounding enemies and damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Scratch",
          "type": "normal",
          "attack": "231",
          "wait": "5",
          "description": "The user rakes its hard, pointed claws over enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Submission",
          "type": "fighting",
          "attack": "130",
          "wait": "5",
          "description": "The user spins toward enemies in front of itself, smashing into them. Deals damage to enemies hit by the user as it whirls around.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fighting Type Moves Wait -5%",
          "ATK of Normal Type Moves +5%",
          "Resistant to ↓ Effects +20%"
        ],
        [
          "Fighting Type Moves Wait -10%",
          "ATK of Normal Type Moves +10%",
          "Resistant to Asleep +100%"
        ],
        [
          "ATK of Fighting Type Moves +20%",
          "Normal Type Moves Wait -15%",
          "Resistant to ↓ Effects +30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "150",
      "baseAtk": "550",
      "sprite": require('./images/sprites/57.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 58,
      "avatar": require('./images/avatars/058.png'),
      "name": "Growlithe",
      "type": [
        "fire"
      ],
      "classification": "Puppy Pokémon",
      "moves": [
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flame Charge",
          "type": "fire",
          "attack": "0",
          "wait": "5",
          "description": "The user stores up the power of flames, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Flame Wheel",
          "type": "fire",
          "attack": "57",
          "wait": "5",
          "description": "The user cloaks itself in fire and charges forward, damaging enemies it hits and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Roar",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user roars intensely, blowing away surrounding enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Damage Taken -25%",
          "Fire Type Moves Wait -5%",
          "ATK of Fire Type Moves +5%"
        ],
        [
          "Resistant to Burn +100%",
          "Fire Type Moves Wait -15%",
          "ATK of Fire Type Moves +15%"
        ],
        [
          "ATK +500",
          "Fire Type Moves Wait -20%",
          "ATK of Fire Type Moves +20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/58.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 59,
      "avatar": require('./images/avatars/059.png'),
      "name": "Arcanine",
      "type": [
        "fire"
      ],
      "classification": "Legendary Pokémon",
      "evolution": "Evolve Growlithe (Lv. 36)",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Extreme Speed",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user charges into enemies in front of itself with blinding speed, damaging them.",
          "learnable": true
        },
        {
          "name": "Fire Blast",
          "type": "fire",
          "attack": "179",
          "wait": "5",
          "description": "The user sprays an all-consuming fire on the ground, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Flame Charge",
          "type": "fire",
          "attack": "0",
          "wait": "5",
          "description": "The user stores up the power of flames, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Flame Wheel",
          "type": "fire",
          "attack": "57",
          "wait": "5",
          "description": "The user cloaks itself in fire and charges forward, damaging enemies it hits and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flare Blitz",
          "type": "fire",
          "attack": "128",
          "wait": "5",
          "description": "The user creates a path of flames in front of itself and charges forward along it. Deals damage to enemies. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Roar",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user roars intensely, blowing away surrounding enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Damage Taken -25%",
          "Fire Type Moves Wait -5%",
          "ATK of Fire Type Moves +5%"
        ],
        [
          "Resistant to Burn +100%",
          "Fire Type Moves Wait -10%",
          "ATK of Fire Type Moves +10%"
        ],
        [
          "Normal Type Moves Wait -15%",
          "Fire Type Moves Wait -15%",
          "ATK of Fire Type Moves +15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "350",
      "baseAtk": "450",
      "sprite": require('./images/sprites/59.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 60,
      "avatar": require('./images/avatars/060.png'),
      "name": "Poliwag",
      "type": [
        "water"
      ],
      "classification": "Tadpole Pokémon",
      "moves": [
        {
          "name": "Aqua Jet",
          "type": "water",
          "attack": "182",
          "wait": "5",
          "description": "The user charges at enemies in front of itself with tremendous speed, dealing damage to them.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Critical Hit Damage +5%",
          "Movement Speed +30%"
        ],
        [
          "ATK of Water Type Moves +20%",
          "Water Type Moves Wait -20%",
          "Water Type Damage Taken -25%"
        ],
        [
          "ATK of Water Type Moves +25%",
          "ATK +550",
          "HP +600"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "90",
      "baseAtk": "110",
      "sprite": require('./images/sprites/60.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 61,
      "avatar": require('./images/avatars/061.png'),
      "name": "Poliwhirl",
      "type": [
        "water"
      ],
      "classification": "Tadpole Pokémon",
      "evolution": "Evolve Poliwag (Lv. 25)",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Bulk Up",
          "type": "fighting",
          "attack": "0",
          "wait": "8",
          "description": "The user tenses its muscles to bulk up its body, raising the damage it deals for a while. This also reduces the damage the user takes.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Critical Hit Damage +5%",
          "Movement Speed +30%"
        ],
        [
          "ATK of Water Type Moves +15%",
          "Water Type Moves Wait -15%",
          "Water Type Damage Taken -25%"
        ],
        [
          "ATK of Water Type Moves +20%",
          "ATK +300",
          "HP +300"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "350",
      "baseAtk": "350",
      "sprite": require('./images/sprites/61.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 62,
      "avatar": require('./images/avatars/062.png'),
      "name": "Poliwrath",
      "type": [
        "water",
        "fighting"
      ],
      "classification": "Tadpole Pokémon",
      "evolution": "Evolve Poliwhirl (Lv. 36)",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Bulk Up",
          "type": "fighting",
          "attack": "0",
          "wait": "8",
          "description": "The user tenses its muscles to bulk up its body, raising the damage it deals for a while. This also reduces the damage the user takes.",
          "learnable": true
        },
        {
          "name": "Dynamic Punch",
          "type": "fighting",
          "attack": "87",
          "wait": "5",
          "description": "The user punches enemies directly in front of itself with its full, concentrated power. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Ice Punch",
          "type": "ice",
          "attack": "175",
          "wait": "5",
          "description": "The user chills its fist and unleashes a freezing punch on enemies directly in front of it. Sometimes freezes enemies.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Power-Up Punch",
          "type": "fighting",
          "attack": "64",
          "wait": "5",
          "description": "The user delivers a punch with its hard fist to enemies directly in front of itself, damaging them. Often raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Critical Hit Damage +5%",
          "Movement Speed +30%"
        ],
        [
          "ATK of Water Type Moves +10%",
          "Water Type Moves Wait -10%",
          "Water Type Damage Taken -25%"
        ],
        [
          "ATK of Water Type Moves +15%",
          "ATK of Fighting Type Moves +20%",
          "Water Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "350",
      "baseAtk": "450",
      "sprite": require('./images/sprites/62.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 63,
      "avatar": require('./images/avatars/063.png'),
      "name": "Abra",
      "type": [
        "psychic"
      ],
      "classification": "Psi Pokémon",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Teleport",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user utilizes its psychic powers to teleport.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Psychic Type Moves Wait -5%",
          "Resistant to ↓ Effects +10%",
          "Movement Speed +30%"
        ],
        [
          "Psychic Type Moves Wait -20%",
          "Resistant to Poisoned +100%",
          "Movement Speed +40%"
        ],
        [
          "ATK of Psychic Type Moves +30%",
          "Resistant to Burned +100%",
          "ATK +550"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "45",
      "baseAtk": "155",
      "sprite": require('./images/sprites/63.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 64,
      "avatar": require('./images/avatars/064.png'),
      "name": "Kadabra",
      "type": [
        "psychic"
      ],
      "classification": "Psi Pokémon",
      "evolution": "Evolve Abra (Lv. 16)",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Dazzling Gleam",
          "type": "fairy",
          "attack": "146",
          "wait": "5",
          "description": "The user moves about as it emits a powerful flash that damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Teleport",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user utilizes its psychic powers to teleport.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Psychic Type Moves Wait -5%",
          "Resistant to ↓ Effects +10%",
          "Movement Speed +30%"
        ],
        [
          "Psychic Type Moves Wait -15%",
          "Resistant to Poisoned +100%",
          "Movement Speed +40%"
        ],
        [
          "ATK of Psychic Type Moves +25%",
          "Resistant to Burned +100%",
          "ATK +250"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "90",
      "baseAtk": "410",
      "sprite": require('./images/sprites/64.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 65,
      "avatar": require('./images/avatars/065.png'),
      "name": "Alakazam",
      "type": [
        "psychic"
      ],
      "classification": "Psi Pokémon",
      "evolution": "Evolve Kadabra (Lv. 36)",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Dazzling Gleam",
          "type": "fairy",
          "attack": "146",
          "wait": "5",
          "description": "The user moves about as it emits a powerful flash that damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Psycho Cut",
          "type": "psychic",
          "attack": "311",
          "wait": "5",
          "description": "After moving forward, the user deals damage to enemies with blades formed by psychic power. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Recover",
          "type": "normal",
          "attack": "0",
          "wait": "9",
          "description": "Restoring its own cells, the user restores its HP.",
          "learnable": true
        },
        {
          "name": "Shadow Ball",
          "type": "ghost",
          "attack": "63",
          "wait": "7",
          "description": "The user hurls a shadowy blob in front of itself, damaging enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Teleport",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user utilizes its psychic powers to teleport.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Psychic Type Moves Wait -5%",
          "Resistant to ↓ Effects +10%",
          "Movement Speed +30%"
        ],
        [
          "Psychic Type Moves Wait -10%",
          "Resistant to Poisoned +100%",
          "Movement Speed +40%"
        ],
        [
          "ATK of Psychic Type Moves +20%",
          "Resistant to Burned +100%",
          "Movement Speed +50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "100",
      "baseAtk": "700",
      "sprite": require('./images/sprites/65.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 66,
      "avatar": require('./images/avatars/066.png'),
      "name": "Machop",
      "type": [
        "fighting"
      ],
      "classification": "Superpower Pokémon",
      "moves": [
        {
          "name": "Bulk Up",
          "type": "fighting",
          "attack": "0",
          "wait": "8",
          "description": "The user tenses its muscles to bulk up its body, raising the damage it deals for a while. This also reduces the damage the user takes.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Rolling Kick",
          "type": "fighting",
          "attack": "156",
          "wait": "5",
          "description": "The user kicks as it spins in place, dealing damage to surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Submission",
          "type": "fighting",
          "attack": "130",
          "wait": "5",
          "description": "The user spins toward enemies in front of itself, smashing into them. Deals damage to enemies hit by the user as it whirls around.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Fighting Type Moves +5%",
          "Fighting Type Moves Wait -5%",
          "Own Knockback Distance -10%"
        ],
        [
          "ATK of Fighting Type Moves +20%",
          "Fighting Type Moves Wait -20%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Fighting Type Moves +20%",
          "Fighting Type Moves Wait -20%",
          "ATK + 450"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/66.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 67,
      "avatar": require('./images/avatars/067.png'),
      "name": "Machoke",
      "type": [
        "fighting"
      ],
      "classification": "Superpower Pokémon",
      "evolution": "Evolve Machop (Lv. 28)",
      "moves": [
        {
          "name": "Bulk Up",
          "type": "fighting",
          "attack": "0",
          "wait": "8",
          "description": "The user tenses its muscles to bulk up its body, raising the damage it deals for a while. This also reduces the damage the user takes.",
          "learnable": true
        },
        {
          "name": "Cross Chop",
          "type": "fighting",
          "attack": "273",
          "wait": "5",
          "description": "The user jumps toward enemies in front of itself and smacks them with a two-handed chop, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Rolling Kick",
          "type": "fighting",
          "attack": "156",
          "wait": "5",
          "description": "The user kicks as it spins in place, dealing damage to surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Submission",
          "type": "fighting",
          "attack": "130",
          "wait": "5",
          "description": "The user spins toward enemies in front of itself, smashing into them. Deals damage to enemies hit by the user as it whirls around.",
          "learnable": true
        },
        {
          "name": "Work Up",
          "type": "normal",
          "attack": "0",
          "wait": "8",
          "description": "The user is roused, raising the amount of damage it deals and reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Fighting Type Moves +5%",
          "Fighting Type Moves Wait -5%",
          "Own Knockback Distance -10%"
        ],
        [
          "ATK of Fighting Type Moves +15%",
          "Fighting Type Moves Wait -15%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Fighting Type Moves +15%",
          "Fighting Type Moves Wait -15%",
          "Critical Hit Rate +20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "200",
      "baseAtk": "500",
      "sprite": require('./images/sprites/67.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 68,
      "avatar": require('./images/avatars/068.png'),
      "name": "Machamp",
      "type": [
        "fighting"
      ],
      "classification": "Superpower Pokémon",
      "evolution": "Evolve Machoke (Lv. 36)",
      "moves": [
        {
          "name": "Bulk Up",
          "type": "fighting",
          "attack": "0",
          "wait": "8",
          "description": "The user tenses its muscles to bulk up its body, raising the damage it deals for a while. This also reduces the damage the user takes.",
          "learnable": true
        },
        {
          "name": "Close Combat",
          "type": "fighting",
          "attack": "245",
          "wait": "5",
          "description": "The user gets right up on enemies in front of itself and smacks them with a single blow, damaging them. Sometimes raises the amount of damage the user takes.",
          "learnable": true
        },
        {
          "name": "Cross Chop",
          "type": "fighting",
          "attack": "273",
          "wait": "5",
          "description": "The user jumps toward enemies in front of itself and smacks them with a two-handed chop, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Dynamic Punch",
          "type": "fighting",
          "attack": "87",
          "wait": "5",
          "description": "The user punches enemies directly in front of itself with its full, concentrated power. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Power-Up Punch",
          "type": "fighting",
          "attack": "64",
          "wait": "5",
          "description": "The user delivers a punch with its hard fist to enemies directly in front of itself, damaging them. Often raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Rolling Kick",
          "type": "fighting",
          "attack": "156",
          "wait": "5",
          "description": "The user kicks as it spins in place, dealing damage to surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Work Up",
          "type": "normal",
          "attack": "0",
          "wait": "8",
          "description": "The user is roused, raising the amount of damage it deals and reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Fighting Type Moves +5%",
          "Fighting Type Moves Wait -5%",
          "Own Knockback Distance -10%"
        ],
        [
          "ATK of Fighting Type Moves +10%",
          "Fighting Type Moves Wait -10%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Fighting Type Moves +10%",
          "Fighting Type Moves Wait -10%",
          "ATK of Normal Type Moves +20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "250",
      "baseAtk": "550",
      "sprite": require('./images/sprites/68.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 69,
      "avatar": require('./images/avatars/069.png'),
      "name": "Bellsprout",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Flower Pokémon",
      "moves": [
        {
          "name": "Bullet Seed",
          "type": "grass",
          "attack": "168",
          "wait": "7",
          "description": "The user sends several seeds flying out in front of itself simultaneously, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Razor Leaf",
          "type": "grass",
          "attack": "118",
          "wait": "7",
          "description": "The user launches sharp-edged leaves to slash at enemies, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Grass Type Moves Wait -5%",
          "ATK of Grass Type Moves + 5%",
          "Critical Hit Rate +5%"
        ],
        [
          "Resistant to Poisoned +100%",
          "ATK of Grass Type Moves + 20%",
          "Critical Hit Rate +20%"
        ],
        [
          "ATK +550",
          "ATK of Grass Type Moves + 20%",
          "Critical Hit Damage +20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/69.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 70,
      "avatar": require('./images/avatars/070.png'),
      "name": "Weepinbell",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Flycatcher Pokémon",
      "evolution": "Evolve Bellsprout (Lv. 21)",
      "moves": [
        {
          "name": "Bullet Seed",
          "type": "grass",
          "attack": "168",
          "wait": "7",
          "description": "The user sends several seeds flying out in front of itself simultaneously, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Razor Leaf",
          "type": "grass",
          "attack": "118",
          "wait": "7",
          "description": "The user launches sharp-edged leaves to slash at enemies, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Vine Whip",
          "type": "grass",
          "attack": "237",
          "wait": "5",
          "description": "The user strikes enemies in front of itself with whiplike vines. Deals damage to enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Grass Type Moves Wait -5%",
          "ATK of Grass Type Moves + 5%",
          "Critical Hit Rate +5%"
        ],
        [
          "Resistant to Poisoned +100%",
          "ATK of Grass Type Moves + 15%",
          "Critical Hit Rate +15%"
        ],
        [
          "ATK +300",
          "ATK of Grass Type Moves + 15%",
          "Critical Hit Damage +15%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "250",
      "baseAtk": "350",
      "sprite": require('./images/sprites/70.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 71,
      "avatar": require('./images/avatars/071.png'),
      "name": "Victreebel",
      "type": [
        "grass",
        "poison"
      ],
      "classification": "Flycatcher Pokémon",
      "evolution": "Evolve Weepinbell (Lv. 36)",
      "moves": [
        {
          "name": "Bullet Seed",
          "type": "grass",
          "attack": "168",
          "wait": "7",
          "description": "The user sends several seeds flying out in front of itself simultaneously, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Hyper Beam",
          "type": "normal",
          "attack": "300",
          "wait": "10",
          "description": "The user stores up power and then fires a tremendous beam at enemies. Deals severe damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Solar Beam",
          "type": "grass",
          "attack": "227",
          "wait": "7",
          "description": "The user gathers light and unleashes it in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Vine Whip",
          "type": "grass",
          "attack": "237",
          "wait": "5",
          "description": "The user strikes enemies in front of itself with whiplike vines. Deals damage to enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Grass Type Moves Wait -5%",
          "ATK of Grass Type Moves + 5%",
          "Critical Hit Rate +5%"
        ],
        [
          "Resistant to Poisoned +100%",
          "ATK of Grass Type Moves + 10%",
          "Critical Hit Rate +10%"
        ],
        [
          "Grass Type Moves Wait -10%",
          "ATK of Grass Type Moves + 10%",
          "Critical Hit Damage +10%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "300",
      "baseAtk": "500",
      "sprite": require('./images/sprites/71.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 72,
      "avatar": require('./images/avatars/072.png'),
      "name": "Tentacool",
      "type": [
        "water",
        "poison"
      ],
      "classification": "Jellyfish Pokémon",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Natural HP Healing +10%",
          "Water Type Moves Wait - 5%",
          "Resistant to ↓ Effects +20%"
        ],
        [
          "Resistant to ↓ Effects +30%",
          "Water Type Moves Wait -15%",
          "Resistant to Poisoned +100%"
        ],
        [
          "HP +500",
          "Water Type Moves Wait -20%",
          "Reasistant to ↓ Effects 50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "90",
      "baseAtk": "110",
      "sprite": require('./images/sprites/72.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 73,
      "avatar": require('./images/avatars/073.png'),
      "name": "Tentacruel",
      "type": [
        "water",
        "poison"
      ],
      "classification": "Jellyfish Pokémon",
      "evolution": "Evolve Tentacool (Lv. 30)",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Confuse Ray",
          "type": "ghost",
          "attack": "0",
          "wait": "3",
          "description": "The user exposes surrounding enemies to a sinister ray, often confusing them.",
          "learnable": true
        },
        {
          "name": "Hydro Pump",
          "type": "water",
          "attack": "213",
          "wait": "5",
          "description": "The user shoots four pillars of water up from the ground and sends them out in front of itself. Deals damage to enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Poison Sting",
          "type": "poison",
          "attack": "107",
          "wait": "7",
          "description": "The user fires a poisonous stinger at enemies in front of itself. Sometimes poisons enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Supersonic",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user generates odd sound waves from its body, often confusing surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Natural HP Healing +10%",
          "Water Type Moves Wait - 5%",
          "Resistant to ↓ Effects +20%"
        ],
        [
          "Resistant to ↓ Effects +30%",
          "Water Type Moves Wait -10%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Natural HP Healing +20%",
          "Water Type Moves Wait -15%",
          "Resistant to ↓ Effects +50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "550",
      "baseAtk": "150",
      "sprite": require('./images/sprites/73.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 74,
      "avatar": require('./images/avatars/074.png'),
      "name": "Geodude",
      "type": [
        "rock",
        "ground"
      ],
      "classification": "Rock Pokémon",
      "moves": [
        {
          "name": "Charge",
          "type": "electric",
          "attack": "0",
          "wait": "9",
          "description": "The user stores up electricity, raising the damage it deals and making it resistant to negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "ATK of Ground Type Moves +5%",
          "Own Knockback Distance -10%"
        ],
        [
          "ATK of Normal Type Moves +20%",
          "ATK of Ground Type Moves +20%",
          "Own Knockback Distance -20%"
        ],
        [
          "HP +550",
          "ATK of Ground Type Moves +25%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "140",
      "baseAtk": "60",
      "sprite": require('./images/sprites/74.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 75,
      "avatar": require('./images/avatars/075.png'),
      "name": "Graveler",
      "type": [
        "rock",
        "ground"
      ],
      "classification": "Rock Pokémon",
      "evolution": "Evolve Geodude (Lv. 24)",
      "moves": [
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Self-Destruct",
          "type": "normal",
          "attack": "494",
          "wait": "5",
          "description": "The user approaches enemies and causes an explosion, damaging all surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Stealth Rock",
          "type": "rock",
          "attack": "120",
          "wait": "5",
          "description": "The user creates pillars of stone from the ground, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "ATK of Ground Type Moves +5%",
          "Own Knockback Distance -10%"
        ],
        [
          "ATK of Normal Type Moves +15%",
          "ATK of Ground Type Moves +15%",
          "Critical Hit Damage +20%"
        ],
        [
          "ATK +450",
          "ATK of Ground  Type Moves  +20%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "610",
      "baseAtk": "90",
      "sprite": require('./images/sprites/75.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 76,
      "avatar": require('./images/avatars/076.png'),
      "name": "Golem",
      "type": [
        "rock",
        "ground"
      ],
      "classification": "Megaton Pokémon",
      "evolution": "Evolve Graveler (Lv. 36)",
      "moves": [
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Explosion",
          "type": "normal",
          "attack": "683",
          "wait": "5",
          "description": "The user causes a tremendous explosion, dealing huge damage to surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Rock Polish",
          "type": "rock",
          "attack": "0",
          "wait": "2",
          "description": "The user polishes its body to reduce drag, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Self-Destruct",
          "type": "normal",
          "attack": "494",
          "wait": "5",
          "description": "The user approaches enemies and causes an explosion, damaging all surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Stealth Rock",
          "type": "rock",
          "attack": "120",
          "wait": "5",
          "description": "The user creates pillars of stone from the ground, damaging enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "ATK of Ground Type Moves +5%",
          "Own Knockback Distance -10%"
        ],
        [
          "ATK of Normal Type Moves +10%",
          "ATK of Ground Type Moves +10%",
          "Critical Hit Damage +20%"
        ],
        [
          "ATK of Normal Type Moves +20%",
          "ATK of Ground Type Moves +15%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "700",
      "baseAtk": "100",
      "sprite": require('./images/sprites/76.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 77,
      "avatar": require('./images/avatars/077.png'),
      "name": "Ponyta",
      "type": [
        "fire"
      ],
      "classification": "Fire Horse Pokémon",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Bounce",
          "type": "flying",
          "attack": "186",
          "wait": "5",
          "description": "The user bounces forward high into the air twice, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Fire Spin",
          "type": "fire",
          "attack": "97",
          "wait": "5",
          "description": "The user creates flames all around itself and fires them off in a spiral. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flame Charge",
          "type": "fire",
          "attack": "0",
          "wait": "5",
          "description": "The user stores up the power of flames, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Self-Destruct",
          "type": "normal",
          "attack": "494",
          "wait": "5",
          "description": "The user approaches enemies and causes an explosion, damaging all surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Moves Wait -5%",
          "ATK of Fire Type Moves +5%",
          "Movement Speed +30%"
        ],
        [
          "Fire Type Moves Wait -15%",
          "Resistant to Burned +100%",
          "Movement Speed +40%"
        ],
        [
          "Fire Type Moves Wait -20%",
          "Fire Type Damage Taken -50%",
          "ATK + 500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "100",
      "sprite": require('./images/sprites/77.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 78,
      "avatar": require('./images/avatars/078.png'),
      "name": "Rapidash",
      "type": [
        "fire"
      ],
      "classification": "Fire Horse Pokémon",
      "evolution": "Evolve Ponyta (Lv. 40)",
      "moves": [
        {
          "name": "Bounce",
          "type": "flying",
          "attack": "186",
          "wait": "5",
          "description": "The user bounces forward high into the air twice, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Confuse Ray",
          "type": "ghost",
          "attack": "0",
          "wait": "3",
          "description": "The user exposes surrounding enemies to a sinister ray, often confusing them.",
          "learnable": true
        },
        {
          "name": "Fire Blast",
          "type": "fire",
          "attack": "179",
          "wait": "5",
          "description": "The user sprays an all-consuming fire on the ground, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Fire Spin",
          "type": "fire",
          "attack": "97",
          "wait": "5",
          "description": "The user creates flames all around itself and fires them off in a spiral. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flame Charge",
          "type": "fire",
          "attack": "0",
          "wait": "5",
          "description": "The user stores up the power of flames, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flare Blitz",
          "type": "fire",
          "attack": "128",
          "wait": "5",
          "description": "The user creates a path of flames in front of itself and charges forward along it. Deals damage to enemies. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Megahorn",
          "type": "bug",
          "attack": "513",
          "wait": "5",
          "description": "Using its tough and impressive horn, the user rams into enemies in front of itself with no letup, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Self-Destruct",
          "type": "normal",
          "attack": "494",
          "wait": "5",
          "description": "The user approaches enemies and causes an explosion, damaging all surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        },
        {
          "name": "Will-O-Wisp",
          "type": "fire",
          "attack": "19",
          "wait": "3",
          "description": "The user drapes itself with sinister flames and attacks enemies directly in front of it. Often burns enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Moves Wait -5%",
          "ATK of Fire Type Moves +5%",
          "Movement Speed +30%"
        ],
        [
          "Fire Type Moves Wait -10%",
          "Resistant to Burned +100%",
          "Movement Speed +40%"
        ],
        [
          "Fire Type Moves Wait -15%",
          "Fire Type Damage Taken -50%",
          "ATK of Fire Type Moves +25%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "400",
      "baseAtk": "400",
      "sprite": require('./images/sprites/78.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 79,
      "avatar": require('./images/avatars/079.png'),
      "name": "Slowpoke",
      "type": [
        "water",
        "psychic"
      ],
      "classification": "Dopey Pokémon",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Ice Punch",
          "type": "ice",
          "attack": "175",
          "wait": "5",
          "description": "The user chills its fist and unleashes a freezing punch on enemies directly in front of it. Sometimes freezes enemies.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Zen Headbutt",
          "type": "psychic",
          "attack": "370",
          "wait": "5",
          "description": "The user focuses its willpower to its head, then smashes it into enemies directly in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Healing per Wave +30%",
          "Time to Recover -10%",
          "HP +100"
        ],
        [
          "Resistant to Confused +100%",
          "HP upon Recovery +10%",
          "HP +200"
        ],
        [
          "Healing per Wave +40%",
          "Time to Recover -20%",
          "HP + 350"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "130",
      "baseAtk": "70",
      "sprite": require('./images/sprites/79.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 80,
      "avatar": require('./images/avatars/080.png'),
      "name": "Slowbro",
      "type": [
        "water",
        "psychic"
      ],
      "classification": "Hermit Crab Pokémon",
      "evolution": "Evolve Slowpoke (Lv. 37)",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Belly Drum",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user uses its own HP to raise all of its stats for a while.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Ice Punch",
          "type": "ice",
          "attack": "175",
          "wait": "5",
          "description": "The user chills its fist and unleashes a freezing punch on enemies directly in front of it. Sometimes freezes enemies.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Rest",
          "type": "psychic",
          "attack": "0",
          "wait": "9",
          "description": "The user rests in place, greatly restoring its HP.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Withdraw",
          "type": "water",
          "attack": "0",
          "wait": "5",
          "description": "The user withdraws into its hard shell, reducing the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Zen Headbutt",
          "type": "psychic",
          "attack": "370",
          "wait": "5",
          "description": "The user focuses its willpower to its head, then smashes it into enemies directly in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Healing per Wave +20%",
          "Time to Recover -10%",
          "Taking Critical Hits Rate -25%"
        ],
        [
          "Resistant to Confused +100%",
          "HP upon Recovery +10%",
          "Taking Critical Hits Rate -25%"
        ],
        [
          "Healing per Wave +30%",
          "Time to Recover -15%",
          "Taking Critical Hits Rate -50%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "650",
      "baseAtk": "150",
      "sprite": require('./images/sprites/80.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 81,
      "avatar": require('./images/avatars/081.png'),
      "name": "Magnemite",
      "type": [
        "electric",
        "steel"
      ],
      "classification": "Magnet Pokémon",
      "moves": [
        {
          "name": "Charge",
          "type": "electric",
          "attack": "0",
          "wait": "9",
          "description": "The user stores up electricity, raising the damage it deals and making it resistant to negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Electroweb",
          "type": "electric",
          "attack": "0",
          "wait": "2",
          "description": "The user spreads an electric net out directly in front of itself, lowering the movement speed of enemies hit by it for a while.",
          "learnable": true
        },
        {
          "name": "Flash Cannon",
          "type": "steel",
          "attack": "170",
          "wait": "7",
          "description": "The user focuses all of its light energy into a single point and fires a beam in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        },
        {
          "name": "Metal Sound",
          "type": "steel",
          "attack": "0",
          "wait": "3",
          "description": "Enemies near the user are forced to listen to a horrible sound like metal scraping, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Supersonic",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user generates odd sound waves from its body, often confusing surrounding enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Electric Type Moves +5%",
          "Electric Type Moves Wait -5%",
          "Steel Type Moves Wait -10%"
        ],
        [
          "ATK of Electric Type Moves +15%",
          "Electric Type Moves Wait -15%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Resistant to Paralyzed +100%",
          "Steel Type Moves Wait -15%",
          "ATK +500"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/81.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 82,
      "avatar": require('./images/avatars/082.png'),
      "name": "Magneton",
      "type": [
        "electric",
        "steel"
      ],
      "classification": "Magnet Pokémon",
      "evolution": "Evolve Magnemite (Lv. 30)",
      "moves": [
        {
          "name": "Charge",
          "type": "electric",
          "attack": "0",
          "wait": "9",
          "description": "The user stores up electricity, raising the damage it deals and making it resistant to negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Electric Terrain",
          "type": "electric",
          "attack": "0",
          "wait": "5",
          "description": "The user gathers electrical power beneath itself, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Explosion",
          "type": "normal",
          "attack": "683",
          "wait": "5",
          "description": "The user causes a tremendous explosion, dealing huge damage to surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Flash Cannon",
          "type": "steel",
          "attack": "170",
          "wait": "7",
          "description": "The user focuses all of its light energy into a single point and fires a beam in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Metal Sound",
          "type": "steel",
          "attack": "0",
          "wait": "3",
          "description": "Enemies near the user are forced to listen to a horrible sound like metal scraping, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Supersonic",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user generates odd sound waves from its body, often confusing surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Thunder",
          "type": "electric",
          "attack": "204",
          "wait": "5",
          "description": "The user strikes the area in front of itself with a lightning bolt. Deals damage to nearby enemies. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunderbolt",
          "type": "electric",
          "attack": "80",
          "wait": "5",
          "description": "The user discharges tremendous electricity all around itself. Deals damage to enemies around the user. Sometimes paralyzes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Electric Type Moves +5%",
          "Electric Type Moves Wait -5%",
          "Steel Type Moves Wait -10%"
        ],
        [
          "ATK of Electric Type Moves +10%",
          "Electric Type Moves Wait -10%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Resistant to Paralyzed +100%",
          "Normal Type Moves Wait -10%",
          "ATK of Electric Type Moves +30%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "300",
      "baseAtk": "400",
      "sprite": require('./images/sprites/82.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 83,
      "avatar": require('./images/avatars/083.png'),
      "name": "Farfetch'd",
      "type": [
        "normal",
        "flying"
      ],
      "classification": "Wild Duck Pokémon",
      "moves": [
        {
          "name": "Gust",
          "type": "flying",
          "attack": "61",
          "wait": "7",
          "description": "The user sends an intense gust of wind out in front of itself that whirls around and damages enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Heat Wave",
          "type": "fire",
          "attack": "123",
          "wait": "7",
          "description": "The user exhales hot breath in front of itself, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Night Slash",
          "type": "dark",
          "attack": "83",
          "wait": "5",
          "description": "The user dashes forward, slashing surrounding enemies and damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Roost",
          "type": "flying",
          "attack": "0",
          "wait": "9",
          "description": "The user briefly rests its body, restoring a bit of its HP.",
          "learnable": true
        },
        {
          "name": "Sky Attack",
          "type": "flying",
          "attack": "125",
          "wait": "5",
          "description": "After flying up and bracing itself, the user charges at enemies directly in front of itself, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Steel Wing",
          "type": "steel",
          "attack": "81",
          "wait": "5",
          "description": "The user charges at enemies in front of itself and smacks them with its hard wings, dealing damage. Sometimes reduces the amount of damage the user takes.",
          "learnable": true
        },
        {
          "name": "Sucker Punch",
          "type": "dark",
          "attack": "130",
          "wait": "5",
          "description": "The user briefly disappears and moves a short distance. It then charges toward enemies, damaging them.",
          "learnable": true
        },
        {
          "name": "Swords Dance",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "With a frenetic dance to uplift the fighting spirit, the user raises the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tailwind",
          "type": "flying",
          "attack": "0",
          "wait": "2",
          "description": "The user creates an intense swirling wind that raises its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "U-turn",
          "type": "bug",
          "attack": "243",
          "wait": "5",
          "description": "After attacking surrounding enemies, the user moves back to dodge enemies' counterattacks.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Flying Type Moves Wait -10%",
          "Critical Hit Rate +15%",
          "Critical Hit Damage +10%"
        ],
        [
          "Flying Type Moves Wait -10%",
          "Critical Hit Rate +10%",
          "Critical Hit Damage +20%"
        ],
        [
          "Flying Type Moves Wait -15%",
          "Critical Hit Rate +20%",
          "ATK +300"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "350",
      "baseAtk": "350",
      "sprite": require('./images/sprites/83.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          165,
          3300,
          3300
        ],
        "type": [
          0,
          225,
          4500,
          4500
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 84,
      "avatar": require('./images/avatars/084.png'),
      "name": "Doduo",
      "type": [
        "normal",
        "flying"
      ],
      "classification": "Twin Bird Pokémon",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Drill Peck",
          "type": "flying",
          "attack": "321",
          "wait": "5",
          "description": "The user attacks enemies directly in front of itself with its sharp beak, damaging them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Wait for Standard Attacks -20%",
          "Flying Type Move Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "Wait for Standard Attacks -30%",
          "Flying Type Moves Wait -15%",
          "Movement Speed +40%"
        ],
        [
          "Movement Speed +50%",
          "Flying Type Moves Wait -20%",
          "ATK +500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/84.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 85,
      "avatar": require('./images/avatars/085.png'),
      "name": "Dodrio",
      "type": [
        "normal",
        "flying"
      ],
      "classification": "Triple Bird Pokémon",
      "evolution": "Evolve Doduo (Lv. 31)",
      "moves": [
        {
          "name": "Aerial Ace",
          "type": "flying",
          "attack": "124",
          "wait": "5",
          "description": "The user quickly slashes in front of itself twice, dealing damage.",
          "learnable": true
        },
        {
          "name": "Drill Peck",
          "type": "flying",
          "attack": "321",
          "wait": "5",
          "description": "The user attacks enemies directly in front of itself with its sharp beak, damaging them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Swords Dance",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "With a frenetic dance to uplift the fighting spirit, the user raises the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tailwind",
          "type": "flying",
          "attack": "0",
          "wait": "2",
          "description": "The user creates an intense swirling wind that raises its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Tri Attack",
          "type": "normal",
          "attack": "81",
          "wait": "5",
          "description": "The user's body is imbued with three powers as it attacks enemies in front of itself, damaging them. Sometimes burns, paralyzes, or freezes enemies.",
          "learnable": true
        },
        {
          "name": "Work Up",
          "type": "normal",
          "attack": "0",
          "wait": "8",
          "description": "The user is roused, raising the amount of damage it deals and reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Wait for Standard Attacks -20%",
          "Flying Type Move Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "Wait for Standard Attacks -25%",
          "Flying Type Moves Wait -10%",
          "Movement Speed +40%"
        ],
        [
          "Movement Speed +50%",
          "Flying Type Moves Wait -15%",
          "ATK of Normal Type Moves +30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "200",
      "baseAtk": "500",
      "sprite": require('./images/sprites/85.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 86,
      "avatar": require('./images/avatars/086.png'),
      "name": "Seel",
      "type": [
        "water"
      ],
      "classification": "Sea Lion Pokémon",
      "moves": [
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Lick",
          "type": "ghost",
          "attack": "233",
          "wait": "5",
          "description": "The user licks enemies all around itself with its long tongue, damaging them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Water Type Moves Wait -5%",
          "ATK of Water Type Moves +5%",
          "Resistant to Status Conditions +10%"
        ],
        [
          "Fire Type Damage Taken -25%",
          "Resistant to Status Conditions +30%",
          "Ice Type Damage Taken -25%"
        ],
        [
          "Fire Type Damage Taken -25%",
          "HP +550",
          "Ice Type Damage Taken -25%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "110",
      "baseAtk": "90",
      "sprite": require('./images/sprites/86.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 87,
      "avatar": require('./images/avatars/087.png'),
      "name": "Dewgong",
      "type": [
        "water",
        "ice"
      ],
      "classification": "Sea Lion Pokémon",
      "evolution": "Evolve Seel (Lv. 34)",
      "moves": [
        {
          "name": "Aqua Ring",
          "type": "water",
          "attack": "0",
          "wait": "9",
          "description": "The user envelops itself in a veil made of water, restoring some of its HP.",
          "learnable": true
        },
        {
          "name": "Aurora Veil",
          "type": "ice",
          "attack": "0",
          "wait": "7",
          "description": "The user cloaks itself in a veil of light, reducing the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Lick",
          "type": "ghost",
          "attack": "233",
          "wait": "5",
          "description": "The user licks enemies all around itself with its long tongue, damaging them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Rest",
          "type": "psychic",
          "attack": "0",
          "wait": "9",
          "description": "The user rests in place, greatly restoring its HP.",
          "learnable": true
        },
        {
          "name": "Slam",
          "type": "normal",
          "attack": "211",
          "wait": "5",
          "description": "The user slams nearby enemies with a long tail, vines, or the like, damaging all of them.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Water Type Moves Wait -5%",
          "ATK of Water Type Moves +5%",
          "Resistant to Status Conditions +10%"
        ],
        [
          "Fire Type Damage Taken -25%",
          "Resistant to Frozen 100%",
          "Ice Type Damage Taken -25%"
        ],
        [
          "Fire Type Damage Taken -25%",
          "Natural HP Healing +10%",
          "Ice Type Damage Taken -25%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "500",
      "baseAtk": "200",
      "sprite": require('./images/sprites/87.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 88,
      "avatar": require('./images/avatars/088.png'),
      "name": "Grimer",
      "type": [
        "poison"
      ],
      "classification": "Sludge Pokémon",
      "moves": [
        {
          "name": "Acid Armor",
          "type": "poison",
          "attack": "0",
          "wait": "5",
          "description": "The user alters its cellular structure to liquefy itself, reducing the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Slam",
          "type": "normal",
          "attack": "211",
          "wait": "5",
          "description": "The user slams nearby enemies with a long tail, vines, or the like, damaging all of them.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Toxic",
          "type": "poison",
          "attack": "59",
          "wait": "4",
          "description": "The user sprays a powerful poison around itself, often poisoning enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Venom Drench",
          "type": "poison",
          "attack": "118",
          "wait": "5",
          "description": "The user spews poison in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Poison Type Moves Wait -5%",
          "Natural HP Healing +10%",
          "Pokémon Size Change -10%"
        ],
        [
          "Poison Type Moves Wait -15%",
          "Pokémon Size Change -15%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Pokémon Size Change -25%",
          "HP +550",
          "Poison Type Moves Wait -20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "110",
      "baseAtk": "90",
      "sprite": require('./images/sprites/88.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 89,
      "avatar": require('./images/avatars/089.png'),
      "name": "Muk",
      "type": [
        "poison"
      ],
      "classification": "Sludge Pokémon",
      "evolution": "Evolve Grimer (Lv. 38)",
      "moves": [
        {
          "name": "Acid Armor",
          "type": "poison",
          "attack": "0",
          "wait": "5",
          "description": "The user alters its cellular structure to liquefy itself, reducing the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Lick",
          "type": "ghost",
          "attack": "233",
          "wait": "5",
          "description": "The user licks enemies all around itself with its long tongue, damaging them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Power-Up Punch",
          "type": "fighting",
          "attack": "64",
          "wait": "5",
          "description": "The user delivers a punch with its hard fist to enemies directly in front of itself, damaging them. Often raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Slam",
          "type": "normal",
          "attack": "211",
          "wait": "5",
          "description": "The user slams nearby enemies with a long tail, vines, or the like, damaging all of them.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Venom Drench",
          "type": "poison",
          "attack": "118",
          "wait": "5",
          "description": "The user spews poison in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Poison Type  Moves Wait  -5%",
          "Natural HP Healing +10%",
          "Pokémon Size Change -10%"
        ],
        [
          "Poison Type Moves Wait 10%",
          "Pokémon Size Change -15%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Pokémon Size Change -25%",
          "Natural HP Healing +20%",
          "Poison Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "650",
      "baseAtk": "150",
      "sprite": require('./images/sprites/89.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 90,
      "avatar": require('./images/avatars/090.png'),
      "name": "Shellder",
      "type": [
        "water"
      ],
      "classification": "Bivalve Pokémon",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Iron Defense",
          "type": "steel",
          "attack": "0",
          "wait": "5",
          "description": "The user hardens its skin until it's like iron, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Withdraw",
          "type": "water",
          "attack": "0",
          "wait": "5",
          "description": "The user withdraws into its hard shell, reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Resistant to Status Conditions +10%",
          "Taking Critical Hits Rate -25%",
          "Movement Speed +30%"
        ],
        [
          "Resistant to Status Conditions +30%",
          "Taking Critical Hits Rate -25%",
          "Movement Speed +40%"
        ],
        [
          "Water Type Moves Wait -20%",
          "Taking Critical Hits Rate -50%",
          "Natural HP Healing +20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "120",
      "baseAtk": "80",
      "sprite": require('./images/sprites/90.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 91,
      "avatar": require('./images/avatars/091.png'),
      "name": "Cloyster",
      "type": [
        "water",
        "ice"
      ],
      "classification": "Bivalve Pokémon",
      "evolution": "Evolve Shellder (Lv. 36)",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icicle Crash",
          "type": "ice",
          "attack": "143",
          "wait": "5",
          "description": "The user drops frigid icicles in front of itself. Deals damage to enemies hit by them and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Rock Blast",
          "type": "rock",
          "attack": "168",
          "wait": "7",
          "description": "The user hurls hard rocks in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Spikes",
          "type": "ground",
          "attack": "221",
          "wait": "5",
          "description": "The user scatters spikes in front of itself, damaging enemies that step on them.",
          "learnable": true
        },
        {
          "name": "Supersonic",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user generates odd sound waves from its body, often confusing surrounding enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Resistant to Status Conditions +10%",
          "Taking Critical Hits Rate -25%",
          "Movement Speed +30%"
        ],
        [
          "Resistant to Frozen +100%",
          "Taking Critical Hits Rate -25%",
          "Movement Speed +20%"
        ],
        [
          "Ice Type Moves Wait -15%",
          "Taking Critical Hits Rate -50%",
          "Resistant to Status Conditions +40%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "575",
      "baseAtk": "225",
      "sprite": require('./images/sprites/91.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 92,
      "avatar": require('./images/avatars/092.png'),
      "name": "Gastly",
      "type": [
        "ghost",
        "poison"
      ],
      "classification": "Gas Pokémon",
      "moves": [
        {
          "name": "Astonish",
          "type": "ghost",
          "attack": "180",
          "wait": "5",
          "description": "The user tries to startle enemies directly in front of itself, damaging those taken by surprise.",
          "learnable": true
        },
        {
          "name": "Lick",
          "type": "ghost",
          "attack": "233",
          "wait": "5",
          "description": "The user licks enemies all around itself with its long tongue, damaging them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Smog",
          "type": "poison",
          "attack": "188",
          "wait": "5",
          "description": "The user spews poison around itself, damaging enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Sucker Punch",
          "type": "dark",
          "attack": "130",
          "wait": "5",
          "description": "The user briefly disappears and moves a short distance. It then charges toward enemies, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Ghost Type  Moves Wait -5%",
          "ATK of Ghost Type Moves +5%",
          "Normal Type Damage Taken -25%"
        ],
        [
          "ATK of Ghost Type Moves +20%",
          "Resistant to Poisoned +100%",
          "Fighting Type Damage Taken -25%"
        ],
        [
          "ATK +500",
          "Ground Type Damage Taken -50%",
          "Ghost Type Moves Wait -20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "50",
      "baseAtk": "150",
      "sprite": require('./images/sprites/92.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          25,
          500,
          500
        ],
        "type": [
          0,
          125,
          2500,
          2500
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 93,
      "avatar": require('./images/avatars/093.png'),
      "name": "Haunter",
      "type": [
        "ghost",
        "poison"
      ],
      "classification": "Gas Pokémon",
      "evolution": "Evolve Gastly (Lv. 25)",
      "moves": [
        {
          "name": "Astonish",
          "type": "ghost",
          "attack": "180",
          "wait": "5",
          "description": "The user tries to startle enemies directly in front of itself, damaging those taken by surprise.",
          "learnable": true
        },
        {
          "name": "Lick",
          "type": "ghost",
          "attack": "233",
          "wait": "5",
          "description": "The user licks enemies all around itself with its long tongue, damaging them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Smog",
          "type": "poison",
          "attack": "188",
          "wait": "5",
          "description": "The user spews poison around itself, damaging enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Sucker Punch",
          "type": "dark",
          "attack": "130",
          "wait": "5",
          "description": "The user briefly disappears and moves a short distance. It then charges toward enemies, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Ghost Type  Moves Wait -5%",
          "ATK of Ghost Type Moves +5%",
          "Normal Type Damage Taken -25%"
        ],
        [
          "ATK of Ghost Type Moves +15%",
          "Resistant to Poisoned +100%",
          "Fighting Type Damage Taken -25%"
        ],
        [
          "ATK of Ghost Type Moves +20%",
          "Ground Type Damage Taken -50%",
          "Ghost Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "125",
      "baseAtk": "575",
      "sprite": require('./images/sprites/93.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 94,
      "avatar": require('./images/avatars/094.png'),
      "name": "Gengar",
      "type": [
        "ghost",
        "poison"
      ],
      "classification": "Shadow Pokémon",
      "evolution": "Evolve Haunter (Lv. 36)",
      "moves": [
        {
          "name": "Astonish",
          "type": "ghost",
          "attack": "180",
          "wait": "5",
          "description": "The user tries to startle enemies directly in front of itself, damaging those taken by surprise.",
          "learnable": true
        },
        {
          "name": "Confuse Ray",
          "type": "ghost",
          "attack": "0",
          "wait": "3",
          "description": "The user exposes surrounding enemies to a sinister ray, often confusing them.",
          "learnable": true
        },
        {
          "name": "Hypnosis",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user employs hypnotic suggestion, often making enemies in front of itself fall asleep.",
          "learnable": true
        },
        {
          "name": "Lick",
          "type": "ghost",
          "attack": "233",
          "wait": "5",
          "description": "The user licks enemies all around itself with its long tongue, damaging them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Mega Drain",
          "type": "grass",
          "attack": "165",
          "wait": "9",
          "description": "The user attacks enemies in front of itself, dealing damage to them. Some of the damage dealt is absorbed by the user, restoring its HP.",
          "learnable": true
        },
        {
          "name": "Shadow Ball",
          "type": "ghost",
          "attack": "63",
          "wait": "7",
          "description": "The user hurls a shadowy blob in front of itself, damaging enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Smog",
          "type": "poison",
          "attack": "188",
          "wait": "5",
          "description": "The user spews poison around itself, damaging enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Sucker Punch",
          "type": "dark",
          "attack": "130",
          "wait": "5",
          "description": "The user briefly disappears and moves a short distance. It then charges toward enemies, damaging them.",
          "learnable": true
        },
        {
          "name": "Toxic",
          "type": "poison",
          "attack": "59",
          "wait": "4",
          "description": "The user sprays a powerful poison around itself, often poisoning enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Ghost Type  Moves Wait -5%",
          "ATK of Ghost Type Moves +5%",
          "Normal Type Damage Taken -25%"
        ],
        [
          "ATK of Ghost Type Moves +10%",
          "Resistant to Poisoned +100%",
          "Fighting Type Damage Taken -25%"
        ],
        [
          "ATK of Ghost Type Moves +15%",
          "Normal-Type Damage Taken -25%",
          "Ghost Type Moves Wait -10%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "150",
      "baseAtk": "650",
      "sprite": require('./images/sprites/94.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 95,
      "avatar": require('./images/avatars/095.png'),
      "name": "Onix",
      "type": [
        "rock",
        "ground"
      ],
      "classification": "Rock Snake Pokémon",
      "moves": [
        {
          "name": "Flash Cannon",
          "type": "steel",
          "attack": "170",
          "wait": "7",
          "description": "The user focuses all of its light energy into a single point and fires a beam in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Lick",
          "type": "ghost",
          "attack": "233",
          "wait": "5",
          "description": "The user licks enemies all around itself with its long tongue, damaging them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Roar",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user roars intensely, blowing away surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Rock Polish",
          "type": "rock",
          "attack": "0",
          "wait": "2",
          "description": "The user polishes its body to reduce drag, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Rock Throw",
          "type": "rock",
          "attack": "234",
          "wait": "5",
          "description": "The user picks up two rocks and hurls them in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Sandstorm",
          "type": "rock",
          "attack": "117",
          "wait": "5",
          "description": "The user creates a sandstorm around itself, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Stealth Rock",
          "type": "rock",
          "attack": "120",
          "wait": "5",
          "description": "The user creates pillars of stone from the ground, damaging enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Rock Type Moves +5%",
          "Movement Speed +30%",
          "Rock Type Moves Wait -5%"
        ],
        [
          "ATK of Rock Type Moves +15%",
          "Movement Speed +40%",
          "Rock Type Moves Wait -10%"
        ],
        [
          "ATK of Rock Type Moves +20%",
          "Movement Speed +50%",
          "Rock Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "600",
      "baseAtk": "100",
      "sprite": require('./images/sprites/95.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 96,
      "avatar": require('./images/avatars/096.png'),
      "name": "Drowzee",
      "type": [
        "psychic"
      ],
      "classification": "Hypnosis Pokémon",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Psychic Type Moves Wait -5%",
          "Healing per Wave +30%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Healing per Wave +40%",
          "Resistant to Asleep +100%",
          "Psychic Type Moves Wait -15%"
        ],
        [
          "HP +600",
          "Resistant to ↓ Effects +30%",
          "Psychic Type Moves Wait -20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "120",
      "baseAtk": "80",
      "sprite": require('./images/sprites/96.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          165,
          3300,
          3300
        ],
        "type": [
          0,
          400,
          8000,
          8000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 97,
      "avatar": require('./images/avatars/097.png'),
      "name": "Hypno",
      "type": [
        "psychic"
      ],
      "classification": "Hypnosis Pokémon",
      "evolution": "Evolve Drowzee (Lv. 26)",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Flatter",
          "type": "dark",
          "attack": "0",
          "wait": "6",
          "description": "The user flatters enemies in front of itself, which confuses them but raises the amount of damage they deal and reduces the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Hypnosis",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user employs hypnotic suggestion, often making enemies in front of itself fall asleep.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Meditate",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user meditates to awaken the power deep within its body, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Shadow Ball",
          "type": "ghost",
          "attack": "63",
          "wait": "7",
          "description": "The user hurls a shadowy blob in front of itself, damaging enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Psychic Type Moves Wait -5%",
          "Healing per Wave +20%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Healing per Wave +30%",
          "Resistant to Asleep +100%",
          "Psychic Type Moves Wait -15%"
        ],
        [
          "HP +250",
          "Resistant to ↓ Effects +30%",
          "Psychic Type Moves Wait -20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "500",
      "baseAtk": "200",
      "sprite": require('./images/sprites/97.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 98,
      "avatar": require('./images/avatars/098.png'),
      "name": "Krabby",
      "type": [
        "water"
      ],
      "classification": "River Crab Pokémon",
      "moves": [
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Taking Critical Hits Rate -20%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "ATK of Normal Type Moves +15%",
          "Resistant to ↓ Effects +30%",
          "Taking Critical Hit Damage -30%"
        ],
        [
          "Taking Critical Hits Rate -50%",
          "Resistant to Damage Down -100%",
          "ATK +500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "70",
      "baseAtk": "130",
      "sprite": require('./images/sprites/98.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 99,
      "avatar": require('./images/avatars/099.png'),
      "name": "Kingler",
      "type": [
        "water"
      ],
      "classification": "Pincer Pokémon",
      "evolution": "Evolve Krabby (Lv. 28)",
      "moves": [
        {
          "name": "Giga Impact",
          "type": "normal",
          "attack": "176",
          "wait": "5",
          "description": "The user focuses every bit of its power and charges toward enemies in front of itself, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Slam",
          "type": "normal",
          "attack": "211",
          "wait": "5",
          "description": "The user slams nearby enemies with a long tail, vines, or the like, damaging all of them.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Taking Critical Hits Rate -20%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "ATK of Normal Type Moves +10%",
          "Resistant to ↓ Effects +20%",
          "Taking Critical Hits Rate -30%"
        ],
        [
          "Taking Critical Hits Rate -50%",
          "Resistant to Damage Down -100%",
          "ATK of Normal Type Moves +20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "600",
      "sprite": require('./images/sprites/99.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 100,
      "avatar": require('./images/avatars/100.png'),
      "name": "Voltorb",
      "type": [
        "electric"
      ],
      "classification": "Ball Pokémon",
      "moves": [
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Self-Destruct",
          "type": "normal",
          "attack": "494",
          "wait": "5",
          "description": "The user approaches enemies and causes an explosion, damaging all surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Thunder Shock",
          "type": "electric",
          "attack": "173",
          "wait": "5",
          "description": "After storing up electricity, the user fires it toward enemies in front of itself, dealing damage to them. Sometimes paralyzes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Normal Type Moves Wait -5%",
          "Movement Speed +50%"
        ],
        [
          "Movement Speed +50%",
          "ATK of Normal Type Moves +15%",
          "Resistant to Paralyzed +100%"
        ],
        [
          "Movement Speed +100%",
          "Normal Type Moves Wait -20%",
          "ATK +700"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "110",
      "baseAtk": "90",
      "sprite": require('./images/sprites/100.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 101,
      "avatar": require('./images/avatars/101.png'),
      "name": "Electrode",
      "type": [
        "electric"
      ],
      "classification": "Ball Pokémon",
      "evolution": "Evolve Voltorb (Lv. 30)",
      "moves": [
        {
          "name": "Explosion",
          "type": "normal",
          "attack": "683",
          "wait": "5",
          "description": "The user causes a tremendous explosion, dealing huge damage to surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Self-Destruct",
          "type": "normal",
          "attack": "494",
          "wait": "5",
          "description": "The user approaches enemies and causes an explosion, damaging all surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Thunder Shock",
          "type": "electric",
          "attack": "173",
          "wait": "5",
          "description": "After storing up electricity, the user fires it toward enemies in front of itself, dealing damage to them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunderbolt",
          "type": "electric",
          "attack": "80",
          "wait": "5",
          "description": "The user discharges tremendous electricity all around itself. Deals damage to enemies around the user. Sometimes paralyzes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Normal Type Moves Wait -5%",
          "Movement Speed +50%"
        ],
        [
          "Movement Speed +50%",
          "ATK of Normal Type Moves +10%",
          "Resistant to Paralyzed +100%"
        ],
        [
          "Movement Speed +100%",
          "Normal Type Moves Wait -10%",
          "ATK +400"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "400",
      "baseAtk": "300",
      "sprite": require('./images/sprites/101.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 102,
      "avatar": require('./images/avatars/102.png'),
      "name": "Exeggcute",
      "type": [
        "grass",
        "psychic"
      ],
      "classification": "Egg Pokémon",
      "moves": [
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Leech Seed",
          "type": "grass",
          "attack": "103",
          "wait": "9",
          "description": "The user plants a seed on the ground in front of itself. Enemies in range are gradually damaged. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Grass Type Moves +5%",
          "Grass Type Moves Wait -5%",
          "Wait for Standard Attacks -20%"
        ],
        [
          "ATK of Grass Type Moves +15%",
          "Grass Type Moves Wait -15%",
          "Wait for Standard Attacks -25%"
        ],
        [
          "ATK +600",
          "Grass Type Moves Wait -20%",
          "Wait for Standard Attacks -30%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "130",
      "baseAtk": "70",
      "sprite": require('./images/sprites/102.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 103,
      "avatar": require('./images/avatars/103.png'),
      "name": "Exeggutor",
      "type": [
        "grass",
        "psychic"
      ],
      "classification": "Coconut Pokémon",
      "evolution": "Evolve Exeggcute (Lv. 36)",
      "moves": [
        {
          "name": "Bullet Seed",
          "type": "grass",
          "attack": "168",
          "wait": "7",
          "description": "The user sends several seeds flying out in front of itself simultaneously, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Egg Bomb",
          "type": "normal",
          "attack": "201",
          "wait": "5",
          "description": "The user scatters eggs around itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Leech Seed",
          "type": "grass",
          "attack": "103",
          "wait": "9",
          "description": "The user plants a seed on the ground in front of itself. Enemies in range are gradually damaged. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Solar Beam",
          "type": "grass",
          "attack": "227",
          "wait": "7",
          "description": "The user gathers light and unleashes it in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Grass Type Moves +5%",
          "Grass Type Moves Wait -5%",
          "Wait for Standard Attacks -15%"
        ],
        [
          "ATK of Grass Type Moves +15%",
          "Grass Type Moves Wait -10%",
          "Wait for Standard Attacks -15%"
        ],
        [
          "ATK of Psychic Type Moves +30%",
          "Grass Type Moves Wait -15%",
          "Psychic Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "250",
      "baseAtk": "550",
      "sprite": require('./images/sprites/103.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 104,
      "avatar": require('./images/avatars/104.png'),
      "name": "Cubone",
      "type": [
        "ground"
      ],
      "classification": "Lonely Pokémon",
      "moves": [
        {
          "name": "Bonemerang",
          "type": "ground",
          "attack": "131",
          "wait": "7",
          "description": "The user throws a boomerang made of bone, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Sandstorm",
          "type": "rock",
          "attack": "117",
          "wait": "5",
          "description": "The user creates a sandstorm around itself, damaging enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -20%",
          "Electric Type Damage Taken -10%",
          "Ground Type Moves Wait -5%"
        ],
        [
          "ATK of Ground Type Moves +15%",
          "Electric Type Damage Taken -15%",
          "Taking Critical Hits -30%"
        ],
        [
          "Electric Type Damage Taken -30%",
          "Taking Critical Hits -50%",
          "ATK +550"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "130",
      "baseAtk": "70",
      "sprite": require('./images/sprites/104.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          500,
          10000,
          10000
        ],
        "type": [
          0,
          500,
          10000,
          10000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 105,
      "avatar": require('./images/avatars/105.png'),
      "name": "Marowak",
      "type": [
        "ground"
      ],
      "classification": "Bone Keeper Pokémon",
      "evolution": "Evolve Cubone (Lv. 28)",
      "moves": [
        {
          "name": "Aerial Ace",
          "type": "flying",
          "attack": "124",
          "wait": "5",
          "description": "The user quickly slashes in front of itself twice, dealing damage.",
          "learnable": true
        },
        {
          "name": "Belly Drum",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user uses its own HP to raise all of its stats for a while.",
          "learnable": true
        },
        {
          "name": "Bonemerang",
          "type": "ground",
          "attack": "131",
          "wait": "7",
          "description": "The user throws a boomerang made of bone, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Outrage",
          "type": "dragon",
          "attack": "104",
          "wait": "5",
          "description": "The user rampages about, attacking and damaging any enemies in its path. Sometimes confuses the user.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Sandstorm",
          "type": "rock",
          "attack": "117",
          "wait": "5",
          "description": "The user creates a sandstorm around itself, damaging enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -20%",
          "Electric Type Damage Taken -10%",
          "Ground Type Moves Wait -5%"
        ],
        [
          "ATK of Ground Type Moves +10%",
          "Electric Type Damage Taken -15%",
          "Taking Critical Hits -30%"
        ],
        [
          "Electric Type Damage Taken -30%",
          "Taking Critical Hits -50%",
          "ATK +500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "525",
      "baseAtk": "175",
      "sprite": require('./images/sprites/105.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 106,
      "avatar": require('./images/avatars/106.png'),
      "name": "Hitmonlee",
      "type": [
        "fighting"
      ],
      "classification": "Kicking Pokémon",
      "moves": [
        {
          "name": "Bounce",
          "type": "flying",
          "attack": "186",
          "wait": "5",
          "description": "The user bounces forward high into the air twice, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Bulk Up",
          "type": "fighting",
          "attack": "0",
          "wait": "8",
          "description": "The user tenses its muscles to bulk up its body, raising the damage it deals for a while. This also reduces the damage the user takes.",
          "learnable": true
        },
        {
          "name": "Close Combat",
          "type": "fighting",
          "attack": "245",
          "wait": "5",
          "description": "The user gets right up on enemies in front of itself and smacks them with a single blow, damaging them. Sometimes raises the amount of damage the user takes.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "High Jump Kick",
          "type": "fighting",
          "attack": "402",
          "wait": "5",
          "description": "After charging toward enemies in front of itself, the user jumps up and deals damage with a knee kick. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Meditate",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user meditates to awaken the power deep within its body, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Rolling Kick",
          "type": "fighting",
          "attack": "156",
          "wait": "5",
          "description": "The user kicks as it spins in place, dealing damage to surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Submission",
          "type": "fighting",
          "attack": "130",
          "wait": "5",
          "description": "The user spins toward enemies in front of itself, smashing into them. Deals damage to enemies hit by the user as it whirls around.",
          "learnable": true
        },
        {
          "name": "Sucker Punch",
          "type": "dark",
          "attack": "130",
          "wait": "5",
          "description": "The user briefly disappears and moves a short distance. It then charges toward enemies, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Fighting Type Moves +5%",
          "Fighting Type Moves Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "ATK of Fighting Type Moves +15%",
          "Resistant to Paralyzed +100%",
          "Critical Hit Damage +10%"
        ],
        [
          "ATK of Fighting Type Moves +20%",
          "Fighting Type Moves Wait -20%",
          "Critical Hit Rate +15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "50",
      "baseAtk": "650",
      "sprite": require('./images/sprites/106.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          125,
          2500,
          2500
        ],
        "type": [
          0,
          200,
          4000,
          4000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 107,
      "avatar": require('./images/avatars/107.png'),
      "name": "Hitmonchan",
      "type": [
        "fighting"
      ],
      "classification": "Punching Pokémon",
      "moves": [
        {
          "name": "Close Combat",
          "type": "fighting",
          "attack": "245",
          "wait": "5",
          "description": "The user gets right up on enemies in front of itself and smacks them with a single blow, damaging them. Sometimes raises the amount of damage the user takes.",
          "learnable": true
        },
        {
          "name": "Comet Punch",
          "type": "normal",
          "attack": "201",
          "wait": "5",
          "description": "The user unleashes a flurry of punches on enemies directly in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Drain Punch",
          "type": "fighting",
          "attack": "223",
          "wait": "9",
          "description": "The user fires a punch at enemies directly in front of itself, damaging them. It also absorbs power with its fist, restoring its own HP.",
          "learnable": true
        },
        {
          "name": "Dynamic Punch",
          "type": "fighting",
          "attack": "87",
          "wait": "5",
          "description": "The user punches enemies directly in front of itself with its full, concentrated power. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Fire Punch",
          "type": "fire",
          "attack": "229",
          "wait": "5",
          "description": "The user imbues its fist with the power of flames, and strikes enemies directly in front of it with a burning punch. Deals damage and sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Ice Punch",
          "type": "ice",
          "attack": "175",
          "wait": "5",
          "description": "The user chills its fist and unleashes a freezing punch on enemies directly in front of it. Sometimes freezes enemies.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Power-Up Punch",
          "type": "fighting",
          "attack": "64",
          "wait": "5",
          "description": "The user delivers a punch with its hard fist to enemies directly in front of itself, damaging them. Often raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Critical Hit Damage +5%",
          "Resistant to ↓ Effects +10%",
          "Movement Speed +30%"
        ],
        [
          "Resistant To Status Conditions +20%",
          "Critical Hit Rate +10%",
          "Resistant to ↓ Effects +20%"
        ],
        [
          "Wait for Standard Attacks -75%",
          "Critical Hit Damage +15%",
          "ATK of Fighting Type Moves +20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "75",
      "baseAtk": "625",
      "sprite": require('./images/sprites/107.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          125,
          2500,
          2500
        ],
        "type": [
          0,
          200,
          4000,
          4000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 108,
      "avatar": require('./images/avatars/108.png'),
      "name": "Lickitung",
      "type": [
        "normal"
      ],
      "classification": "Licking Pokémon",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Belly Drum",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user uses its own HP to raise all of its stats for a while.",
          "learnable": true
        },
        {
          "name": "Lick",
          "type": "ghost",
          "attack": "233",
          "wait": "5",
          "description": "The user licks enemies all around itself with its long tongue, damaging them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Power-Up Punch",
          "type": "fighting",
          "attack": "64",
          "wait": "5",
          "description": "The user delivers a punch with its hard fist to enemies directly in front of itself, damaging them. Often raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Slam",
          "type": "normal",
          "attack": "211",
          "wait": "5",
          "description": "The user slams nearby enemies with a long tail, vines, or the like, damaging all of them.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Resistant to Status Conditions +10%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "ATK of Normal Type Moves +15%",
          "Resistant to Status Conditions +15%",
          "Resistant to Confused +100%"
        ],
        [
          "ATK of Normal Type Moves +20%",
          "Resistant to Status Conditions +25%",
          "Resistant to ↓ Effects +30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "600",
      "baseAtk": "100",
      "sprite": require('./images/sprites/108.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 109,
      "avatar": require('./images/avatars/109.png'),
      "name": "Koffing",
      "type": [
        "poison"
      ],
      "classification": "Poison Gas Pokémon",
      "moves": [
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Lava Plume",
          "type": "fire",
          "attack": "132",
          "wait": "5",
          "description": "The user spouts scarlet flames all around itself. Deals damage to enemies around it. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Self-Destruct",
          "type": "normal",
          "attack": "494",
          "wait": "5",
          "description": "The user approaches enemies and causes an explosion, damaging all surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Smog",
          "type": "poison",
          "attack": "188",
          "wait": "5",
          "description": "The user spews poison around itself, damaging enemies. Sometimes poisons enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Poison Type Moves Wait -5%",
          "Ground Type Damage Taken -20%",
          "ATK of Poison Type Moves +5%"
        ],
        [
          "Poison Type Moves Wait -15%",
          "ATK of Poison Type Moves +15%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Ground Type Damage Taken -30%",
          "Poison Type Moves Wait -20%",
          "ATK +550"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "140",
      "baseAtk": "60",
      "sprite": require('./images/sprites/109.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 110,
      "avatar": require('./images/avatars/110.png'),
      "name": "Weezing",
      "type": [
        "poison"
      ],
      "classification": "Poison Gas Pokémon",
      "evolution": "Evolve Koffing (Lv. 35)",
      "moves": [
        {
          "name": "Explosion",
          "type": "normal",
          "attack": "683",
          "wait": "5",
          "description": "The user causes a tremendous explosion, dealing huge damage to surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Lava Plume",
          "type": "fire",
          "attack": "132",
          "wait": "5",
          "description": "The user spouts scarlet flames all around itself. Deals damage to enemies around it. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Self-Destruct",
          "type": "normal",
          "attack": "494",
          "wait": "5",
          "description": "The user approaches enemies and causes an explosion, damaging all surrounding enemies. The trade-off is that the user takes enough damage to knock itself out.",
          "learnable": true
        },
        {
          "name": "Sludge Bomb",
          "type": "poison",
          "attack": "173",
          "wait": "5",
          "description": "The user shoots out a glob of sludge that splits open when it hits the ground, damaging surrounding enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Smog",
          "type": "poison",
          "attack": "188",
          "wait": "5",
          "description": "The user spews poison around itself, damaging enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Venom Drench",
          "type": "poison",
          "attack": "118",
          "wait": "5",
          "description": "The user spews poison in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Poison Type Moves Wait -5%",
          "Ground Type Damage Taken -20%",
          "ATK of Poison Type Moves +5%"
        ],
        [
          "Poison Type Moves Wait -10%",
          "ATK of Poison Type Moves +10%",
          "Resistant to Poisoned +100%"
        ],
        [
          "Ground Type Damage Taken -30%",
          "Poison Type Moves Wait -15%",
          "ATK of Poison Type Moves +20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "450",
      "baseAtk": "350",
      "sprite": require('./images/sprites/110.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 111,
      "avatar": require('./images/avatars/111.png'),
      "name": "Rhyhorn",
      "type": [
        "ground",
        "rock"
      ],
      "classification": "Spikes Pokémon",
      "moves": [
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Roar",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user roars intensely, blowing away surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Critical Hit Damage +5%",
          "Own Knockback Distance -10%",
          "Electric Type Damage Taken -10%"
        ],
        [
          "Critical Hit Damage +15%",
          "Electric Type Damage Taken -15%",
          "Own Knockback Distance -20%"
        ],
        [
          "Critical Hit Damage +20%",
          "Electric Type Damage Taken -25%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "120",
      "baseAtk": "80",
      "sprite": require('./images/sprites/111.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 112,
      "avatar": require('./images/avatars/112.png'),
      "name": "Rhydon",
      "type": [
        "ground",
        "rock"
      ],
      "classification": "Drill Pokémon",
      "evolution": "Evolve Rhyhorn (Lv. 42)",
      "moves": [
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Dragon Rush",
          "type": "dragon",
          "attack": "141",
          "wait": "5",
          "description": "The user flies into enemies a short distance from itself with great intensity, damaging them.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Megahorn",
          "type": "bug",
          "attack": "513",
          "wait": "5",
          "description": "Using its tough and impressive horn, the user rams into enemies in front of itself with no letup, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Roar",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user roars intensely, blowing away surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Rock Polish",
          "type": "rock",
          "attack": "0",
          "wait": "2",
          "description": "The user polishes its body to reduce drag, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Critical Hit Damage +5%",
          "Own Knockback Distance -10%",
          "Electric Type Damage Taken -10%"
        ],
        [
          "Critical Hit Damage +10%",
          "Electric Type Damage Taken -15%",
          "Own Knockback Distance -20%"
        ],
        [
          "Critical Hit Damage +15%",
          "Electric Type Damage Taken -25%",
          "Own Knockback Distance -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "300",
      "baseAtk": "500",
      "sprite": require('./images/sprites/112.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 113,
      "avatar": require('./images/avatars/113.png'),
      "name": "Chansey",
      "type": [
        "normal"
      ],
      "classification": "Egg Pokémon",
      "moves": [
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Egg Bomb",
          "type": "normal",
          "attack": "201",
          "wait": "5",
          "description": "The user scatters eggs around itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Sing",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user sings to enemies around itself with its calming voice, often putting them to sleep.",
          "learnable": true
        },
        {
          "name": "Soft-Boiled",
          "type": "normal",
          "attack": "0",
          "wait": "9",
          "description": "The user restores its HP with the power of eggs.",
          "learnable": true
        },
        {
          "name": "Sweet Kiss",
          "type": "fairy",
          "attack": "165",
          "wait": "3",
          "description": "The user kisses enemies directly in front of itself with a sweet, angelic kiss that often confuses them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Normal Type Moves Wait -5%",
          "Ghost Type Damage Taken -10%",
          "Resistant to Status Conditions +10%"
        ],
        [
          "Ghost Type Damage Taken -15%",
          "Resistant to Status Conditions +20%",
          "Normal Type Moves Wait -10%"
        ],
        [
          "Critical Hit Rate +30%",
          "Resistant to Status Conditions +30%",
          "Pokémon Size Change -50%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "675",
      "baseAtk": "25",
      "sprite": require('./images/sprites/113.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          25,
          500,
          500
        ],
        "type": [
          0,
          30,
          600,
          600
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 114,
      "avatar": require('./images/avatars/114.png'),
      "name": "Tangela",
      "type": [
        "grass"
      ],
      "classification": "Vine Pokémon",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Leech Seed",
          "type": "grass",
          "attack": "103",
          "wait": "9",
          "description": "The user plants a seed on the ground in front of itself. Enemies in range are gradually damaged. Part of the damage dealt is absorbed to restore the user's HP.",
          "learnable": true
        },
        {
          "name": "Mega Drain",
          "type": "grass",
          "attack": "165",
          "wait": "9",
          "description": "The user attacks enemies in front of itself, dealing damage to them. Some of the damage dealt is absorbed by the user, restoring its HP.",
          "learnable": true
        },
        {
          "name": "Rage Powder",
          "type": "bug",
          "attack": "0",
          "wait": "2",
          "description": "The user scatters a cloud of irritating powder on itself, causing surrounding enemies to target it.",
          "learnable": true
        },
        {
          "name": "Rest",
          "type": "psychic",
          "attack": "0",
          "wait": "9",
          "description": "The user rests in place, greatly restoring its HP.",
          "learnable": true
        },
        {
          "name": "Slam",
          "type": "normal",
          "attack": "211",
          "wait": "5",
          "description": "The user slams nearby enemies with a long tail, vines, or the like, damaging all of them.",
          "learnable": true
        },
        {
          "name": "Stun Spore",
          "type": "grass",
          "attack": "21",
          "wait": "3",
          "description": "The user scatters numbing powder directly in front of itself. Often paralyzes enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Substitute",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user puts out a substitute for itself that enemies are forced to attack.",
          "learnable": true
        },
        {
          "name": "Synthesis",
          "type": "grass",
          "attack": "0",
          "wait": "5",
          "description": "The user absorbs light, raising the damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Vine Whip",
          "type": "grass",
          "attack": "237",
          "wait": "5",
          "description": "The user strikes enemies in front of itself with whiplike vines. Deals damage to enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Grass Type Moves Wait -5%",
          "HP upon Recovery +10%",
          "Natural HP Healing +10%"
        ],
        [
          "Grass Type Moves Wait -5%",
          "Resistant to Status Conditions +50%",
          "Healing per Wave +30%"
        ],
        [
          "Grass Type Moves Wait -5%",
          "Resistant to Status Conditions +50%",
          "Healing per Wave +40%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "400",
      "baseAtk": "300",
      "sprite": require('./images/sprites/114.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          30,
          600,
          600
        ],
        "type": [
          0,
          100,
          2000,
          2000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 115,
      "avatar": require('./images/avatars/115.png'),
      "name": "Kangaskhan",
      "type": [
        "normal"
      ],
      "classification": "Parent Pokémon",
      "moves": [
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Outrage",
          "type": "dragon",
          "attack": "104",
          "wait": "5",
          "description": "The user rampages about, attacking and damaging any enemies in its path. Sometimes confuses the user.",
          "learnable": true
        },
        {
          "name": "Rest",
          "type": "psychic",
          "attack": "0",
          "wait": "9",
          "description": "The user rests in place, greatly restoring its HP.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Stomp",
          "type": "normal",
          "attack": "180",
          "wait": "5",
          "description": "The user stomps on enemies in front of itself with a big foot, damaging them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Resistant to Status Conditions +10%",
          "Own Knockback Distance -10%"
        ],
        [
          "ATK of Normal Type Moves +15%",
          "Resistant to Status Conditions +15%",
          "Own Knockback Distance -15%"
        ],
        [
          "ATK of Normal Type Moves +20%",
          "Normal Type Moves Wait -15%",
          "Own Knockback Distance -25%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "350",
      "baseAtk": "350",
      "sprite": require('./images/sprites/115.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          125,
          2500,
          2500
        ],
        "type": [
          0,
          250,
          5000,
          5000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 116,
      "avatar": require('./images/avatars/116.png'),
      "name": "Horsea",
      "type": [
        "water"
      ],
      "classification": "Dragon Pokémon",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Twister",
          "type": "dragon",
          "attack": "115",
          "wait": "7",
          "description": "The user whips up several tornadoes and sends them out in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Water Type Moves Wait -5%",
          "ATK of Water Type Moves +5%",
          "Critical Hit Damage +10%"
        ],
        [
          "Water Type Moves Wait -15%",
          "ATK of Water Type Moves +15%",
          "Critical Hit Damage +15%"
        ],
        [
          "ATK +600",
          "Critical Hit Damage +25%",
          "Water Type Moves Wait -20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "90",
      "baseAtk": "110",
      "sprite": require('./images/sprites/116.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 117,
      "avatar": require('./images/avatars/117.png'),
      "name": "Seadra",
      "type": [
        "water"
      ],
      "classification": "Dragon Pokémon",
      "evolution": "Evolve Horsea (Lv. 37)",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Dragon Dance",
          "type": "dragon",
          "attack": "0",
          "wait": "8",
          "description": "The user vigorously performs a mystic, powerful dance that raises the amount of damage it deals and its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Dragon Pulse",
          "type": "dragon",
          "attack": "188",
          "wait": "7",
          "description": "The user sends a shock wave flying from its mouth, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Flash Cannon",
          "type": "steel",
          "attack": "170",
          "wait": "7",
          "description": "The user focuses all of its light energy into a single point and fires a beam in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        },
        {
          "name": "Hydro Pump",
          "type": "water",
          "attack": "213",
          "wait": "5",
          "description": "The user shoots four pillars of water up from the ground and sends them out in front of itself. Deals damage to enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Twister",
          "type": "dragon",
          "attack": "115",
          "wait": "7",
          "description": "The user whips up several tornadoes and sends them out in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Water Type Moves Wait -5%",
          "ATK of Water Type Moves +5%",
          "Critical Hit Damage +10%"
        ],
        [
          "Water Type Moves Wait -10%",
          "ATK of Water Type Moves +10%",
          "Critical Hit Damage +15%"
        ],
        [
          "ATK of Water Type Moves +20%",
          "Critical Hit Damage +25%",
          "Water Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "250",
      "baseAtk": "450",
      "sprite": require('./images/sprites/117.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 118,
      "avatar": require('./images/avatars/118.png'),
      "name": "Goldeen",
      "type": [
        "water"
      ],
      "classification": "Goldfish Pokémon",
      "moves": [
        {
          "name": "Aqua Jet",
          "type": "water",
          "attack": "182",
          "wait": "5",
          "description": "The user charges at enemies in front of itself with tremendous speed, dealing damage to them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Splash",
          "type": "normal",
          "attack": "56",
          "wait": "3",
          "description": "The user splashes in place.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Normal Type Moves Wait -5%",
          "Electric Type Damage Taken -10%"
        ],
        [
          "ATK of Water Type Moves +15%",
          "Resistant to Burned +100%",
          "Electric Type Damage Taken -20%"
        ],
        [
          "Water Type Moves Wait -20%",
          "ATK +500",
          "Electric Type Damage Taken -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "70",
      "baseAtk": "130",
      "sprite": require('./images/sprites/118.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 119,
      "avatar": require('./images/avatars/119.png'),
      "name": "Seaking",
      "type": [
        "water"
      ],
      "classification": "Goldfish Pokémon",
      "evolution": "Evolve Goldeen (Lv. 33)",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Aqua Jet",
          "type": "water",
          "attack": "182",
          "wait": "5",
          "description": "The user charges at enemies in front of itself with tremendous speed, dealing damage to them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Megahorn",
          "type": "bug",
          "attack": "513",
          "wait": "5",
          "description": "Using its tough and impressive horn, the user rams into enemies in front of itself with no letup, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Normal Type Moves Wait -5%",
          "Electric Type Damage Taken -10%"
        ],
        [
          "ATK of Water Type Moves +10%",
          "Resistant to Burned +100%",
          "Electric Type Damage Taken -20%"
        ],
        [
          "Water Type Moves Wait -15%",
          "ATK of Water Type Moves +20%",
          "Electric Type Damage Taken -30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "350",
      "baseAtk": "450",
      "sprite": require('./images/sprites/119.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 120,
      "avatar": require('./images/avatars/120.png'),
      "name": "Staryu",
      "type": [
        "water"
      ],
      "classification": "Starshape Pokémon",
      "moves": [
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Flash Cannon",
          "type": "steel",
          "attack": "170",
          "wait": "7",
          "description": "The user focuses all of its light energy into a single point and fires a beam in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Twister",
          "type": "dragon",
          "attack": "115",
          "wait": "7",
          "description": "The user whips up several tornadoes and sends them out in front of itself, damaging enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Water Type Moves Wait -5%",
          "Ice Type Moves Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "Water Type Moves Wait -15%",
          "Pokémon Size Change -10%",
          "Movement Speed +40%"
        ],
        [
          "Water Type Moves Wait -20%",
          "Pokémon Size Change -15%",
          "ATK +500"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "60",
      "baseAtk": "140",
      "sprite": require('./images/sprites/120.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          10000,
          0,
          0,
          0
        ],
        "color": [
          10000,
          0,
          0,
          0
        ],
        "type": [
          10000,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 121,
      "avatar": require('./images/avatars/121.png'),
      "name": "Starmie",
      "type": [
        "water",
        "psychic"
      ],
      "classification": "Mysterious Pokémon",
      "evolution": "Evolve Staryu (Lv. 36)",
      "moves": [
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Confuse Ray",
          "type": "ghost",
          "attack": "0",
          "wait": "3",
          "description": "The user exposes surrounding enemies to a sinister ray, often confusing them.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Flash Cannon",
          "type": "steel",
          "attack": "170",
          "wait": "7",
          "description": "The user focuses all of its light energy into a single point and fires a beam in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        },
        {
          "name": "Hydro Pump",
          "type": "water",
          "attack": "213",
          "wait": "5",
          "description": "The user shoots four pillars of water up from the ground and sends them out in front of itself. Deals damage to enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Hyper Beam",
          "type": "normal",
          "attack": "300",
          "wait": "10",
          "description": "The user stores up power and then fires a tremendous beam at enemies. Deals severe damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Twister",
          "type": "dragon",
          "attack": "115",
          "wait": "7",
          "description": "The user whips up several tornadoes and sends them out in front of itself, damaging enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Water Type Moves Wait -5%",
          "Ice Type Moves Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "Water Type Moves Wait -10%",
          "Pokémon Size Change -10%",
          "Movement Speed +15%"
        ],
        [
          "Water Type Moves Wait -15%",
          "Pokémon Size Change -15%",
          "ATK of Water Type Moves +30%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "150",
      "baseAtk": "650",
      "sprite": require('./images/sprites/121.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 122,
      "avatar": require('./images/avatars/122.png'),
      "name": "Mr. Mime",
      "type": [
        "psychic",
        "fairy"
      ],
      "classification": "Barrier Pokémon",
      "moves": [
        {
          "name": "Barrier",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user throws up a wall around itself, lowering the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Follow Me",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user grabs the attention of surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Hypnosis",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user employs hypnotic suggestion, often making enemies in front of itself fall asleep.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Meditate",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user meditates to awaken the power deep within its body, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Nasty Plot",
          "type": "dark",
          "attack": "0",
          "wait": "5",
          "description": "The user stimulates its brain by thinking bad thoughts, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Substitute",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user puts out a substitute for itself that enemies are forced to attack.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Psychic Type Moves Wait -5%",
          "Resistant to ↓ Effects +10%",
          "ATK of Psychic Type Moves +15%"
        ],
        [
          "Psychic Type Moves Wait -10%",
          "Resistant to ↓ Effects +20%",
          "ATK of Psychic Type Moves +20%"
        ],
        [
          "Psychic Type Moves Wait -15%",
          "Dragon Type Damage Taken -50%",
          "ATK +500"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "575",
      "baseAtk": "125",
      "sprite": require('./images/sprites/122.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          25,
          500,
          500
        ],
        "type": [
          0,
          50,
          1000,
          1000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 123,
      "avatar": require('./images/avatars/123.png'),
      "name": "Scyther",
      "type": [
        "bug",
        "flying"
      ],
      "classification": "Mantis Pokémon",
      "moves": [
        {
          "name": "Aerial Ace",
          "type": "flying",
          "attack": "124",
          "wait": "5",
          "description": "The user quickly slashes in front of itself twice, dealing damage.",
          "learnable": true
        },
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Lunge",
          "type": "bug",
          "attack": "180",
          "wait": "5",
          "description": "The user lunges toward enemies in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Night Slash",
          "type": "dark",
          "attack": "83",
          "wait": "5",
          "description": "The user dashes forward, slashing surrounding enemies and damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Silver Wind",
          "type": "bug",
          "attack": "53",
          "wait": "5",
          "description": "Scales carried by the wind swirl around the user, damaging enemies hit by them. Some or all of the user's stats sometimes rise at random.",
          "learnable": true
        },
        {
          "name": "Steel Wing",
          "type": "steel",
          "attack": "81",
          "wait": "5",
          "description": "The user charges at enemies in front of itself and smacks them with its hard wings, dealing damage. Sometimes reduces the amount of damage the user takes.",
          "learnable": true
        },
        {
          "name": "Swords Dance",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "With a frenetic dance to uplift the fighting spirit, the user raises the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Tailwind",
          "type": "flying",
          "attack": "0",
          "wait": "2",
          "description": "The user creates an intense swirling wind that raises its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "U-turn",
          "type": "bug",
          "attack": "243",
          "wait": "5",
          "description": "After attacking surrounding enemies, the user moves back to dodge enemies' counterattacks.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Bug Type Moves +5%",
          "Bug Type Moves Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "ATK of Bug Type Moves +15%",
          "Bug Type Moves Wait -10%",
          "Movement Speed +40%"
        ],
        [
          "Bug Type Moves Wait -15%",
          "ATK of Bug Type Moves +20%",
          "Movement Speed +50%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "700",
      "sprite": require('./images/sprites/123.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          45,
          900,
          900
        ],
        "type": [
          0,
          60,
          1200,
          1200
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 124,
      "avatar": require('./images/avatars/124.png'),
      "name": "Jynx",
      "type": [
        "ice",
        "psychic"
      ],
      "classification": "Humanshape Pokémon",
      "moves": [
        {
          "name": "Aurora Veil",
          "type": "ice",
          "attack": "0",
          "wait": "7",
          "description": "The user cloaks itself in a veil of light, reducing the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Draining Kiss",
          "type": "fairy",
          "attack": "165",
          "wait": "9",
          "description": "The user kisses enemies directly in front of itself and damages them. Part of the damage dealt restores the user's HP.",
          "learnable": true
        },
        {
          "name": "Flash",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user suddenly flashes a bright light at surrounding enemies, often lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Sing",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user sings to enemies around itself with its calming voice, often putting them to sleep.",
          "learnable": true
        },
        {
          "name": "Sweet Kiss",
          "type": "fairy",
          "attack": "165",
          "wait": "3",
          "description": "The user kisses enemies directly in front of itself with a sweet, angelic kiss that often confuses them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fairy Type Moves Wait -5%",
          "Psychic Type Moves Wait -5%",
          "Ice Type Moves Wait -5%"
        ],
        [
          "ATK of Ice Type Moves +15%",
          "ATK of Psychic Type Moves +15%",
          "Resistant to Frozen +100%"
        ],
        [
          "Water Type Damage Taken -50%",
          "ATK of Ice Type Moves +20%",
          "ATK of Psychic Type Moves +20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "150",
      "baseAtk": "550",
      "sprite": require('./images/sprites/124.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          30,
          600,
          600
        ],
        "type": [
          0,
          50,
          1000,
          1000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 125,
      "avatar": require('./images/avatars/125.png'),
      "name": "Electabuzz",
      "type": [
        "electric"
      ],
      "classification": "Electric Pokémon",
      "moves": [
        {
          "name": "Charge",
          "type": "electric",
          "attack": "0",
          "wait": "9",
          "description": "The user stores up electricity, raising the damage it deals and making it resistant to negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Cross Chop",
          "type": "fighting",
          "attack": "273",
          "wait": "5",
          "description": "The user jumps toward enemies in front of itself and smacks them with a two-handed chop, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Dynamic Punch",
          "type": "fighting",
          "attack": "87",
          "wait": "5",
          "description": "The user punches enemies directly in front of itself with its full, concentrated power. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Electroweb",
          "type": "electric",
          "attack": "0",
          "wait": "2",
          "description": "The user spreads an electric net out directly in front of itself, lowering the movement speed of enemies hit by it for a while.",
          "learnable": true
        },
        {
          "name": "Meditate",
          "type": "psychic",
          "attack": "0",
          "wait": "5",
          "description": "The user meditates to awaken the power deep within its body, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Power-Up Punch",
          "type": "fighting",
          "attack": "64",
          "wait": "5",
          "description": "The user delivers a punch with its hard fist to enemies directly in front of itself, damaging them. Often raises the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Thunder",
          "type": "electric",
          "attack": "204",
          "wait": "5",
          "description": "The user strikes the area in front of itself with a lightning bolt. Deals damage to nearby enemies. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunder Punch",
          "type": "electric",
          "attack": "194",
          "wait": "5",
          "description": "The user charges its fist with electricity and unleashes a shocking punch on enemies directly in front of itself, sometimes paralyzing them.",
          "learnable": true
        },
        {
          "name": "Thunder Shock",
          "type": "electric",
          "attack": "173",
          "wait": "5",
          "description": "After storing up electricity, the user fires it toward enemies in front of itself, dealing damage to them. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunderbolt",
          "type": "electric",
          "attack": "80",
          "wait": "5",
          "description": "The user discharges tremendous electricity all around itself. Deals damage to enemies around the user. Sometimes paralyzes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Electric Type Moves +5%",
          "Electric Type Moves Wait -5%",
          "ATK of Fighting Type Moves +5%"
        ],
        [
          "ATK of Electric Type Moves +15%",
          "Electric Type Moves Wait -10%",
          "Resistant to Paralyzed +100%"
        ],
        [
          "ATK of Electric Type Moves +20%",
          "Electric Type Moves Wait -15%",
          "Resistant to Asleep +100%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "300",
      "baseAtk": "400",
      "sprite": require('./images/sprites/125.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          45,
          900,
          900
        ],
        "type": [
          0,
          100,
          2000,
          2000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 126,
      "avatar": require('./images/avatars/126.png'),
      "name": "Magmar",
      "type": [
        "fire"
      ],
      "classification": "Spitfire Pokémon",
      "moves": [
        {
          "name": "Belly Drum",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user uses its own HP to raise all of its stats for a while.",
          "learnable": true
        },
        {
          "name": "Cross Chop",
          "type": "fighting",
          "attack": "273",
          "wait": "5",
          "description": "The user jumps toward enemies in front of itself and smacks them with a two-handed chop, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Fire Blast",
          "type": "fire",
          "attack": "179",
          "wait": "5",
          "description": "The user sprays an all-consuming fire on the ground, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Follow Me",
          "type": "normal",
          "attack": "0",
          "wait": "2",
          "description": "The user grabs the attention of surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Smog",
          "type": "poison",
          "attack": "188",
          "wait": "5",
          "description": "The user spews poison around itself, damaging enemies. Sometimes poisons enemies.",
          "learnable": true
        },
        {
          "name": "Will-O-Wisp",
          "type": "fire",
          "attack": "19",
          "wait": "3",
          "description": "The user drapes itself with sinister flames and attacks enemies directly in front of it. Often burns enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Fire Type Moves +5%",
          "Fire Type Moves Wait -5%",
          "Wait for Standard Attacks -25%"
        ],
        [
          "ATK of Fire Type Moves +15%",
          "Fire Type Moves Wait -10%",
          "Resistant to Burned +100%"
        ],
        [
          "Critical Hit Damage +30%",
          "ATK of Fire Type Moves +20%",
          "Resistant to Asleep +100%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "175",
      "baseAtk": "525",
      "sprite": require('./images/sprites/126.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          30,
          600,
          600
        ],
        "type": [
          0,
          100,
          2000,
          2000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 127,
      "avatar": require('./images/avatars/127.png'),
      "name": "Pinsir",
      "type": [
        "bug"
      ],
      "classification": "Stagbeetle Pokémon",
      "moves": [
        {
          "name": "Bulk Up",
          "type": "fighting",
          "attack": "0",
          "wait": "8",
          "description": "The user tenses its muscles to bulk up its body, raising the damage it deals for a while. This also reduces the damage the user takes.",
          "learnable": true
        },
        {
          "name": "Close Combat",
          "type": "fighting",
          "attack": "245",
          "wait": "5",
          "description": "The user gets right up on enemies in front of itself and smacks them with a single blow, damaging them. Sometimes raises the amount of damage the user takes.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Focus Energy",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user takes a deep breath and focuses, raising the amount of damage it deals for a while.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Rock Smash",
          "type": "fighting",
          "attack": "29",
          "wait": "1",
          "description": "The user unleashes its fury, damaging enemies in a broad area nearby and destroying surrounding trees and rocks.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Submission",
          "type": "fighting",
          "attack": "130",
          "wait": "5",
          "description": "The user spins toward enemies in front of itself, smashing into them. Deals damage to enemies hit by the user as it whirls around.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Normal Type Moves Wait -5%",
          "Critical Hit Damage +5%",
          "ATK of Fighting Type Moves +5%"
        ],
        [
          "Normal Type Moves Wait -10%",
          "Critical Hit Damage +10%",
          "ATK of Fighting Type Moves +15%"
        ],
        [
          "Resistance to Damage Down +100%",
          "Critical Hit Damage +15%",
          "ATK of Fighting Type Moves +20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "75",
      "baseAtk": "725",
      "sprite": require('./images/sprites/127.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          30,
          600,
          600
        ],
        "type": [
          0,
          60,
          1200,
          1200
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 128,
      "avatar": require('./images/avatars/128.png'),
      "name": "Tauros",
      "type": [
        "normal"
      ],
      "classification": "Wild Bull Pokémon",
      "moves": [
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Giga Impact",
          "type": "normal",
          "attack": "176",
          "wait": "5",
          "description": "The user focuses every bit of its power and charges toward enemies in front of itself, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Hyper Beam",
          "type": "normal",
          "attack": "300",
          "wait": "10",
          "description": "The user stores up power and then fires a tremendous beam at enemies. Deals severe damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Outrage",
          "type": "dragon",
          "attack": "104",
          "wait": "5",
          "description": "The user rampages about, attacking and damaging any enemies in its path. Sometimes confuses the user.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Zen Headbutt",
          "type": "psychic",
          "attack": "370",
          "wait": "5",
          "description": "The user focuses its willpower to its head, then smashes it into enemies directly in front of itself, dealing damage to enemies hit by it.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Critical Hit Damage +5%",
          "ATK of Normal Type Moves +15%",
          "Movement Speed +30%"
        ],
        [
          "Critical Hit Damage +10%",
          "Normal Type Moves Wait -15%",
          "Critical Hit Rate +10%"
        ],
        [
          "ATK of Normal Type Moves +20%",
          "Critical Hit Damage +15%",
          "Wait for Standard Attacks -50%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "600",
      "sprite": require('./images/sprites/128.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          25,
          500,
          500
        ],
        "type": [
          0,
          30,
          600,
          600
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 129,
      "avatar": require('./images/avatars/129.png'),
      "name": "Magikarp",
      "type": [
        "water"
      ],
      "classification": "Fish Pokémon",
      "moves": [
        {
          "name": "Bounce",
          "type": "flying",
          "attack": "186",
          "wait": "5",
          "description": "The user bounces forward high into the air twice, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Splash",
          "type": "normal",
          "attack": "56",
          "wait": "3",
          "description": "The user splashes in place.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Movement Speed +50%",
          "Normal Type Moves Wait -5%"
        ],
        [
          "Time to Recover -20%",
          "Normal Type Moves Wait -20%",
          "Movement Speed +50%"
        ],
        [
          "Time to Recover -25%",
          "Pokémon Size Change +50%",
          "Movement Speed +100%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "25",
      "baseAtk": "25",
      "sprite": require('./images/sprites/129.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          250,
          5000,
          5000
        ],
        "type": [
          0,
          200,
          4000,
          4000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 130,
      "avatar": require('./images/avatars/130.png'),
      "name": "Gyarados",
      "type": [
        "water",
        "flying"
      ],
      "classification": "Atrocious Pokémon",
      "evolution": "Evolve Magikarp (Lv. 20)",
      "moves": [
        {
          "name": "Bounce",
          "type": "flying",
          "attack": "186",
          "wait": "5",
          "description": "The user bounces forward high into the air twice, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Dragon Dance",
          "type": "dragon",
          "attack": "0",
          "wait": "8",
          "description": "The user vigorously performs a mystic, powerful dance that raises the amount of damage it deals and its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Hyper Beam",
          "type": "normal",
          "attack": "300",
          "wait": "10",
          "description": "The user stores up power and then fires a tremendous beam at enemies. Deals severe damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Outrage",
          "type": "dragon",
          "attack": "104",
          "wait": "5",
          "description": "The user rampages about, attacking and damaging any enemies in its path. Sometimes confuses the user.",
          "learnable": true
        },
        {
          "name": "Tackle",
          "type": "normal",
          "attack": "163",
          "wait": "5",
          "description": "The user smashes into enemies in front of itself with all its might, damaging them.",
          "learnable": true
        },
        {
          "name": "Taunt",
          "type": "dark",
          "attack": "0",
          "wait": "2",
          "description": "The user taunts surrounding enemies, forcing them to target it.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Movement Speed +30%",
          "Normal Type Moves Wait -5%"
        ],
        [
          "Time to Recover -10%",
          "Normal Type Moves Wait -10%",
          "Movement Speed +30%"
        ],
        [
          "HP + 500",
          "ATK+300",
          "Movement Speed +30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "200",
      "baseAtk": "400",
      "sprite": require('./images/sprites/130.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 131,
      "avatar": require('./images/avatars/131.png'),
      "name": "Lapras",
      "type": [
        "water",
        "ice"
      ],
      "classification": "Transport Pokémon",
      "moves": [
        {
          "name": "Aurora Veil",
          "type": "ice",
          "attack": "0",
          "wait": "7",
          "description": "The user cloaks itself in a veil of light, reducing the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Hydro Pump",
          "type": "water",
          "attack": "213",
          "wait": "5",
          "description": "The user shoots four pillars of water up from the ground and sends them out in front of itself. Deals damage to enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icicle Crash",
          "type": "ice",
          "attack": "143",
          "wait": "5",
          "description": "The user drops frigid icicles in front of itself. Deals damage to enemies hit by them and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Rest",
          "type": "psychic",
          "attack": "0",
          "wait": "9",
          "description": "The user rests in place, greatly restoring its HP.",
          "learnable": true
        },
        {
          "name": "Sing",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user sings to enemies around itself with its calming voice, often putting them to sleep.",
          "learnable": true
        },
        {
          "name": "Aqua Ring",
          "type": "water",
          "attack": "0",
          "wait": "9",
          "description": "The user envelops itself in a veil made of water, restoring some of its HP.",
          "learnable": false,
          "method": "Great Expedition Pack Only"
        }
      ],
      "bonus": [
        [
          "Resistant to ↓ Effects +10%",
          "Healing per Wave +20%",
          "Own Knockback Distance -20%"
        ],
        [
          "Taking Critical Hits Rate -10%",
          "Water Type Damage Taken -20%",
          "Resistant to Frozen +100%"
        ],
        [
          "Water Type Damage Taken -30%",
          "Natural HP Healing +10%",
          "Resistant to ↓ Effects +20%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "650",
      "baseAtk": "150",
      "sprite": require('./images/sprites/131.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          30,
          600,
          600
        ],
        "type": [
          0,
          125,
          2500,
          2500
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 132,
      "avatar": require('./images/avatars/132.png'),
      "name": "Ditto",
      "type": [
        "normal"
      ],
      "classification": "Transform Pokémon",
      "moves": [
        {
          "name": "Transform",
          "type": "normal",
          "attack": "0",
          "wait": "0",
          "description": "When Ditto transforms into another Pokémon, this changes into a move that Pokémon can learn.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Critical hit Rate +10%",
          "HP upon Recovery +10%",
          "Movement Speed +50%"
        ],
        [
          "Resistant to Paralyzed +100%",
          "Movement Speed +50%",
          "Time to Recover -10%"
        ],
        [
          "Pokémon Size Change +50%",
          "Critical Hit Damage +10%",
          "Pokémon Size Change -25%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "350",
      "baseAtk": "350",
      "sprite": require('./images/sprites/132.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          30,
          600,
          600
        ],
        "type": [
          0,
          30,
          600,
          600
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 133,
      "avatar": require('./images/avatars/133.png'),
      "name": "Eevee",
      "type": [
        "normal"
      ],
      "classification": "Evolution Pokémon",
      "moves": [
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Flail",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user flails about, damaging enemies it hits.",
          "learnable": true
        },
        {
          "name": "Growl",
          "type": "normal",
          "attack": "0",
          "wait": "4",
          "description": "The user growls in an endearing way, making surrounding enemies less wary and often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Normal Type Moves Wait -5%",
          "Movement Speed +30%"
        ],
        [
          "HP upon Recovery +10%",
          "ATK of Normal Type Moves +20%",
          "Movement Speed +50%"
        ],
        [
          "ATK +550",
          "ATK of Normal Type Moves +50%",
          "HP +550"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "100",
      "baseAtk": "100",
      "sprite": require('./images/sprites/133.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          165,
          3300,
          3300
        ],
        "type": [
          0,
          175,
          3500,
          3500
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 134,
      "avatar": require('./images/avatars/134.png'),
      "name": "Vaporeon",
      "type": [
        "water"
      ],
      "classification": "Bubble Jet Pokémon",
      "evolution": "Evolve Eevee (Lv. 36 - Only HP Power Stones attached)",
      "moves": [
        {
          "name": "Acid Armor",
          "type": "poison",
          "attack": "0",
          "wait": "5",
          "description": "The user alters its cellular structure to liquefy itself, reducing the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Aqua Ring",
          "type": "water",
          "attack": "0",
          "wait": "9",
          "description": "The user envelops itself in a veil made of water, restoring some of its HP.",
          "learnable": true
        },
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Hydro Pump",
          "type": "water",
          "attack": "213",
          "wait": "5",
          "description": "The user shoots four pillars of water up from the ground and sends them out in front of itself. Deals damage to enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Time to Recover -10%",
          "Movement Speed +30%"
        ],
        [
          "HP upon Recovery +10%",
          "ATK of Water Type Moves +10%",
          "Water Type Damage Taken -25%"
        ],
        [
          "ATK of Water Type Moves +20%",
          "Resistant to Status Conditions +30%",
          "Water Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "600",
      "baseAtk": "200",
      "sprite": require('./images/sprites/134.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 135,
      "avatar": require('./images/avatars/135.png'),
      "name": "Jolteon",
      "type": [
        "electric"
      ],
      "classification": "Lightning Pokémon",
      "evolution": "Evolve Eevee (Lv. 36 - An equal mix of HP & ATK Power Stones attached)",
      "moves": [
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Pin Missile",
          "type": "bug",
          "attack": "110",
          "wait": "7",
          "description": "The user shoots three sharp spikes in front of itself, damaging enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Spark",
          "type": "electric",
          "attack": "81",
          "wait": "5",
          "description": "The user charges its body with electricity and charges toward enemies in front of itself. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Thunder",
          "type": "electric",
          "attack": "204",
          "wait": "5",
          "description": "The user strikes the area in front of itself with a lightning bolt. Deals damage to nearby enemies. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunderbolt",
          "type": "electric",
          "attack": "80",
          "wait": "5",
          "description": "The user discharges tremendous electricity all around itself. Deals damage to enemies around the user. Sometimes paralyzes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Time to Recover -10%",
          "Movement Speed +30%"
        ],
        [
          "HP upon Recovery +10%",
          "ATK of Electric Type Moves +10%",
          "Electric Type Damage Taken -25%"
        ],
        [
          "ATK of Electric Type Moves +20%",
          "Resistant to Paralyzed +100%",
          "Electric Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "250",
      "baseAtk": "550",
      "sprite": require('./images/sprites/135.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 136,
      "avatar": require('./images/avatars/136.png'),
      "name": "Flareon",
      "type": [
        "fire"
      ],
      "classification": "Flame Pokémon",
      "evolution": "Evolve Eevee (Lv. 36 - Only ATK Power Stones attached)",
      "moves": [
        {
          "name": "Charm",
          "type": "fairy",
          "attack": "0",
          "wait": "3",
          "description": "The user makes surrounding enemies less wary with its cute behavior, often reducing the amount of damage they deal.",
          "learnable": true
        },
        {
          "name": "Dig",
          "type": "ground",
          "attack": "243",
          "wait": "5",
          "description": "The user digs a tunnel to travel beneath the feet of enemies in front of itself, then pops out from beneath them to damage them.",
          "learnable": true
        },
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flare Blitz",
          "type": "fire",
          "attack": "128",
          "wait": "5",
          "description": "The user creates a path of flames in front of itself and charges forward along it. Deals damage to enemies. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Lava Plume",
          "type": "fire",
          "attack": "132",
          "wait": "5",
          "description": "The user spouts scarlet flames all around itself. Deals damage to enemies around it. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Time to Recover -10%",
          "Movement Speed +30%"
        ],
        [
          "HP upon Recovery +10%",
          "ATK of Fire Type Moves +10%",
          "Fire Type Damage Taken -25%"
        ],
        [
          "ATK of Fire Type Moves +20%",
          "Resistant to Burned +100%",
          "Fire Type Moves Wait -15%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "200",
      "baseAtk": "600",
      "sprite": require('./images/sprites/136.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 137,
      "avatar": require('./images/avatars/137.png'),
      "name": "Porygon",
      "type": [
        "normal"
      ],
      "classification": "Virtual Pokémon",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Hyper Beam",
          "type": "normal",
          "attack": "300",
          "wait": "10",
          "description": "The user stores up power and then fires a tremendous beam at enemies. Deals severe damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Iron Tail",
          "type": "steel",
          "attack": "67",
          "wait": "5",
          "description": "The user swings its steel-hard tail, damaging surrounding enemies and sometimes raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Psybeam",
          "type": "psychic",
          "attack": "69",
          "wait": "7",
          "description": "The user sends peculiar rays of light out in three directions, damaging enemies hit by them. Sometimes confuses enemies.",
          "learnable": true
        },
        {
          "name": "Recover",
          "type": "normal",
          "attack": "0",
          "wait": "9",
          "description": "Restoring its own cells, the user restores its HP.",
          "learnable": true
        },
        {
          "name": "Shadow Ball",
          "type": "ghost",
          "attack": "63",
          "wait": "7",
          "description": "The user hurls a shadowy blob in front of itself, damaging enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Thunderbolt",
          "type": "electric",
          "attack": "80",
          "wait": "5",
          "description": "The user discharges tremendous electricity all around itself. Deals damage to enemies around the user. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Tri Attack",
          "type": "normal",
          "attack": "81",
          "wait": "5",
          "description": "The user's body is imbued with three powers as it attacks enemies in front of itself, damaging them. Sometimes burns, paralyzes, or freezes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Normal Type Moves +5%",
          "Movement Speed +30%",
          "Resistant to Status Conditions +10%"
        ],
        [
          "ATK of Normal Type Moves +15%",
          "Normal Type Moves Wait -10%",
          "Resistant to Statis Conditions +20%"
        ],
        [
          "ATK of Normal Type Moves +20%",
          "ATK +350",
          "HP +350"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "350",
      "baseAtk": "350",
      "sprite": require('./images/sprites/137.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          10000,
          10000,
          0
        ],
        "color": [
          0,
          10000,
          10000,
          0
        ],
        "type": [
          0,
          10000,
          10000,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 138,
      "avatar": require('./images/avatars/138.png'),
      "name": "Omanyte",
      "type": [
        "rock",
        "water"
      ],
      "classification": "Spiral Pokémon",
      "moves": [
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Spikes",
          "type": "ground",
          "attack": "221",
          "wait": "5",
          "description": "The user scatters spikes in front of itself, damaging enemies that step on them.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        },
        {
          "name": "Withdraw",
          "type": "water",
          "attack": "0",
          "wait": "5",
          "description": "The user withdraws into its hard shell, reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -20%",
          "Movement Speed +30%",
          "Water Type Moves Wait -5%"
        ],
        [
          "Normal Type Moves Wait -20%",
          "Movement Speed +40%",
          "Taking Critical Hits Rate -30%"
        ],
        [
          "Taking Critical Hits Rate -50%",
          "ATK +550",
          "Movement Speed +50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "140",
      "baseAtk": "60",
      "sprite": require('./images/sprites/138.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          125,
          2500,
          2500
        ],
        "type": [
          0,
          125,
          2500,
          2500
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 139,
      "avatar": require('./images/avatars/139.png'),
      "name": "Omastar",
      "type": [
        "rock",
        "water"
      ],
      "classification": "Spiral Pokémon",
      "evolution": "Evolve Omanyte (Lv. 40)",
      "moves": [
        {
          "name": "Bubble",
          "type": "water",
          "attack": "68",
          "wait": "7",
          "description": "The user fires bubbles in three directions. Deals damage to enemies hit by the bubbles and sometimes lowers their movement speed.",
          "learnable": true
        },
        {
          "name": "Hydro Pump",
          "type": "water",
          "attack": "213",
          "wait": "5",
          "description": "The user shoots four pillars of water up from the ground and sends them out in front of itself. Deals damage to enemies hit by them.",
          "learnable": true
        },
        {
          "name": "Ice Beam",
          "type": "ice",
          "attack": "133",
          "wait": "7",
          "description": "The user fires an icy-cold beam at enemies in front of itself. Deals damage to enemies and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Rock Polish",
          "type": "rock",
          "attack": "0",
          "wait": "2",
          "description": "The user polishes its body to reduce drag, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Supersonic",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user generates odd sound waves from its body, often confusing surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Whirlpool",
          "type": "water",
          "attack": "94",
          "wait": "5",
          "description": "The user creates a whirlpool around itself. Deals damage to enemies around the user.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Taking Critical Hits Rate -20%",
          "Movement Speed +30%",
          "Water Type Moves Wait -5%"
        ],
        [
          "Water Type Moves Wait -10%",
          "Movement Speed +40%",
          "Taking Critical Hits Rate -30%"
        ],
        [
          "Taking Critical Hits Rate -50%",
          "ATK of Water Type Moves +15%",
          "Movement Speed +50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "575",
      "baseAtk": "225",
      "sprite": require('./images/sprites/139.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 140,
      "avatar": require('./images/avatars/140.png'),
      "name": "Kabuto",
      "type": [
        "rock",
        "water"
      ],
      "classification": "Shellfish Pokémon",
      "moves": [
        {
          "name": "Aqua Jet",
          "type": "water",
          "attack": "182",
          "wait": "5",
          "description": "The user charges at enemies in front of itself with tremendous speed, dealing damage to them.",
          "learnable": true
        },
        {
          "name": "Metal Sound",
          "type": "steel",
          "attack": "0",
          "wait": "3",
          "description": "Enemies near the user are forced to listen to a horrible sound like metal scraping, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Surf",
          "type": "water",
          "attack": "127",
          "wait": "5",
          "description": "The user creates a wide wave and charges forward on it. Deals damage to enemies caught in the wave.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Withdraw",
          "type": "water",
          "attack": "0",
          "wait": "5",
          "description": "The user withdraws into its hard shell, reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Movement Speed +30%",
          "Taking Critical Hits Rate -20%"
        ],
        [
          "ATK of Water Type Moves +20%",
          "Movement Speed +40%",
          "Taking Critical Hits Rate -30%"
        ],
        [
          "ATK +550",
          "Movement Speed +50%",
          "Taking Critical Hits Rate -50%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "70",
      "baseAtk": "130",
      "sprite": require('./images/sprites/140.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          125,
          2500,
          2500
        ],
        "type": [
          0,
          125,
          2500,
          2500
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 141,
      "avatar": require('./images/avatars/141.png'),
      "name": "Kabutops",
      "type": [
        "rock",
        "water"
      ],
      "classification": "Shellfish Pokémon",
      "evolution": "Evolve Kabuto (Lv. 40)",
      "moves": [
        {
          "name": "Aerial Ace",
          "type": "flying",
          "attack": "124",
          "wait": "5",
          "description": "The user quickly slashes in front of itself twice, dealing damage.",
          "learnable": true
        },
        {
          "name": "Night Slash",
          "type": "dark",
          "attack": "83",
          "wait": "5",
          "description": "The user dashes forward, slashing surrounding enemies and damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Waterfall",
          "type": "water",
          "attack": "252",
          "wait": "5",
          "description": "The user approaches enemies in front of itself and creates a pillar of water beneath them. This deals damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Withdraw",
          "type": "water",
          "attack": "0",
          "wait": "5",
          "description": "The user withdraws into its hard shell, reducing the amount of damage it takes for a while.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Water Type Moves +5%",
          "Movement Speed +30%",
          "Taking Critical Hits Rate -20%"
        ],
        [
          "ATK of Water Type Moves +15%",
          "Movement Speed +40%",
          "Taking Critical Hits Rate -30%"
        ],
        [
          "ATK of Water Type Moves +15%",
          "Movement Speed +50%",
          "Taking Critical Hits Rate -50%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "150",
      "baseAtk": "650",
      "sprite": require('./images/sprites/141.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 142,
      "avatar": require('./images/avatars/142.png'),
      "name": "Aerodactyl",
      "type": [
        "rock",
        "flying"
      ],
      "classification": "Fossil Pokémon",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Crunch",
          "type": "dark",
          "attack": "370",
          "wait": "5",
          "description": "The user takes aim and then bites on to enemies a short distance in front of itself, damaging them.",
          "learnable": true
        },
        {
          "name": "Dragon Claw",
          "type": "dragon",
          "attack": "296",
          "wait": "5",
          "description": "The user gathers its strength, then charges forward while spinning, damaging enemies with its sharp claws.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Fly",
          "type": "flying",
          "attack": "243",
          "wait": "5",
          "description": "The user flies toward enemies far in front of itself, then swoops down to deal damage to them.",
          "learnable": true
        },
        {
          "name": "Rock Tomb",
          "type": "rock",
          "attack": "212",
          "wait": "5",
          "description": "The user drops boulders directly in front of itself, damaging enemies hit by them and sometimes lowering their movement speed.",
          "learnable": true
        },
        {
          "name": "Roost",
          "type": "flying",
          "attack": "0",
          "wait": "9",
          "description": "The user briefly rests its body, restoring a bit of its HP.",
          "learnable": true
        },
        {
          "name": "Sandstorm",
          "type": "rock",
          "attack": "117",
          "wait": "5",
          "description": "The user creates a sandstorm around itself, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Sky Attack",
          "type": "flying",
          "attack": "125",
          "wait": "5",
          "description": "After flying up and bracing itself, the user charges at enemies directly in front of itself, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Normal Type Moves Wait -5%",
          "Movement Speed +30%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Flying Type Moves Wait -10%",
          "Movement Speed +40%",
          "Resistant to ↓ Effects +20%"
        ],
        [
          "Wait for Standard Attacks -50%",
          "Movement Speed +50%",
          "Resistant to status Conditions +30%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "125",
      "baseAtk": "675",
      "sprite": require('./images/sprites/142.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          25,
          500,
          500
        ],
        "type": [
          0,
          25,
          500,
          500
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 143,
      "avatar": require('./images/avatars/143.png'),
      "name": "Snorlax",
      "type": [
        "normal"
      ],
      "classification": "Sleeping Pokémon",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Belly Drum",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user uses its own HP to raise all of its stats for a while.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Harden",
          "type": "normal",
          "attack": "0",
          "wait": "5",
          "description": "The user stiffens all the muscles in its body, lowering the damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Mega Punch",
          "type": "normal",
          "attack": "561",
          "wait": "5",
          "description": "After approaching enemies in front of itself, the user slugs enemies directly in front of itself with a muscle-packed punch, damaging them.",
          "learnable": true
        },
        {
          "name": "Outrage",
          "type": "dragon",
          "attack": "104",
          "wait": "5",
          "description": "The user rampages about, attacking and damaging any enemies in its path. Sometimes confuses the user.",
          "learnable": true
        },
        {
          "name": "Rest",
          "type": "psychic",
          "attack": "0",
          "wait": "9",
          "description": "The user rests in place, greatly restoring its HP.",
          "learnable": true
        },
        {
          "name": "Rollout",
          "type": "rock",
          "attack": "130",
          "wait": "5",
          "description": "The user spins around, damaging surrounding enemies it smashes into.",
          "learnable": true
        },
        {
          "name": "Take Down",
          "type": "normal",
          "attack": "189",
          "wait": "5",
          "description": "The user slams into enemies in front of itself with a reckless, full-body charge, damaging all enemies hit by it. The user also takes recoil damage.",
          "learnable": true
        },
        {
          "name": "Giga Impact",
          "type": "normal",
          "attack": "176",
          "wait": "5",
          "description": "The user focuses every bit of its power and charges toward enemies in front of itself, dealing huge damage to them.",
          "learnable": false,
          "method": "Ultra Expedition Pack Only"
        },
        {
          "name": "Play Rough",
          "type": "fairy",
          "attack": "98",
          "wait": "5",
          "description": "The user plays rough with enemies in front of itself, damaging them. Sometimes lowers the damage enemies deal.",
          "learnable": false,
          "method": "Ultra Expedition Pack Only"
        }
      ],
      "bonus": [
        [
          "Resistant to Poisoned +100%",
          "Taking Critical Hits Rate -10%",
          "Resistant to ↓ Effects +10%"
        ],
        [
          "Healing per Wave +25%",
          "Ice Type Damage Taken -50%",
          "Fire Type Damage Taken -50%"
        ],
        [
          "ATK +550",
          "Own Knockback Distance -50%",
          "Natural HP Healing +5%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "650",
      "baseAtk": "150",
      "sprite": require('./images/sprites/143.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          45,
          900,
          900
        ],
        "type": [
          0,
          30,
          600,
          600
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 144,
      "avatar": require('./images/avatars/144.png'),
      "name": "Articuno",
      "type": [
        "ice",
        "flying"
      ],
      "classification": "Freeze Pokémon",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Aurora Veil",
          "type": "ice",
          "attack": "0",
          "wait": "7",
          "description": "The user cloaks itself in a veil of light, reducing the amount of damage it takes for a while.",
          "learnable": true
        },
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Hurricane",
          "type": "flying",
          "attack": "105",
          "wait": "5",
          "description": "The user whips up an intense wind around itself, damaging surrounding enemies and sometimes confusing them.",
          "learnable": true
        },
        {
          "name": "Icy Wind",
          "type": "ice",
          "attack": "126",
          "wait": "7",
          "description": "The user sends a freezing gust of chilled air at enemies in front of itself, damaging them. Sometimes lowers enemies' movement speed.",
          "learnable": true
        },
        {
          "name": "Roost",
          "type": "flying",
          "attack": "0",
          "wait": "9",
          "description": "The user briefly rests its body, restoring a bit of its HP.",
          "learnable": true
        },
        {
          "name": "Sky Attack",
          "type": "flying",
          "attack": "125",
          "wait": "5",
          "description": "After flying up and bracing itself, the user charges at enemies directly in front of itself, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Steel Wing",
          "type": "steel",
          "attack": "81",
          "wait": "5",
          "description": "The user charges at enemies in front of itself and smacks them with its hard wings, dealing damage. Sometimes reduces the amount of damage the user takes.",
          "learnable": true
        },
        {
          "name": "U-turn",
          "type": "bug",
          "attack": "243",
          "wait": "5",
          "description": "After attacking surrounding enemies, the user moves back to dodge enemies' counterattacks.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Ice Type Moves Wait -5%",
          "ATK of Ice Type Moves +5%",
          "Critical Hit Damage +10%"
        ],
        [
          "ATK of Ice Type Moves + 15%",
          "Ice Type Moves Wait -10%",
          "Resistant to Frozen +100%"
        ],
        [
          "ATK of Ice Type Moves +20%",
          "Ice Type Moves Wait -15%",
          "Crit Hit Damage +15%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "600",
      "baseAtk": "400",
      "sprite": require('./images/sprites/144.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          100,
          100,
          100,
          100
        ]
      }
    },
    {
      "id": 145,
      "avatar": require('./images/avatars/145.png'),
      "name": "Zapdos",
      "type": [
        "electric",
        "flying"
      ],
      "classification": "Electric Pokémon",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Charge",
          "type": "electric",
          "attack": "0",
          "wait": "9",
          "description": "The user stores up electricity, raising the damage it deals and making it resistant to negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Charge",
          "type": "electric",
          "attack": "0",
          "wait": "9",
          "description": "The user stores up electricity, raising the damage it deals and making it resistant to negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Drill Peck",
          "type": "flying",
          "attack": "321",
          "wait": "5",
          "description": "The user attacks enemies directly in front of itself with its sharp beak, damaging them.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Metal Sound",
          "type": "steel",
          "attack": "0",
          "wait": "3",
          "description": "Enemies near the user are forced to listen to a horrible sound like metal scraping, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Roost",
          "type": "flying",
          "attack": "0",
          "wait": "9",
          "description": "The user briefly rests its body, restoring a bit of its HP.",
          "learnable": true
        },
        {
          "name": "Sky Attack",
          "type": "flying",
          "attack": "125",
          "wait": "5",
          "description": "After flying up and bracing itself, the user charges at enemies directly in front of itself, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Thunder",
          "type": "electric",
          "attack": "204",
          "wait": "5",
          "description": "The user strikes the area in front of itself with a lightning bolt. Deals damage to nearby enemies. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Thunder Shock",
          "type": "electric",
          "attack": "173",
          "wait": "5",
          "description": "After storing up electricity, the user fires it toward enemies in front of itself, dealing damage to them. Sometimes paralyzes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Electric Type Moves Wait -5%",
          "ATK of Electric Type Moves +5%",
          "Wait for Standard Attacks -20%"
        ],
        [
          "ATK of Electric Type Moves +15%",
          "Electric Type Moves Wait -10%",
          "Resistant to Paralyzed +100%"
        ],
        [
          "ATK of Electric Type Moves +20%",
          "Electric Type Moves Wait -15%",
          "Wait for Standard Attacks -30%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "350",
      "baseAtk": "650",
      "sprite": require('./images/sprites/145.png'),
      "color": "Yellow",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          100,
          100,
          100,
          100
        ]
      }
    },
    {
      "id": 146,
      "avatar": require('./images/avatars/146.png'),
      "name": "Moltres",
      "type": [
        "fire",
        "flying"
      ],
      "classification": "Flame Pokémon",
      "moves": [
        {
          "name": "Ember",
          "type": "fire",
          "attack": "109",
          "wait": "7",
          "description": "The user fires sparks in front of itself that split and run in three directions when they hit the ground. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Fire Blast",
          "type": "fire",
          "attack": "179",
          "wait": "5",
          "description": "The user sprays an all-consuming fire on the ground, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Fire Spin",
          "type": "fire",
          "attack": "97",
          "wait": "5",
          "description": "The user creates flames all around itself and fires them off in a spiral. Deals damage to enemies they hit. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Flamethrower",
          "type": "fire",
          "attack": "94",
          "wait": "5",
          "description": "The user continuously breathes out long flames for a while. Deals damage to enemies as long as they remain in the flames. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Heat Wave",
          "type": "fire",
          "attack": "123",
          "wait": "7",
          "description": "The user exhales hot breath in front of itself, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Lava Plume",
          "type": "fire",
          "attack": "132",
          "wait": "5",
          "description": "The user spouts scarlet flames all around itself. Deals damage to enemies around it. Sometimes burns enemies.",
          "learnable": true
        },
        {
          "name": "Leer",
          "type": "normal",
          "attack": "0",
          "wait": "3",
          "description": "The user glares at nearby enemies to intimidate them, often raising the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Roost",
          "type": "flying",
          "attack": "0",
          "wait": "9",
          "description": "The user briefly rests its body, restoring a bit of its HP.",
          "learnable": true
        },
        {
          "name": "Sky Attack",
          "type": "flying",
          "attack": "125",
          "wait": "5",
          "description": "After flying up and bracing itself, the user charges at enemies directly in front of itself, damaging them. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Will-O-Wisp",
          "type": "fire",
          "attack": "19",
          "wait": "3",
          "description": "The user drapes itself with sinister flames and attacks enemies directly in front of it. Often burns enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Fire Type Moves Wait -5%",
          "ATK of Fire Type Moves +5%",
          "Critical Hit Rate +10%"
        ],
        [
          "ATK of Fire Type Moves +15%",
          "Fire Type Moves Wait -10%",
          "Resistant to Burned +100%"
        ],
        [
          "ATK of Fire Type Moves +20%",
          "Fire Type Moves Wait -15%",
          "Critical Hit Rate +15%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "500",
      "baseAtk": "500",
      "sprite": require('./images/sprites/146.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          100,
          100,
          100,
          100
        ]
      }
    },
    {
      "id": 147,
      "avatar": require('./images/avatars/147.png'),
      "name": "Dratini",
      "type": [
        "dragon"
      ],
      "classification": "Dragon Pokémon",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Dragon Dance",
          "type": "dragon",
          "attack": "0",
          "wait": "8",
          "description": "The user vigorously performs a mystic, powerful dance that raises the amount of damage it deals and its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Dragon Dance",
          "type": "dragon",
          "attack": "0",
          "wait": "8",
          "description": "The user vigorously performs a mystic, powerful dance that raises the amount of damage it deals and its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Dragon Pulse",
          "type": "dragon",
          "attack": "188",
          "wait": "7",
          "description": "The user sends a shock wave flying from its mouth, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Dragon Rush",
          "type": "dragon",
          "attack": "141",
          "wait": "5",
          "description": "The user flies into enemies a short distance from itself with great intensity, damaging them.",
          "learnable": true
        },
        {
          "name": "Extreme Speed",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user charges into enemies in front of itself with blinding speed, damaging them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Dragon Type Moves +5%",
          "Dragon Type Moves Wait -5%",
          "Own Knockback Distance -10%"
        ],
        [
          "HP upon Recovery +20%",
          "Resistant to Status Conditions +30%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK +450",
          "Dragon Type Moves Wait -20%",
          "HP +500"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "80",
      "baseAtk": "120",
      "sprite": require('./images/sprites/147.png'),
      "color": "Blue",
      "dishWeight": {
        "mulligan": [
          0,
          500,
          10000,
          10000
        ],
        "color": [
          0,
          30,
          600,
          600
        ],
        "type": [
          0,
          500,
          10000,
          10000
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 148,
      "avatar": require('./images/avatars/148.png'),
      "name": "Dragonair",
      "type": [
        "dragon"
      ],
      "classification": "Dragon Pokémon",
      "evolution": "Evolve Dratini (Lv. 30)",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Dragon Dance",
          "type": "dragon",
          "attack": "0",
          "wait": "8",
          "description": "The user vigorously performs a mystic, powerful dance that raises the amount of damage it deals and its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Dragon Pulse",
          "type": "dragon",
          "attack": "188",
          "wait": "7",
          "description": "The user sends a shock wave flying from its mouth, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Dragon Rush",
          "type": "dragon",
          "attack": "141",
          "wait": "5",
          "description": "The user flies into enemies a short distance from itself with great intensity, damaging them.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Extreme Speed",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user charges into enemies in front of itself with blinding speed, damaging them.",
          "learnable": true
        },
        {
          "name": "Twister",
          "type": "dragon",
          "attack": "115",
          "wait": "7",
          "description": "The user whips up several tornadoes and sends them out in front of itself, damaging enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Dragon Type Moves +5%",
          "Dragon Type Moves Wait -5%",
          "Own Knockback Distance -10%"
        ],
        [
          "HP upon Recovery +15%",
          "Resistant to Status Conditions +20%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Dragon Type Moves +25%",
          "Dragon Type Moves Wait -15%",
          "Natural HP Healing +10%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "300",
      "baseAtk": "400",
      "sprite": require('./images/sprites/148.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 149,
      "avatar": require('./images/avatars/149.png'),
      "name": "Dragonite",
      "type": [
        "dragon",
        "flying"
      ],
      "classification": "Dragon Pokémon",
      "evolution": "Evolve Dragonair (Lv. 55)",
      "moves": [
        {
          "name": "Agility",
          "type": "psychic",
          "attack": "0",
          "wait": "2",
          "description": "The user relaxes and lightens its body, raising its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Draco Meteor",
          "type": "dragon",
          "attack": "377",
          "wait": "5",
          "description": "The user summons several meteors down around itself, damaging enemies hit by them. Sometimes reduces the amount of damage the user deals.",
          "learnable": true
        },
        {
          "name": "Dragon Dance",
          "type": "dragon",
          "attack": "0",
          "wait": "8",
          "description": "The user vigorously performs a mystic, powerful dance that raises the amount of damage it deals and its movement speed for a while.",
          "learnable": true
        },
        {
          "name": "Dragon Pulse",
          "type": "dragon",
          "attack": "188",
          "wait": "7",
          "description": "The user sends a shock wave flying from its mouth, damaging enemies hit by it.",
          "learnable": true
        },
        {
          "name": "Dragon Rush",
          "type": "dragon",
          "attack": "141",
          "wait": "5",
          "description": "The user flies into enemies a short distance from itself with great intensity, damaging them.",
          "learnable": true
        },
        {
          "name": "Earthquake",
          "type": "ground",
          "attack": "390",
          "wait": "5",
          "description": "The user causes an earthquake that damages surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Extreme Speed",
          "type": "normal",
          "attack": "130",
          "wait": "5",
          "description": "The user charges into enemies in front of itself with blinding speed, damaging them.",
          "learnable": true
        },
        {
          "name": "Hyper Beam",
          "type": "normal",
          "attack": "300",
          "wait": "10",
          "description": "The user stores up power and then fires a tremendous beam at enemies. Deals severe damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Outrage",
          "type": "dragon",
          "attack": "104",
          "wait": "5",
          "description": "The user rampages about, attacking and damaging any enemies in its path. Sometimes confuses the user.",
          "learnable": true
        },
        {
          "name": "Twister",
          "type": "dragon",
          "attack": "115",
          "wait": "7",
          "description": "The user whips up several tornadoes and sends them out in front of itself, damaging enemies hit by them.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "ATK of Dragon Type Moves +5%",
          "Dragon Type Moves Wait -5%",
          "Own Knockback Distance -10%"
        ],
        [
          "HP upon Recovery +10%",
          "Resistant to ↓ Effects +20%",
          "Own Knockback Distance -20%"
        ],
        [
          "ATK of Dragon Type Moves +20%",
          "Dragon Type Moves Wait -10%",
          "ATK of Normal Type Moves +20%"
        ]
      ],
      "automaticStyle": "Melee",
      "baseHp": "400",
      "baseAtk": "500",
      "sprite": require('./images/sprites/149.png'),
      "color": "unknown",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          0
        ]
      }
    },
    {
      "id": 150,
      "avatar": require('./images/avatars/150.png'),
      "name": "Mewtwo",
      "type": [
        "psychic"
      ],
      "classification": "Genetic Pokémon",
      "moves": [
        {
          "name": "Blizzard",
          "type": "ice",
          "attack": "52",
          "wait": "5",
          "description": "The user moves about while creating a blizzard centered on itself. Deals damage to enemies around the user and sometimes freezes them.",
          "learnable": true
        },
        {
          "name": "Bulk Up",
          "type": "fighting",
          "attack": "0",
          "wait": "8",
          "description": "The user tenses its muscles to bulk up its body, raising the damage it deals for a while. This also reduces the damage the user takes.",
          "learnable": true
        },
        {
          "name": "Giga Impact",
          "type": "normal",
          "attack": "176",
          "wait": "5",
          "description": "The user focuses every bit of its power and charges toward enemies in front of itself, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Hyper Beam",
          "type": "normal",
          "attack": "300",
          "wait": "10",
          "description": "The user stores up power and then fires a tremendous beam at enemies. Deals severe damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Psycho Cut",
          "type": "psychic",
          "attack": "311",
          "wait": "5",
          "description": "After moving forward, the user deals damage to enemies with blades formed by psychic power. Critical hits land more easily.",
          "learnable": true
        },
        {
          "name": "Psystrike",
          "type": "psychic",
          "attack": "129",
          "wait": "5",
          "description": "The user creates a large orb of light in front of itself. The orb then splits into many smaller ones that fly out in all directions, dealing damage to surrounding enemies.",
          "learnable": true
        },
        {
          "name": "Recover",
          "type": "normal",
          "attack": "0",
          "wait": "9",
          "description": "Restoring its own cells, the user restores its HP.",
          "learnable": true
        },
        {
          "name": "Shadow Ball",
          "type": "ghost",
          "attack": "63",
          "wait": "7",
          "description": "The user hurls a shadowy blob in front of itself, damaging enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Thunderbolt",
          "type": "electric",
          "attack": "80",
          "wait": "5",
          "description": "The user discharges tremendous electricity all around itself. Deals damage to enemies around the user. Sometimes paralyzes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Movement Speed +50%",
          "Resistant to ↓ Effects +20%",
          "Critical Hit Damage +20%"
        ],
        [
          "Psychic Type Moves Wait -20%",
          "Critical Hit Rate +20%",
          "Normal Type  Moves Wait  -20%"
        ],
        [
          "ATK of Psychic Type Moves +20%",
          "ATK of Normal Type Moves +20%",
          "Wait for Standard Attacks -50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "550",
      "baseAtk": "750",
      "sprite": require('./images/sprites/150.png'),
      "color": "Gray",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          300
        ]
      }
    },
    {
      "id": 151,
      "avatar": require('./images/avatars/151.png'),
      "name": "Mew",
      "type": [
        "psychic"
      ],
      "classification": "New Species Pokémon",
      "moves": [
        {
          "name": "Amnesia",
          "type": "psychic",
          "attack": "0",
          "wait": "8",
          "description": "The user temporarily empties its mind to forget its concerns, raising the amount of damage it deals and making it more resistant to negative effects.",
          "learnable": true
        },
        {
          "name": "Flash Cannon",
          "type": "steel",
          "attack": "170",
          "wait": "7",
          "description": "The user focuses all of its light energy into a single point and fires a beam in front of itself, sometimes raising the amount of damage enemies take.",
          "learnable": true
        },
        {
          "name": "Giga Impact",
          "type": "normal",
          "attack": "176",
          "wait": "5",
          "description": "The user focuses every bit of its power and charges toward enemies in front of itself, dealing huge damage to them.",
          "learnable": true
        },
        {
          "name": "Heat Wave",
          "type": "fire",
          "attack": "123",
          "wait": "7",
          "description": "The user exhales hot breath in front of itself, damaging enemies hit by it and sometimes burning them.",
          "learnable": true
        },
        {
          "name": "Hyper Beam",
          "type": "normal",
          "attack": "300",
          "wait": "10",
          "description": "The user stores up power and then fires a tremendous beam at enemies. Deals severe damage to enemies it hits.",
          "learnable": true
        },
        {
          "name": "Light Screen",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user creates a wall of light, making it harder for it to be affected by negative effects for a while.",
          "learnable": true
        },
        {
          "name": "Psychic",
          "type": "psychic",
          "attack": "121",
          "wait": "7",
          "description": "The user creates a large, mysterious light and fires it out, dealing damage to enemies hit by it. Sometimes raises the amount of damage they take.",
          "learnable": true
        },
        {
          "name": "Recover",
          "type": "normal",
          "attack": "0",
          "wait": "9",
          "description": "Restoring its own cells, the user restores its HP.",
          "learnable": true
        },
        {
          "name": "Teleport",
          "type": "psychic",
          "attack": "0",
          "wait": "3",
          "description": "The user utilizes its psychic powers to teleport.",
          "learnable": true
        },
        {
          "name": "Thunder",
          "type": "electric",
          "attack": "204",
          "wait": "5",
          "description": "The user strikes the area in front of itself with a lightning bolt. Deals damage to nearby enemies. Sometimes paralyzes enemies.",
          "learnable": true
        },
        {
          "name": "Transform",
          "type": "normal",
          "attack": "0",
          "wait": "0",
          "description": "When Ditto transforms into another Pokémon, this changes into a move that Pokémon can learn.",
          "learnable": true
        },
        {
          "name": "Tri Attack",
          "type": "normal",
          "attack": "81",
          "wait": "5",
          "description": "The user's body is imbued with three powers as it attacks enemies in front of itself, damaging them. Sometimes burns, paralyzes, or freezes enemies.",
          "learnable": true
        }
      ],
      "bonus": [
        [
          "Critical Hit Damage +20%",
          "Resistant to ↓ Effects +20%",
          "Movement Speed +50%"
        ],
        [
          "Critical Hit Rate +20%",
          "Resistant to Status Conditions +20%",
          "Time to Recover -20%"
        ],
        [
          "Psychic Type Moves Wait -20%",
          "Own Knockback Distance -20%",
          "Wait for Standard Attacks -50%"
        ]
      ],
      "automaticStyle": "Range",
      "baseHp": "650",
      "baseAtk": "650",
      "sprite": require('./images/sprites/151.png'),
      "color": "Red",
      "dishWeight": {
        "mulligan": [
          0,
          0,
          0,
          0
        ],
        "color": [
          0,
          0,
          0,
          0
        ],
        "type": [
          0,
          0,
          0,
          0
        ],
        "legendary": [
          0,
          0,
          0,
          30
        ]
      }
    }
  ],
  "dishes": [
    {
      "id": 1,
      "name": "Mulligan Stew a la Cube",
      "description": "Favorite food of some Pokémon on Tumblecube Island",
      "ingredients": "Whatever ingredients you like",
      "pokemonFilter": {
        "color": "",
        "type": "",
        "legendary": false
      },
      "ingredientRules": [],
      "logo": require('./images/dishes/1.png')
    },
    {
      "id": 2,
      "name": "Red Stew a la Cube",
      "description": "Favorite food of reddish Pokémon",
      "ingredients": "A whole lot of red",
      "pokemonFilter": {
        "color": "red",
        "type": "",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "red",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/2.png')
    },
    {
      "id": 3,
      "name": "Blue Soda a la Cube",
      "description": "Favorite food of bluish Pokémon",
      "ingredients": "A whole lot of blue",
      "pokemonFilter": {
        "color": "blue",
        "type": "",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "blue",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/3.png')
    },
    {
      "id": 4,
      "name": "Yellow Curry a la Cube",
      "description": "Favorite food of yellowish Pokémon",
      "ingredients": "A whole lot of yellow",
      "pokemonFilter": {
        "color": "yellow",
        "type": "",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "yellow",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/4.png')
    },
    {
      "id": 5,
      "name": "Gray Porridge a la Cube",
      "description": "Favorite food of grayish Pokémon",
      "ingredients": "A whole lot of gray",
      "pokemonFilter": {
        "color": "gray",
        "type": "",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "gray",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/5.png')
    },
    {
      "id": 6,
      "name": "Mouth-Watering Dip a la Cube",
      "description": "Favorite food of Water-type Pokémon",
      "ingredients": "A whole lot of soft things and a lot of blue",
      "pokemonFilter": {
        "color": "",
        "type": "water",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "blue",
          "minimum": 3
        },
        {
          "attribute": "soft",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/6.png')
    },
    {
      "id": 7,
      "name": "Plain Crepe a la Cube",
      "description": "Favorite food of Normal-type Pokémon",
      "ingredients": "A lot of sweet things and a few gray",
      "pokemonFilter": {
        "color": "",
        "type": "normal",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "gray",
          "minimum": 2
        },
        {
          "attribute": "sweet",
          "minimum": 3
        }
      ],
      "logo": require('./images/dishes/7.png')
    },
    {
      "id": 8,
      "name": "Sludge Soup a la Cube",
      "description": "Favorite food of Poison-type Pokémon",
      "ingredients": "A whole lot of mushrooms and a lot of soft things",
      "pokemonFilter": {
        "color": "",
        "type": "poison",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "soft",
          "minimum": 3
        },
        {
          "attribute": "mushroom",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/8.png')
    },
    {
      "id": 9,
      "name": "Mud Pie a la Cube",
      "description": "Favorite food of Ground-type Pokémon",
      "ingredients": "A few minerals and a lot of soft things",
      "pokemonFilter": {
        "color": "",
        "type": "ground",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "soft",
          "minimum": 3
        },
        {
          "attribute": "mineral",
          "minimum": 2
        }
      ],
      "logo": require('./images/dishes/9.png')
    },
    {
      "id": 10,
      "name": "Veggie Smoothie a la Cube",
      "description": "Favorite food of Grass-type Pokémon",
      "ingredients": "A whole lot of plants and a few soft things",
      "pokemonFilter": {
        "color": "",
        "type": "grass",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "soft",
          "minimum": 2
        },
        {
          "attribute": "plant",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/10.png')
    },
    {
      "id": 11,
      "name": "Honey Nectar a la Cube",
      "description": "Favorite food of Bug-type Pokémon",
      "ingredients": "A whole lot of sweet things and a lot of yellow",
      "pokemonFilter": {
        "color": "",
        "type": "bug",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "yellow",
          "minimum": 3
        },
        {
          "attribute": "sweet",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/11.png')
    },
    {
      "id": 12,
      "name": "Brain Food a la Cube",
      "description": "Favorite food of Psychic-type Pokémon",
      "ingredients": "A lot of sweet things and a few hard things",
      "pokemonFilter": {
        "color": "",
        "type": "psychic",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "hard",
          "minimum": 2
        },
        {
          "attribute": "sweet",
          "minimum": 3
        }
      ],
      "logo": require('./images/dishes/12.png')
    },
    {
      "id": 13,
      "name": "Stone Soup a la Cube",
      "description": "Favorite food of Rock-type Pokémon",
      "ingredients": "A whole lot of hard things and a few minerals",
      "pokemonFilter": {
        "color": "",
        "type": "rock",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "hard",
          "minimum": 4
        },
        {
          "attribute": "mineral",
          "minimum": 2
        }
      ],
      "logo": require('./images/dishes/13.png')
    },
    {
      "id": 14,
      "name": "Light-as-Air Casserole a la Cube",
      "description": "Favorite food of Flying-type Pokémon",
      "ingredients": "A lot of minerals and a few plants",
      "pokemonFilter": {
        "color": "",
        "type": "flying",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "plant",
          "minimum": 2
        },
        {
          "attribute": "mineral",
          "minimum": 3
        }
      ],
      "logo": require('./images/dishes/14.png')
    },
    {
      "id": 15,
      "name": "Hot Pot a la Cube",
      "description": "Favorite food of Fire-type Pokémon",
      "ingredients": "A lot of mushrooms and a little red",
      "pokemonFilter": {
        "color": "",
        "type": "fire",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "red",
          "minimum": 2
        },
        {
          "attribute": "mushroom",
          "minimum": 3
        }
      ],
      "logo": require('./images/dishes/15.png')
    },
    {
      "id": 16,
      "name": "Watt a Risotta a la Cube",
      "description": "Favorite food of Electric-type Pokémon",
      "ingredients": "A whole lot of soft things and a lot of yellow",
      "pokemonFilter": {
        "color": "",
        "type": "electric",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "yellow",
          "minimum": 3
        },
        {
          "attribute": "soft",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/16.png')
    },
    {
      "id": 17,
      "name": "Get Swole Syrup a la Cube",
      "description": "Favorite food of Fighting-type Pokémon",
      "ingredients": "A lot of sweet things and a few mushrooms",
      "pokemonFilter": {
        "color": "",
        "type": "fighting",
        "legendary": false
      },
      "ingredientRules": [
        {
          "attribute": "mushroom",
          "minimum": 2
        },
        {
          "attribute": "sweet",
          "minimum": 3
        }
      ],
      "logo": require('./images/dishes/17.png')
    },
    {
      "id": 18,
      "name": "Ambrosia of Legends a la Cube",
      "description": "Favorite food of extremely rare Pokémon",
      "ingredients": "A whole lot of mystical things",
      "pokemonFilter": {
        "color": "",
        "type": "",
        "legendary": true
      },
      "ingredientRules": [
        {
          "attribute": "mystical",
          "minimum": 4
        }
      ],
      "logo": require('./images/dishes/18.png')
    }
  ],
  "ingredients": [
    {
      "id": 1,
      "name": "Tiny mushrooms",
      "color": "red",
      "hardness": "soft",
      "matterial": "mushroom",
      "quality": 1,
      "logo": require('./images/ingredients/1.png')
    },
    {
      "id": 2,
      "name": "Bluk Berries",
      "color": "blue",
      "hardness": "soft",
      "matterial": "sweet",
      "quality": 1,
      "logo": require('./images/ingredients/2.png')
    },
    {
      "id": 3,
      "name": "Apricorns",
      "color": "yellow",
      "hardness": "hard",
      "matterial": "plant",
      "quality": 1,
      "logo": require('./images/ingredients/3.png')
    },
    {
      "id": 4,
      "name": "Fossils",
      "color": "gray",
      "hardness": "hard",
      "matterial": "mineral",
      "quality": 1,
      "logo": require('./images/ingredients/4.png')
    },
    {
      "id": 5,
      "name": "Big roots",
      "color": "red",
      "hardness": "soft",
      "matterial": "plant",
      "quality": 2,
      "logo": require('./images/ingredients/5.png')
    },
    {
      "id": 6,
      "name": "Icy rocks",
      "color": "blue",
      "hardness": "hard",
      "matterial": "mineral",
      "quality": 2,
      "logo": require('./images/ingredients/6.png')
    },
    {
      "id": 7,
      "name": "Honey",
      "color": "yellow",
      "hardness": "soft",
      "matterial": "sweet",
      "quality": 2,
      "logo": require('./images/ingredients/7.png')
    },
    {
      "id": 8,
      "name": "Balm mushrooms",
      "color": "gray",
      "hardness": "soft",
      "matterial": "mushroom",
      "quality": 2,
      "logo": require('./images/ingredients/8.png')
    },
    {
      "id": 9,
      "name": "Rainbow Matter",
      "color": "",
      "hardness": "",
      "matterial": "",
      "quality": 3,
      "logo": require('./images/ingredients/9.png')
    },
    {
      "id": 10,
      "name": "Mystical Shell",
      "color": "",
      "hardness": "",
      "matterial": "mystical",
      "quality": 2,
      "logo": require('./images/ingredients/10.png')
    }
  ],
  "pots": [
    {
      "id": 1,
      "name": "brass",
      "statBonus": 0,
      "ivRange": {
        "minimum": 0,
        "maximum": 10
      },
      "cookTurns": {
        "normal": 2,
        "good": 4,
        "veryGood": 5,
        "special": 6
      }
    },
    {
      "id": 2,
      "name": "bronze",
      "statBonus": 50,
      "ivRange": {
        "minimum": 0,
        "maximum": 50
      },
      "cookTurns": {
        "normal": 2,
        "good": 4,
        "veryGood": 5,
        "special": 6
      }
    },
    {
      "id": 3,
      "name": "silver",
      "statBonus": 100,
      "ivRange": {
        "minimum": 0,
        "maximum": 100
      },
      "cookTurns": {
        "normal": 3,
        "good": 5,
        "veryGood": 6,
        "special": 7
      }
    },
    {
      "id": 4,
      "name": "gold",
      "statBonus": 300,
      "ivRange": {
        "minimum": 0,
        "maximum": 100
      },
      "cookTurns": {
        "normal": 4,
        "good": 6,
        "veryGood": 7,
        "special": 8
      }
    }
  ]
}